//  * @package         src/components/Preview
//  * @author          Parimal A Ghadiyali
//  * @date            02nd October 2018
//  * @type            Preview middle Content Component File
//  * @description -   This file renders the html and functionality for center component when questions tab is choosed.
<template>
  <!-- One at a time question -->
  <div class="content" v-if="surveyMasterDetails.in_question_flow == 0">
    <v-wait for="adding response">
      <template slot="waiting">
        <div id="designLoadingdiv" class="loadingDiv_analytics">
          <!-- <img class="designAjaxLoader" src="../../assets/images/loader.gif" /> -->
          <div class="loader"></div>
        </div>
      </template>
    </v-wait>
    <form name="frmOneAtATimeFrm" @submit.prevent novalidate autocomplete="off">
      <div class="service-provide-info">
        <div v-for="(controlData, key, index) in surveyQuestionDetailsData[quesNo]">
          <!-- START text question type -->
          <div
            class="persnol-info-main qus_ans_sec"
            v-if="controlData.in_question_type_id == vueQueTypeConfig.TYPE_INPUT"
          >
            <label class="persnol-info-title">
              <span
                class="error"
              >{{controlData.validationDetailsObj[1] ? '*' : ''}}</span>{{controlData.in_question_order + '.'}}
              {{controlData.st_question_title}}
              <a
                @click.prevent
                data-toggle="tooltip"
                data-placement="top"
                v-if="controlData.validationDetailsObj[9] && controlData.st_question_hint != null"
              >
                <i class="fa fa-info-circle" v-tooltip.right="controlData.st_question_hint"></i>
              </a>
            </label>
            <!-- Paragraph -->
            <div class="group" v-if="controlData.validationDetailsObj[8]">
              <div class="text-wrap-new">
                <div class="form-group" v-if="controlData.validationDetailsObj[49]">
                  <input
                    type="hidden"
                    :key="'map'+controlData.in_question_master_id"
                    :name="'map_'+controlData.in_question_master_id"
                    v-model="previewSurveyData.chkSurveyQuestionDetails[''+controlData.in_question_master_id]"
                    v-validate="{required: controlData.validationDetailsObj[1] ? true : false}"
                    data-vv-as="above"
                  />
                  <mapbox-autocomplete
                    :id="'map_'+controlData.in_question_master_id"
                    :ref="'map_'+controlData.in_question_master_id"
                    placeholder="Enter a location"
                    v-on="{placechanged: (addressData, placeResultData, id) => getAddressData(controlData.validationDetailsObj[1], addressData, placeResultData, id, controlData.in_question_master_id), error: handleError, inputChange: (inputValue, id) => onMapInputChange(inputValue, id, controlData.in_question_master_id)}"
                  ></mapbox-autocomplete>
                  <span
                    v-show="errors.has('map_'+controlData.in_question_master_id)"
                    class="error"
                  >{{ errors.first('map_'+controlData.in_question_master_id) }}</span>
                </div>
                <div class="form-group" v-else>
                  <textarea
                    class="form-control"
                    rows="5"
                    placeholder="Answer here"
                    :key="'text'+controlData.in_question_master_id"
                    :name="'txt_'+controlData.in_question_master_id"
                    v-model="previewSurveyData.chkSurveyQuestionDetails[''+controlData.in_question_master_id]"
                    v-validate="{required: controlData.validationDetailsObj[1] ? true : false, min: controlData.validationDetailsObj[2] ? controlData.validationDetailsObj[2] : '', custom_max: controlData.validationDetailsObj[3] ? (controlData.validationDetailsObj[3],controlData.st_question_hint) : ''}"
                    data-vv-as="above"
                    @input="controlData.validationDetailsObj[1] ? checkInput(controlData.in_question_master_id, $event) : ''"
                  ></textarea>
                  <span
                    v-show="errors.has('txt_'+controlData.in_question_master_id)"
                    class="error"
                  >{{ errors.first('txt_'+controlData.in_question_master_id) }}</span>
                </div>
              </div>
            </div>
            <!-- Serial Number -->
            <div class="group" v-else-if="controlData.validationDetailsObj[9]">
              <input
                type="text"
                placeholder="Answer here"
                :key="'text'+controlData.in_question_master_id"
                :name="'txt_'+controlData.in_question_master_id"
                v-model="previewSurveyData.chkSurveyQuestionDetails[''+controlData.in_question_master_id]"
                v-validate="{required: controlData.validationDetailsObj[1] ? true : false, min: controlData.validationDetailsObj[2] ? controlData.validationDetailsObj[2] : '', custom_max: controlData.validationDetailsObj[3] ? controlData.validationDetailsObj[3] : '', custom_regex: controlData.validationDetailsObj[10] ? ([controlData.validationDetailsObj[10]['source'],controlData.st_question_hint]) : ''}"
                data-vv-as="above"
                @input="controlData.validationDetailsObj[1] ? checkInput(controlData.in_question_master_id, $event) : ''"
              />
              <!-- <span class="bar"></span> -->
              <span
                v-show="errors.has('txt_'+controlData.in_question_master_id)"
                class="error"
              >{{ errors.first('txt_'+controlData.in_question_master_id) }}</span>
            </div>
            <!-- Single Line -->
            <div class="group" v-else-if="controlData.validationDetailsObj[6]">
              <div v-if="controlData.validationDetailsObj[49]">
                <input
                  type="hidden"
                  :key="'map'+controlData.in_question_master_id"
                  :name="'map_'+controlData.in_question_master_id"
                  v-model="previewSurveyData.chkSurveyQuestionDetails[''+controlData.in_question_master_id]"
                  v-validate="{required: controlData.validationDetailsObj[1] ? true : false}"
                  data-vv-as="above"
                />
                <mapbox-autocomplete
                  :id="'map_'+controlData.in_question_master_id"
                  :ref="'map_'+controlData.in_question_master_id"
                  placeholder="Enter a location"
                  v-on="{placechanged: (addressData, placeResultData, id) => getAddressData(controlData.validationDetailsObj[1], addressData, placeResultData, id, controlData.in_question_master_id), error: handleError, inputChange: (inputValue, id) => onMapInputChange(inputValue, id, controlData.in_question_master_id)}"
                ></mapbox-autocomplete>
                <span
                  v-show="errors.has('map_'+controlData.in_question_master_id)"
                  class="error"
                >{{ errors.first('map_'+controlData.in_question_master_id) }}</span>
              </div>
              <div v-else>
                <input
                  type="text"
                  placeholder="Answer here"
                  :key="'text'+controlData.in_question_master_id"
                  :name="'txt_'+controlData.in_question_master_id"
                  v-model="previewSurveyData.chkSurveyQuestionDetails[''+controlData.in_question_master_id]"
                  v-validate="{required: controlData.validationDetailsObj[1] ? true : false, min: controlData.validationDetailsObj[2] ? controlData.validationDetailsObj[2] : '', custom_max: controlData.validationDetailsObj[3] ? controlData.validationDetailsObj[3] : ''}"
                  data-vv-as="above"
                  @input="controlData.validationDetailsObj[1] ? checkInput(controlData.in_question_master_id, $event) : ''"
                />
                <!-- <span class="highlight"></span> -->
                <!-- <span class="bar"></span> -->
                <!-- <label>{{controlData.st_question_title}}</label> -->
                <span
                  v-show="errors.has('txt_'+controlData.in_question_master_id)"
                  class="error"
                >{{ errors.first('txt_'+controlData.in_question_master_id) }}</span>
              </div>
            </div>
          </div>
          <div
            class="persnol-info-main qus_ans_sec"
            v-if="controlData.in_question_type_id == vueQueTypeConfig.TYPE_DISPLAY"
          >
            <blockquote class="ludwig">
              <div class="mb-10">
                <label class="persnol-info-title set-margin-zero">{{controlData.st_question_title}}</label>
                <!-- Display Text (Subtitle) -->
                </div>
            </blockquote>
            <blockquote class="ludwig-subtitle" v-if="controlData.validationDetailsObj[11] ? previewSurveyData.chkSurveyQuestionDetails[''+controlData.in_question_master_id] = controlData.validationDetailsObj[11] : ''">
              <div class="mb-10">
                <p
                >{{controlData.validationDetailsObj[11]}}</p>
              </div>
            </blockquote>
          </div>
          <!-- END for text question type -->
          <!-- ********************* -->
          <!-- START for List question type -->
          <div class="qus_ans_sec" v-if="controlData.in_question_type_id == vueQueTypeConfig.TYPE_LIST || controlData.in_question_type_id == vueQueTypeConfig.TYPE_DYNAMIC_LIST">
            <label class="persnol-info-title">
              <span
                class="error"
              >{{controlData.validationDetailsObj[1] ? '*' : ''}}</span>{{controlData.in_question_order + '.'}}
              {{controlData.st_question_title}}
            </label>
            <multi-select
              :key="'multiselect_'+controlData.in_question_master_id"
              :name="'multiselect_'+controlData.in_question_master_id"
              v-model="previewSurveyData.chkSurveyQuestionDetails[''+controlData.in_question_master_id]"
              tag-placeholder="Add this as new option"
              placeholder="Answer here"
              deselect-label="Can't remove this value"
              :options="emojiSplitJoin(controlData.validationDetailsObj[6], '\n', controlData.validationDetailsObj['extra']['lat'], controlData.validationDetailsObj['extra']['lng'], controlData.validationDetailsObj['extra']['score'], controlData.in_question_type_id)"
              v-validate="{required: controlData.validationDetailsObj[1] ? true : false}"
              data-vv-as="above"
              v-on="{input: (selectedOption, id) => checkMultipleChoice(selectedOption, id, controlData.in_question_master_id, quesNo, controlData.validationDetailsObj[1])}"
              track-by="formatted_address"
              label="formatted_address"
              :allow-empty="false"
            ></multi-select>
            <span
              v-show="errors.has('multiselect_'+controlData.in_question_master_id)"
              class="error"
            >{{ errors.first('multiselect_'+controlData.in_question_master_id) }}</span>
            <div class="persnol-info-main" v-if="controlData.other">
              <div class="group list-qus-sec" v-if="controlData.validationDetailsObj[49]">
                <input
                  type="hidden"
                  :key="'map'+controlData.in_question_master_id"
                  :name="'map_'+controlData.in_question_master_id"
                  v-model="previewSurveyData['chkOtherMulChoice'][''+controlData.in_question_master_id]"
                  v-validate="{required: controlData.validationDetailsObj[1] ? true : false}"
                  data-vv-as="above"
                />
                <mapbox-autocomplete
                  :id="'map_'+controlData.in_question_master_id"
                  :ref="'map_'+controlData.in_question_master_id"
                  placeholder="Enter a location"
                  v-on="{placechanged: (addressData, placeResultData, id) => getAddressData(controlData.validationDetailsObj[1], addressData, placeResultData, id, controlData.in_question_master_id, controlData.in_question_type_id), error: handleError, inputChange: (inputValue, id) => onMapInputChange(inputValue, id, controlData.in_question_master_id, controlData.in_question_type_id)}"
                ></mapbox-autocomplete>
                <span
                  v-show="errors.has('map_'+controlData.in_question_master_id)"
                  class="error"
                >{{ errors.first('map_'+controlData.in_question_master_id) }}</span>
              </div>
              <div class="group" v-else>
                <input
                  type="text"
                  class="pac-target-input"
                  :key="'chkrb'+controlData.in_question_master_id"
                  :name="'chkOther_'+controlData.in_question_master_id"
                  data-vv-as="above"
                  v-validate="{required: true,max:80}"
                  placeholder="Enter your other answer"
                  :value="previewSurveyData['chkOtherMulChoice'][''+controlData.in_question_master_id] ? previewSurveyData['chkOtherMulChoice'][''+controlData.in_question_master_id].formatted_address : ''"
                  @input="controlData.validationDetailsObj[1] ? (checkInput(controlData.in_question_master_id, $event),checkListOther(controlData.in_question_master_id, $event)) : checkListOther(controlData.in_question_master_id, $event)"
                />
                <!-- <span class="bar"></span> -->
                <div>
                  <span
                    v-show="errors.has('chkOther_'+controlData.in_question_master_id)"
                    class="error"
                  >{{ errors.first('chkOther_'+controlData.in_question_master_id) }}</span>
                </div>
              </div>
            </div>
          </div>
          <!-- END for List question type -->
          <!-- ********************* -->
          <!-- START for email question type -->
          <div
            class="persnol-info-main qus_ans_sec"
            v-if="controlData.in_question_type_id == vueQueTypeConfig.TYPE_EMAIL"
          >
            <label class="persnol-info-title">
              <span
                class="error"
              >{{controlData.validationDetailsObj[1] ? '*' : ''}}</span>{{controlData.in_question_order + '.'}}
              {{controlData.st_question_title}}
            </label>
            <div class="group email_sec">
              <i aria-hidden="true" class="fas fa-envelope"></i>
              <input
                type="text"
                placeholder="Answer here"
                :key="'email'+controlData.in_question_master_id"
                :name="'txt_email_'+controlData.in_question_master_id"
                v-model="previewSurveyData.chkSurveyQuestionDetails[''+controlData.in_question_master_id]"
                v-validate="{required: controlData.validationDetailsObj[1] ? true : false, email: true}"
                data-vv-as="above"
                :data-email-survey="controlData.validationDetailsObj[22]"
                @input="controlData.validationDetailsObj[1] ? checkInput(controlData.in_question_master_id, $event) : ''"
                @blur="validateEmail('txt_email_'+controlData.in_question_master_id, $event)"
              />
              <!-- <span class="bar"></span> -->
              <span
                v-show="errors.has('txt_email_'+controlData.in_question_master_id)"
                class="error"
              >{{ errors.first('txt_email_'+controlData.in_question_master_id) }}</span>
            </div>
          </div>
          <!-- END email question type -->
          <!-- ********************* -->
          <!-- START for two choices question type -->
          <div
            class="selection-gender qus_ans_sec"
            v-if="controlData.in_question_type_id == vueQueTypeConfig.TYPE_YES_NO || controlData.in_question_type_id == vueQueTypeConfig.TYPE_TRUE_FALSE || controlData.in_question_type_id == vueQueTypeConfig.TYPE_OTHER"
          >
            <label class="persnol-info-title">
              <span
                class="error"
              >{{controlData.validationDetailsObj[1] ? '*' : ''}}</span>{{controlData.in_question_order + '.'}}
              {{controlData.st_question_title}}
            </label>
            <div class="group">
            <label class="selection-main">
              {{(controlData.in_question_type_id == vueQueTypeConfig.TYPE_YES_NO) ? 'Yes' : (controlData.in_question_type_id == vueQueTypeConfig.TYPE_TRUE_FALSE) ? 'True' : controlData.validationDetailsObj[40]}}
              <input
                type="radio"
                :key="'rb'+controlData.in_question_master_id"
                :name="'rb_'+controlData.in_question_master_id"
                v-model="previewSurveyData.chkSurveyQuestionDetails[''+controlData.in_question_master_id]"
                v-validate="{required: controlData.validationDetailsObj[1] ? true : false}"
                data-vv-as="above"
                :value="{value: (controlData.in_question_type_id == vueQueTypeConfig.TYPE_YES_NO) ? 'yes' : (controlData.in_question_type_id == vueQueTypeConfig.TYPE_TRUE_FALSE) ? 'true' : controlData.validationDetailsObj[40], score: (controlData.validationDetailsObj['extra'] & controlData.validationDetailsObj['extra'][0] ? controlData.validationDetailsObj['extra'][0]['score'] : '')}"
                @input="controlData.validationDetailsObj[1] ? checkInput(controlData.in_question_master_id, $event) : ''"
                @click="uncheck(controlData.in_question_master_id, (controlData.in_question_type_id == vueQueTypeConfig.TYPE_YES_NO) ? 'yes' : (controlData.in_question_type_id == vueQueTypeConfig.TYPE_TRUE_FALSE) ? 'true' : controlData.validationDetailsObj[40])"
              />
              <span class="checkmark-new checkradio-new"></span>
            </label>
            <label class="selection-main">
              {{(controlData.in_question_type_id == vueQueTypeConfig.TYPE_YES_NO) ? 'No' : (controlData.in_question_type_id == vueQueTypeConfig.TYPE_TRUE_FALSE) ? 'False' : controlData.validationDetailsObj[41]}}
              <input
                type="radio"
                :key="'rb'+controlData.in_question_master_id"
                :name="'rb_'+controlData.in_question_master_id"
                v-model="previewSurveyData.chkSurveyQuestionDetails[''+controlData.in_question_master_id]"
                :value="{value: (controlData.in_question_type_id == vueQueTypeConfig.TYPE_YES_NO) ? 'no' : (controlData.in_question_type_id == vueQueTypeConfig.TYPE_TRUE_FALSE) ? 'false' : controlData.validationDetailsObj[41], score: (controlData.validationDetailsObj['extra'] && controlData.validationDetailsObj['extra'][1] ? controlData.validationDetailsObj['extra'][1]['score'] : '')}"
                @input="controlData.validationDetailsObj[1] ? checkInput(controlData.in_question_master_id, $event) : ''"
                @click="uncheck(controlData.in_question_master_id, (controlData.in_question_type_id == vueQueTypeConfig.TYPE_YES_NO) ? 'no' : (controlData.in_question_type_id == vueQueTypeConfig.TYPE_TRUE_FALSE) ? 'false' : controlData.validationDetailsObj[41])"
              />
              <span class="checkmark-new checkradio-new"></span>
            </label>
            <div>
              <span
                v-show="errors.has('rb_'+controlData.in_question_master_id)"
                class="error"
              >{{ errors.first('rb_'+controlData.in_question_master_id) }}</span>
            </div>
            </div>
          </div>
          <!-- END for two choices question type -->
          <!-- ********************* -->
          <!-- START Number question type -->
          <div
            class="persnol-info-main qus_ans_sec"
            v-if="controlData.in_question_type_id == vueQueTypeConfig.TYPE_CURRENCY || controlData.in_question_type_id == vueQueTypeConfig.TYPE_NUMBER"
          >
            <label class="persnol-info-title">
              <span
                class="error"
              >{{controlData.validationDetailsObj[1] ? '*' : ''}}</span>{{controlData.in_question_order + '.'}}
              {{controlData.st_question_title}}
            </label>
            <!-- Currency and Numbers -->
            <div class="group">
              <span
                class="currency"
                v-if="controlData.validationDetailsObj[27]"
              >{{controlData.validationDetailsObj[27]}}</span>
              <input
                type="text"
                placeholder="Answer here"
                :key="'number'+controlData.in_question_master_id"
                :name="'txt_number_'+controlData.in_question_master_id"
                v-model="previewSurveyData.chkSurveyQuestionDetails[''+controlData.in_question_master_id]"
                v-validate="{required: controlData.validationDetailsObj[1] ? true : false, decimal: controlData.validationDetailsObj[28] ? 2 : false, integer: controlData.validationDetailsObj[28] ? false : true, custom_min_value: controlData.validationDetailsObj[4] ? controlData.validationDetailsObj[4] : '', custom_max_value: controlData.validationDetailsObj[5] ? controlData.validationDetailsObj[5] : ''}"
                data-vv-as="above"
                @input="controlData.validationDetailsObj[1] ? checkInput(controlData.in_question_master_id, $event) : ''"
                :style="{ 'padding-left': controlData.in_question_type_id == vueQueTypeConfig.TYPE_CURRENCY ? '60px' : '20px'}"
              />
              <!-- <span class="bar"></span> -->
              <span
                v-show="errors.has('txt_number_'+controlData.in_question_master_id)"
                class="error"
              >{{ errors.first('txt_number_'+controlData.in_question_master_id) }}</span>
            </div>
          </div>
          <div
            class="persnol-info-main qus_ans_sec"
            v-if="controlData.in_question_type_id == vueQueTypeConfig.TYPE_TELEPHONE"
          >
            <label class="persnol-info-title">
              <span
                class="error"
              >{{controlData.validationDetailsObj[1] ? '*' : ''}}</span>{{controlData.in_question_order + '.'}}
              {{controlData.st_question_title}}
              <a
                @click.prevent
                data-toggle="tooltip"
                data-placement="top"
                v-if="controlData.st_question_hint != null"
              >
                <i class="fa fa-info-circle" v-tooltip.right="controlData.st_question_hint"></i>
              </a>
            </label>
            <!-- Telephone -->
            <div class="group">
              {{controlData.validationDetailsObj[27] ? controlData.validationDetailsObj[27] : ''}}
              <i class="fa fa-phone"></i>
              <input
                type="text"
                placeholder="Answer here"
                :key="'number'+controlData.in_question_master_id"
                :name="'txt_number_'+controlData.in_question_master_id"
                v-model="previewSurveyData.chkSurveyQuestionDetails[''+controlData.in_question_master_id]"
                v-validate="{required: controlData.validationDetailsObj[1] ? true : false, min: controlData.validationDetailsObj[2] ? controlData.validationDetailsObj[2] : '', custom_max: controlData.validationDetailsObj[3] ? controlData.validationDetailsObj[3] : '', custom_regex: controlData.validationDetailsObj[26] ? ([controlData.validationDetailsObj[26]['source'],controlData.st_question_hint]) : ['^[0-9]+$', 'Allowed characters: 0-9']}"
                data-vv-as="above"
                @input="controlData.validationDetailsObj[1] ? checkInput(controlData.in_question_master_id, $event) : ''"
              />
              <!-- <span class="bar"></span> -->
              <span
                v-show="errors.has('txt_number_'+controlData.in_question_master_id)"
                class="error"
              >{{ errors.first('txt_number_'+controlData.in_question_master_id) }}</span>
            </div>
          </div>
          <!-- END for Number question type -->
          <!-- ********************* -->
          <!-- START Terms & Condition question type -->
          <div
            class="persnol-info-main selection-gender qus_ans_sec term-sec"
            v-if="controlData.in_question_type_id == vueQueTypeConfig.TYPE_TERMS_AND_CONDITIONS"
          >
            <label class="persnol-info-title">
              <span
                class="error"
              >{{controlData.validationDetailsObj[1] ? '*' : ''}}</span>{{controlData.in_question_order + '.'}}
              {{controlData.st_question_title}}
            </label>
            <div class="group">
              <div class="text-wrap-new" v-if="controlData.validationDetailsObj[12]">
                <textarea rows="5" class="form-control" readonly>{{controlData.validationDetailsObj[12]}}</textarea>
              </div>
              <label
                class="selection-main"
                v-for="(val, i) in controlData.validationDetailsObj[19]"
                :key="i"
              >
                {{val}}
                <input
                  type="radio"
                  :key="'rb'+controlData.in_question_master_id"
                  :name="'rb_'+controlData.in_question_master_id"
                  v-model="previewSurveyData.chkSurveyQuestionDetails[''+controlData.in_question_master_id]"
                  v-validate="{required: controlData.validationDetailsObj[1] ? true : false}"
                  data-vv-as="above"
                  :value="val"
                  @input="controlData.validationDetailsObj[1] ? checkInput(controlData.in_question_master_id, $event) : ''"
                  @click="uncheck(controlData.in_question_master_id, val)"
                />
                <span class="checkmark-new checkradio-new"></span>
              </label>
            </div>
            
            <div>
              <span
                v-show="errors.has('rb_'+controlData.in_question_master_id)"
                class="error"
              >{{ errors.first('rb_'+controlData.in_question_master_id) }}</span>
            </div>
          </div>
          <!-- END for Terms & Condition question type -->
          <!-- ********************* -->
          <!-- START Date question type -->
          <div
            class="persnol-info-main qus_ans_sec"
            v-if="controlData.in_question_type_id == vueQueTypeConfig.TYPE_DATE"
          >
            <label class="persnol-info-title">
              <span
                class="error"
              >{{controlData.validationDetailsObj[1] ? '*' : ''}}</span>{{controlData.in_question_order + '.'}}
              {{controlData.st_question_title}}
            </label>
            <div class="group">
              <date-picker
                value-type="format"
                v-model="previewSurveyData.chkSurveyQuestionDetails[''+controlData.in_question_master_id]"
                v-validate="{required: controlData.validationDetailsObj[1] ? true : false}"
                :name="'datepicker_'+controlData.in_question_master_id"
                :not-before="controlData.validationDetailsObj[30] ? controlData.validationDetailsObj[30] : ''"
                :not-after="controlData.validationDetailsObj[31] ? controlData.validationDetailsObj[31] : ''"
                :format="controlData.validationDetailsObj[42] ? controlData.validationDetailsObj[42] : 'DD-MM-YYYY' "
                :first-day-of-week="1"
                :lang="lang"
                data-vv-as="above"
                data-id="date_field"
                v-on="{ input: controlData.validationDetailsObj[1] ? (currentValue) => checkDateTimePicker(currentValue, controlData.in_question_master_id) : null }"
                input-class
              ></date-picker>
              <div>
                <span
                  v-show="errors.has('datepicker_'+controlData.in_question_master_id)"
                  class="error"
                >{{ errors.first('datepicker_'+controlData.in_question_master_id) }}</span>
              </div>
            </div>
          </div>
          <!-- END for Date question type -->
          <!-- START Time question type -->
          <div
            class="persnol-info-main qus_ans_sec"
            v-if="controlData.in_question_type_id == vueQueTypeConfig.TYPE_12_HOURS || controlData.in_question_type_id == vueQueTypeConfig.TYPE_24_HOURS"
          >
            <label class="persnol-info-title">
              <span
                class="error"
              >{{controlData.validationDetailsObj[1] ? '*' : ''}}</span>{{controlData.in_question_order + '.'}}
              {{controlData.st_question_title}}
            </label>
            <div class="group timepicker-container" v-if="!previewSurveyData.chkSurveyQuestionDetails[''+controlData.in_question_master_id] ? (previewSurveyData.chkSurveyQuestionDetails[''+controlData.in_question_master_id] = moment().format('HH:mm:ss'), true) : true">
              <!-- <span class="mx-input-append">
                <svg height="512pt" viewBox="0 0 512 512" width="512pt" xmlns="http://www.w3.org/2000/svg"><path d="m256 0c-141.164062 0-256 114.835938-256 256s114.835938 256 256 256 256-114.835938 256-256-114.835938-256-256-256zm121.75 388.414062c-4.160156 4.160157-9.621094 6.253907-15.082031 6.253907-5.460938 0-10.925781-2.09375-15.082031-6.253907l-106.667969-106.664062c-4.011719-3.988281-6.25-9.410156-6.25-15.082031v-138.667969c0-11.796875 9.554687-21.332031 21.332031-21.332031s21.332031 9.535156 21.332031 21.332031v129.835938l100.417969 100.414062c8.339844 8.34375 8.339844 21.824219 0 30.164062zm0 0"/></svg>
              </span>
              <boot-date-picker
                :key="'timepicker_'+controlData.in_question_master_id"
                :model.sync="previewSurveyData.chkSurveyQuestionDetails[''+controlData.in_question_master_id]"
                :requiredValidation="controlData.validationDetailsObj[1]"
                :minDate="controlData.validationDetailsObj[32]"
                :maxDate="controlData.validationDetailsObj[33]"
                :surQuesTypeId="controlData.in_question_type_id"
                :surQuesMasterId="controlData.in_question_master_id"
                :componentName="'timepicker_'+controlData.in_question_master_id"
              ></boot-date-picker> -->
              
              <!-- <date-picker
                type="time"
                v-model="previewSurveyData.chkSurveyQuestionDetails[''+controlData.in_question_master_id]"
                v-validate="{required: controlData.validationDetailsObj[1] ? true : false}"
                :name="'timepicker_'+controlData.in_question_master_id"
                :not-before="controlData.validationDetailsObj[32] ? controlData.validationDetailsObj[32] : ''"
                :not-after="controlData.validationDetailsObj[33] ? controlData.validationDetailsObj[33] : ''"
                :format="controlData.in_question_type_id == vueQueTypeConfig.TYPE_12_HOURS ? timeFormat12 : timeFormat24"
                :time-picker-options=" timePickerOptions"
                placeholder="Select Time"
                data-vv-as="above"
                v-on="{ input: controlData.validationDetailsObj[1] ? (currentValue) => checkDateTimePicker(currentValue, controlData.in_question_master_id) : null }"
                input-class
              ></date-picker>-->
              <v-app>
                <v-dialog
                  :ref="'dialog_'+controlData.in_question_master_id"
                  v-model="timePickerObject[controlData.in_question_master_id]"
                  :return-value.sync="previewSurveyData.chkSurveyQuestionDetails[''+controlData.in_question_master_id]"
                  persistent
                  width="330px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      solo
                      single-line
                      v-model="tempTimePickerValue[''+controlData.in_question_master_id]"
                      v-validate="{required: controlData.validationDetailsObj[1] ? true : false}"
                      :name="'timepicker_'+controlData.in_question_master_id"
                      @click:clear="clearTimepickerValue(controlData.in_question_master_id, controlData.validationDetailsObj[1], controlData.skipLogic, index)"
                      v-bind="attrs"
                      v-on="on"
                      data-vv-as="above"
                      label="Select Time"
                      prepend-inner-icon="mdi-clock"
                      readonly
                      clearable
                      hide-details="auto"
                      rounded
                    ></v-text-field>
                  </template>
                    <!-- v-model="time" -->
                  <v-time-picker
                    :key="'timepicker_'+controlData.in_question_master_id"
                    v-if="timePickerObject[controlData.in_question_master_id]"
                    v-model="previewSurveyData.chkSurveyQuestionDetails[''+controlData.in_question_master_id]"
                    v-on="{ input: controlData.validationDetailsObj[1] ? (currentValue) => (checkDateTimePicker(currentValue, controlData.in_question_master_id)) : null }"
                    :format="controlData.in_question_type_id == vueQueTypeConfig.TYPE_12_HOURS ? 'ampm' : '24hr'"
                    :min="controlData.validationDetailsObj[32] ? controlData.in_question_type_id == vueQueTypeConfig.TYPE_12_HOURS ? moment(controlData.validationDetailsObj[32], timeFormat12).format(timeFormat24) : controlData.validationDetailsObj[32]
                      : undefined"
                    :max="controlData.validationDetailsObj[33] ? controlData.in_question_type_id == vueQueTypeConfig.TYPE_12_HOURS ? moment(controlData.validationDetailsObj[33], timeFormat12).format(timeFormat24) : controlData.validationDetailsObj[33]
                      : undefined"
                    use-seconds
                    full-width
                    ampm-in-title
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="unsetTimePickerValue(controlData.in_question_master_id)">
                      Cancel
                    </v-btn>
                    <v-btn text color="primary" @click="setTimePickerValue(1, controlData.in_question_type_id, controlData.in_question_master_id, '', '')">
                      OK
                    </v-btn>
                  </v-time-picker>
                </v-dialog>
              </v-app>
              <div>
                <span
                  v-show="errors.has('timepicker_'+controlData.in_question_master_id)"
                  class="error"
                >{{ errors.first('timepicker_'+controlData.in_question_master_id) }}</span>
              </div>
            </div>
          </div>
          <!-- END for Time question type -->
          <!-- ********************* -->
          <!-- START Multiple choice question type - Text -->
          <!-- Allow more than one answer -> checkbox else radio button -->
          <div
            class="selection-gender qus_ans_sec"
            v-if="controlData.in_question_type_id == vueQueTypeConfig.TYPE_MULTIPLE_TEXT"
          >
            <label class="persnol-info-title">
              <span
                class="error"
              >{{controlData.validationDetailsObj[1] ? '*' : ''}}</span>{{controlData.in_question_order + '.'}}
              {{controlData.st_question_title}}
            </label>
            <div class="group">
            <label
              class="check-label"
              v-for="(val, i) in controlData.validationDetailsObj[14]"
              :key="i"
            >
              {{val.answer}}
              <input
                :type="controlData.validationDetailsObj[20] ? 'checkbox' : 'radio'"
                :key="'chkrb'+controlData.in_question_master_id"
                :name="'chk_'+controlData.in_question_master_id"
                v-validate="{required: controlData.validationDetailsObj[1] ? true : false}"
                data-vv-as="above"
                :value="val.answer"
                :checked="previewSurveyData['chkMapMulChoice'][controlData.in_question_master_id] && (previewSurveyData['chkMapMulChoice'][controlData.in_question_master_id].formatted_address == val.answer  || ( !previewSurveyData['chkMapMulChoice'][controlData.in_question_master_id].formatted_address && (previewSurveyData['chkMapMulChoice'][controlData.in_question_master_id]).map(y=>y['formatted_address']).includes(val.answer) ) ) ? true : false"
                @click="checkOtherAnswer(quesNo, controlData.in_question_master_id, controlData.validationDetailsObj[49], $event)"
                @change="controlData.validationDetailsObj[1] ? (checkCheckbox(controlData.in_question_master_id, $event),setModelValueForMultipleAns(controlData.in_question_master_id, controlData.validationDetailsObj[20], $event)) : setModelValueForMultipleAns(controlData.in_question_master_id, controlData.validationDetailsObj[20], $event)"
                :data-lat="val.lat"
                :data-lng="val.lng"
                :data-score="val.score"
              />
              <span class="checkmark check-mark-two"></span>
            </label>
            <!-- Allow other answer -->
            <label class="check-label" v-if="controlData.validationDetailsObj[13]">
              Other
              <input
                :type="controlData.validationDetailsObj[20] ? 'checkbox' : 'radio'"
                :key="'chkrb'+controlData.in_question_master_id"
                :name="'chk_'+controlData.in_question_master_id"
                v-validate="{required: controlData.validationDetailsObj[1] ? true : false}"
                data-vv-as="above"
                value="Other"
                :checked="controlData.other ? true : false"
                @click="checkOtherAnswer(quesNo, controlData.in_question_master_id, controlData.validationDetailsObj[49], $event)"
                @change="controlData.validationDetailsObj[1] ? (checkCheckbox(controlData.in_question_master_id, $event),setModelValueForMultipleAns(controlData.in_question_master_id, controlData.validationDetailsObj[20], $event)) : setModelValueForMultipleAns(controlData.in_question_master_id, controlData.validationDetailsObj[20], $event)"
              />
              <span class="checkmark check-mark-two"></span>
            </label>
            <div>
              <span
                v-show="errors.has('chk_'+controlData.in_question_master_id)"
                class="error"
              >{{ errors.first('chk_'+controlData.in_question_master_id) }}</span>
            </div>
            </div>
            <div class="persnol-info-main" v-if="controlData.other">
              <div class="group" v-if="controlData.validationDetailsObj[49]">
                <input
                  type="hidden"
                  :key="'map'+controlData.in_question_master_id"
                  :name="'map_'+controlData.in_question_master_id"
                  v-model="previewSurveyData['chkOtherMulChoice'][''+controlData.in_question_master_id]"
                  v-validate="{required: controlData.validationDetailsObj[1] ? true : false}"
                  data-vv-as="above"
                />
                <mapbox-autocomplete
                  :id="'map_'+controlData.in_question_master_id"
                  :ref="'map_'+controlData.in_question_master_id"
                  :data-score="controlData.validationDetailsObj[13] ? controlData.validationDetailsObj[13][0]['score'] : ''"
                  placeholder="Enter a location"
                  v-on="{placechanged: (addressData, placeResultData, id) => getAddressData(controlData.validationDetailsObj[1], addressData, placeResultData, id, controlData.in_question_master_id, controlData.in_question_type_id), error: handleError, inputChange: (inputValue, id) => onMapInputChange(inputValue, id, controlData.in_question_master_id, controlData.in_question_type_id)}"
                ></mapbox-autocomplete>
                <span
                  v-show="errors.has('map_'+controlData.in_question_master_id)"
                  class="error"
                >{{ errors.first('map_'+controlData.in_question_master_id) }}</span>
              </div>
              <div class="group list-qus-sec" v-else>
                <input
                  type="text"
                  :key="'chkrb'+controlData.in_question_master_id"
                  :name="'chkOther_'+controlData.in_question_master_id"
                  :data-score="controlData.validationDetailsObj[13] ? controlData.validationDetailsObj[13][0]['score'] : ''"
                  :value="previewSurveyData['chkOtherMulChoice'][''+controlData.in_question_master_id] ? previewSurveyData['chkOtherMulChoice'][''+controlData.in_question_master_id].formatted_address : ''"
                  data-vv-as="above"
                  class="pac-target-input"
                  v-validate="{required: true,max:80,}"
                  placeholder="Enter your other answer"
                  @input="controlData.validationDetailsObj[1] ? (checkInput(controlData.in_question_master_id, $event), checkOtherAnswer(quesNo, controlData.in_question_master_id, controlData.validationDetailsObj[49], $event)) : (checkOtherAnswer(quesNo, controlData.in_question_master_id, controlData.validationDetailsObj[49], $event))"
                />
                <!-- <span class="bar"></span> -->
                <div>
                  <span
                    v-show="errors.has('chkOther_'+controlData.in_question_master_id)"
                    class="error"
                  >{{ errors.first('chkOther_'+controlData.in_question_master_id) }}</span>
                </div>
              </div>
            </div>
          </div>
          <!-- Multiple choice question type - Image -->
          <div
            class="image-selection onebyoneimagesection" style="padding: 0;"
            v-if="controlData.in_question_type_id == vueQueTypeConfig.TYPE_MULTIPLE_IMAGE"
          >
            <label class="persnol-info-title" style="margin-left: -8px;">
              <span
                class="error"
              >{{controlData.validationDetailsObj[1] ? '*' : ''}}</span>{{controlData.in_question_order + '.'}}
              {{controlData.st_question_title}}
            </label>
            <label class="selectonelabel" v-if="!controlData.validationDetailsObj[20]">Select One</label>
            <div class="row">
              <div
                class="col-md-3" style="padding-left: 8px; padding-right: 8px;"
                v-for="(imageValue, imageIndex) in controlData.validationDetailsObj[15]"
              >
                <div :class="(controlData.validationDetailsObj[20] && previewSurveyData.chkSurveyQuestionDetails[''+controlData.in_question_master_id] && previewSurveyData.chkSurveyQuestionDetails[''+controlData.in_question_master_id].includes(imageValue.s3ImagePath) || previewSurveyData.chkSurveyQuestionDetails[''+controlData.in_question_master_id] == imageValue.s3ImagePath) ? 'multichoicequs-div active' : 'multichoicequs-div'">
                  <i class="checked-circle"></i>
                  <label class="imageContainer">
                    <input
                      :type="controlData.validationDetailsObj[20] ? 'checkbox' : 'radio'"
                      :key="'chkrb'+controlData.in_question_master_id"
                      :name="'chk_image_'+controlData.in_question_master_id"
                      v-validate="{required: controlData.validationDetailsObj[1] ? true : false}"
                      data-vv-as="above"
                      :value="imageValue.s3ImagePath"
                      class="hidden"
                      autocomplete="off"
                      @click="checkOtherAnswer(quesNo, controlData.in_question_master_id, true, $event)"
                      @change="controlData.validationDetailsObj[1] ? (checkCheckbox(controlData.in_question_master_id, $event), setModelValueForMultipleAns(controlData.in_question_master_id, controlData.validationDetailsObj[20], $event)) : setModelValueForMultipleAns(controlData.in_question_master_id, controlData.validationDetailsObj[20], $event)"
                      :data-score="imageValue.score"
                      :checked="(controlData.validationDetailsObj[20] && previewSurveyData.chkSurveyQuestionDetails[''+controlData.in_question_master_id] && previewSurveyData.chkSurveyQuestionDetails[''+controlData.in_question_master_id].includes(imageValue.s3ImagePath) || previewSurveyData.chkSurveyQuestionDetails[''+controlData.in_question_master_id] == imageValue.s3ImagePath)"
                    />
                    <img :src="imageValue.dataURL" alt="..." class="profileImagePreview img-check" />
                  </label>
                  <div class="multichoice-text text-center" v-if="controlData.validationDetailsObj[21] && imageValue.st_answer_label">
                    <span class="iteam-select">{{imageValue.st_answer_label}}</span>
                  </div>
                </div>
              </div>
              <div class="col-md-3" v-if="controlData.validationDetailsObj[13]" style="padding-left: 8px; padding-right: 8px;">
                <div :class="(controlData.validationDetailsObj[20] && previewSurveyData.chkSurveyQuestionDetails[''+controlData.in_question_master_id] && previewSurveyData.chkSurveyQuestionDetails[''+controlData.in_question_master_id].includes('Other') || previewSurveyData.chkSurveyQuestionDetails[''+controlData.in_question_master_id] == 'Other') ? 'multichoicequs-div other-block active' : 'multichoicequs-div other-block'">
                  <label class="imageContainer">
                    <input
                      :type="controlData.validationDetailsObj[20] ? 'checkbox' : 'radio'"
                      :key="'chkrb'+controlData.in_question_master_id"
                      :name="'chk_image_'+controlData.in_question_master_id"
                      v-model="previewSurveyData.chkSurveyQuestionDetails[''+controlData.in_question_master_id]"
                      v-validate="{required: controlData.validationDetailsObj[1] ? true : false}"
                      data-vv-as="above"
                      value="Other"
                      @click="checkOtherAnswer(quesNo, controlData.in_question_master_id, true, $event)"
                      @change="controlData.validationDetailsObj[1] ? checkCheckbox(controlData.in_question_master_id, $event) : ''"
                    />
                    <img
                      src="../../assets/images/other_image.png"
                      alt="..."
                      class="profileImagePreview img-check"
                    />
                  </label>
                  <div class="multichoice-text text-center" v-if="controlData.validationDetailsObj[21]">
                    <span class="iteam-select">Other</span>
                  </div>
                </div>
              </div>
            </div>
            <!-- Allow other answer -->
            <!-- <label class="check-label" v-if="controlData.validationDetailsObj[13]">
              Other
              <input
                :type="controlData.validationDetailsObj[20] ? 'checkbox' : 'radio'"
                :key="'chkrb'+controlData.in_question_master_id"
                :name="'chk_image_'+controlData.in_question_master_id"
                v-model="previewSurveyData.chkSurveyQuestionDetails[''+controlData.in_question_master_id]"
                v-validate="{required: controlData.validationDetailsObj[1] ? true : false}"
                data-vv-as="above"
                value="Other"
                @click="checkOtherAnswer(quesNo, controlData.in_question_master_id, true, $event)"
                @input="controlData.validationDetailsObj[1] ? checkCheckbox(controlData.in_question_master_id, $event) : ''"
              >
              <span class="checkmark check-mark-two"></span>
            </label>-->
            <div>
              <span
                v-show="errors.has('chk_image_'+controlData.in_question_master_id)"
                class="error"
              >{{ errors.first('chk_image_'+controlData.in_question_master_id) }}</span>
            </div>
            <div class="persnol-info-main" v-if="controlData.other">
              <div class="group list-qus-sec">
                <input
                  type="text"
                  :key="'chkrb'+controlData.in_question_master_id"
                  :name="'chkOther_image_'+controlData.in_question_master_id"
                  :data-score="controlData.validationDetailsObj[13] ? controlData.validationDetailsObj[13][0]['score'] : ''"
                  :value="previewSurveyData['chkOtherMulChoice'][''+controlData.in_question_master_id] ? previewSurveyData['chkOtherMulChoice'][''+controlData.in_question_master_id].formatted_address : ''"
                  data-vv-as="above"
                  class="pac-target-input"
                  v-validate="{required: true,max:80}"
                  placeholder="Enter your other answer"
                  @input="checkOtherAnswer(quesNo, controlData.in_question_master_id, controlData.validationDetailsObj[49], $event)"
                />
                <!-- <span class="bar"></span> -->
                <div>
                  <span
                    v-show="errors.has('chkOther_image_'+controlData.in_question_master_id)"
                    class="error"
                  >{{ errors.first('chkOther_image_'+controlData.in_question_master_id) }}</span>
                </div>
              </div>
            </div>
          </div>
          <!-- END for Multiple choice question type -->
          <!-- ********************* -->
          <!-- START Image question type -->
          <div
            class="image-selection" style="padding: 0;"
            v-if="controlData.in_question_type_id == vueQueTypeConfig.TYPE_IMAGE ? previewSurveyData.chkSurveyQuestionDetails[''+controlData.in_question_master_id] = [] : 0"
          >
            <label class="persnol-info-title" v-if="controlData.validationDetailsObj[35]">
              <span
                class="error"
              >{{controlData.validationDetailsObj[1] ? '*' : ''}}</span>
              {{controlData.st_question_title}}
            </label>
            <!-- In one column -->
            <div class="row" v-if="controlData.validationDetailsObj[34] == 0">
              <div
                :class="[controlData.validationDetailsObj[15].length == 1 ? 'col-md-12' : (controlData.validationDetailsObj[15].length == 2 ? 'col-md-6' : (controlData.validationDetailsObj[15].length == 3 ? 'col-md-4' : 'col-md-3'))]"
                v-for="(imageValue, imageIndex) in controlData.validationDetailsObj[15]"
                :key="imageIndex"
              >
              <div class="multichoicequs-div">
                <label class="imageContainer">
                  <img
                    :src="imageValue.dataURL"
                    v-if="imageValue.dataURL && imageValue.s3ImagePath ? previewSurveyData.chkSurveyQuestionDetails[''+controlData.in_question_master_id].push(imageValue.s3ImagePath) : ''"
                    alt="..."
                    class="profileImagePreview img-check"
                  />
                </label>
                </div>
              </div>
            </div>
            <!-- In one row -->
            <div
              class="row"
              v-else
              v-for="(imageValue, imageIndex) in controlData.validationDetailsObj[15]"
              :key="imageIndex"
            >
              <div class="col-md-12">
                <label class="imageContainer single-img">
                  <img
                    :src="imageValue.dataURL"
                    v-if="imageValue.dataURL && imageValue.s3ImagePath ? previewSurveyData.chkSurveyQuestionDetails[''+controlData.in_question_master_id].push(imageValue.s3ImagePath) : ''"
                    alt="..."
                    class="profileImagePreview img-check"
                  />
                </label>
              </div>
            </div>
          </div>
          <!-- END Image question type -->
          <!-- ********************* -->
          <!-- START Rating question type - Star Rating-->
          <div
            class="star-rating-wrap"
            v-if="controlData.in_question_type_id == vueQueTypeConfig.TYPE_STAR ? emojiStarScore = emojiSplitJoin(controlData.validationDetailsObj['extra']['score'], '\n') : 0"
          >
            <label class="persnol-info-title">
              <span
                class="error"
              >{{controlData.validationDetailsObj[1] ? '*' : ''}}</span>{{controlData.in_question_order + '.'}}
              {{controlData.st_question_title}}
            </label>
            <label class="selectonelabel" v-if="!controlData.validationDetailsObj[20]">Select One</label>
            <fieldset class="rating">
              <label
                v-for="(rating, ind) in parseInt(controlData.validationDetailsObj[38])"
                :key="ind"
                v-bind:style="{ 'z-index': parseInt(controlData.validationDetailsObj[38]) - ind }"
              >
                <input
                  type="radio"
                  :id="'star'+(ind+1)"
                  :key="'rb'+controlData.in_question_master_id"
                  :name="'rb_'+controlData.in_question_master_id"
                  v-model="previewSurveyData.chkSurveyQuestionDetails[''+controlData.in_question_master_id]"
                  v-validate="{required: ind == 0 && controlData.validationDetailsObj[1] ? true : false}"
                  :value="{value: ind+1, score: (emojiStarScore[ind]) ? emojiStarScore[ind] : ''}"
                  data-vv-as="above"
                  @input="emojiStarScore = emojiSplitJoin(controlData.validationDetailsObj['extra']['score'], '\n'),(controlData.validationDetailsObj[1] ? checkInput(controlData.in_question_master_id, $event) : '')"
                />
                <span class="icon" v-for="i in (ind+1)" :key="i">&#9733;</span>
              </label>
              <!-- <span
                v-for="(rating, ind) in parseInt(controlData.validationDetailsObj[38])"
                :key="ind"
              >
                <input
                  type="radio"
                  :id="'star'+(ind+1)"
                  :key="'rb'+controlData.in_question_master_id"
                  :name="'rb_'+controlData.in_question_master_id"
                  v-model="previewSurveyData.chkSurveyQuestionDetails[''+controlData.in_question_master_id]"
                  v-validate="{required: ind == 0 && controlData.validationDetailsObj[1] ? true : false}"
                  :value="{value: ind+1, score: (emojiStarScore[ind]) ? emojiStarScore[ind] : ''}"
                  data-vv-as="above"
                  @input="controlData.validationDetailsObj[1] ? checkInput(controlData.in_question_master_id, $event) : ''"
                >
                <label class="full" :for="'star'+(ind+1)" :title="ind+1"></label>
              </span>-->
            </fieldset>
            <div>
              <span
                v-show="errors.has('rb_'+controlData.in_question_master_id)"
                class="error"
              >{{ errors.first('rb_'+controlData.in_question_master_id) }}</span>
            </div>
          </div>
          <!-- START Rating question type - Satisfaction Rating-->
          <div
            class="emoji-rates-wrap image-selection" style="padding: 0;"
            v-if="controlData.in_question_type_id == vueQueTypeConfig.TYPE_SATISFACTION ? emojiScore = emojiSplitJoin(controlData.validationDetailsObj['extra']['score'], '\n') : 0"
          >
            <label class="persnol-info-title">
              <span
                class="error"
              >{{controlData.validationDetailsObj[1] ? '*' : ''}}</span>{{controlData.in_question_order + '.'}}
              {{controlData.st_question_title}}
            </label>
            <div id="question-1">
              <ul class="emoji-choices">
                <li
                  class="choice"
                  v-for="(emojiValue, emojiIndex) in emojiSplitJoin(controlData.validationDetailsObj[39], 'sep')"
                  :data-value="emojiIndex+1"
                >
                  <label
                    :class="previewSurveyData.chkSurveyQuestionDetails[''+controlData.in_question_master_id] && previewSurveyData.chkSurveyQuestionDetails[''+controlData.in_question_master_id].value == ':P' ? 'emoji emoji-selected' : 'emoji'"
                    v-if="emojiValue == ':P'"
                  >
                    <input
                      type="radio"
                      v-model="previewSurveyData.chkSurveyQuestionDetails[''+controlData.in_question_master_id]"
                      :key="'emojisatis'+controlData.in_question_master_id"
                      :name="'chk_satis_'+controlData.in_question_master_id"
                      data-vv-as="above"
                      v-validate="{required: controlData.validationDetailsObj[1] ? true : false}"
                      class="hidden"
                      autocomplete="off"
                      :value="{value: ':P', score: (emojiScore[emojiIndex]) ? emojiScore[emojiIndex] : ''}"
                      @input="controlData.validationDetailsObj[1] ? checkInput(controlData.in_question_master_id, $event) : ''"
                      @click="uncheck(controlData.in_question_master_id, emojiValue)"
                    />
                    <i class="em em-heart_eyes"></i>
                  </label>
                  <label
                    :class="previewSurveyData.chkSurveyQuestionDetails[''+controlData.in_question_master_id] && previewSurveyData.chkSurveyQuestionDetails[''+controlData.in_question_master_id].value == ':)' ? 'emoji emoji-selected' : 'emoji'"
                    v-if="emojiValue == ':)'"
                  >
                    <input
                      type="radio"
                      v-model="previewSurveyData.chkSurveyQuestionDetails[''+controlData.in_question_master_id]"
                      :key="'emojisatis'+controlData.in_question_master_id"
                      :name="'chk_satis_'+controlData.in_question_master_id"
                      data-vv-as="above"
                      v-validate="{required: controlData.validationDetailsObj[1] ? true : false}"
                      class="hidden"
                      autocomplete="off"
                      :value="{value: ':)', score: (emojiScore[emojiIndex]) ? emojiScore[emojiIndex] : ''}"
                      @input="controlData.validationDetailsObj[1] ? checkInput(controlData.in_question_master_id, $event) : ''"
                      @click="uncheck(controlData.in_question_master_id, emojiValue)"
                    />
                    <i class="em em-smile"></i>
                  </label>
                  <label
                    :class="previewSurveyData.chkSurveyQuestionDetails[''+controlData.in_question_master_id] && previewSurveyData.chkSurveyQuestionDetails[''+controlData.in_question_master_id].value == ':|' ? 'emoji emoji-selected' : 'emoji'"
                    v-if="emojiValue == ':|'"
                  >
                    <input
                      type="radio"
                      v-model="previewSurveyData.chkSurveyQuestionDetails[''+controlData.in_question_master_id]"
                      :key="'emojisatis'+controlData.in_question_master_id"
                      :name="'chk_satis_'+controlData.in_question_master_id"
                      data-vv-as="above"
                      v-validate="{required: controlData.validationDetailsObj[1] ? true : false}"
                      class="hidden"
                      autocomplete="off"
                      :value="{value: ':|', score: (emojiScore[emojiIndex]) ? emojiScore[emojiIndex] : ''}"
                      @input="controlData.validationDetailsObj[1] ? checkInput(controlData.in_question_master_id, $event) : ''"
                      @click="uncheck(controlData.in_question_master_id, emojiValue)"
                    />
                    <i class="em em-neutral_face"></i>
                  </label>
                  <label
                    :class="previewSurveyData.chkSurveyQuestionDetails[''+controlData.in_question_master_id] && previewSurveyData.chkSurveyQuestionDetails[''+controlData.in_question_master_id].value == ':(' ? 'emoji emoji-selected' : 'emoji'"
                    v-if="emojiValue == ':('"
                  >
                    <input
                      type="radio"
                      v-model="previewSurveyData.chkSurveyQuestionDetails[''+controlData.in_question_master_id]"
                      :key="'emojisatis'+controlData.in_question_master_id"
                      :name="'chk_satis_'+controlData.in_question_master_id"
                      data-vv-as="above"
                      v-validate="{required: controlData.validationDetailsObj[1] ? true : false}"
                      class="hidden"
                      autocomplete="off"
                      :value="{value: ':(', score: (emojiScore[emojiIndex]) ? emojiScore[emojiIndex] : ''}"
                      @input="controlData.validationDetailsObj[1] ? checkInput(controlData.in_question_master_id, $event) : ''"
                      @click="uncheck(controlData.in_question_master_id, emojiValue)"
                    />
                    <i class="em em-disappointed"></i>
                  </label>
                  <label
                    :class="previewSurveyData.chkSurveyQuestionDetails[''+controlData.in_question_master_id] && previewSurveyData.chkSurveyQuestionDetails[''+controlData.in_question_master_id].value == ':@' ? 'emoji emoji-selected' : 'emoji'"
                    v-if="emojiValue == ':@'"
                  >
                    <input
                      type="radio"
                      v-model="previewSurveyData.chkSurveyQuestionDetails[''+controlData.in_question_master_id]"
                      :key="'emojisatis'+controlData.in_question_master_id"
                      :name="'chk_satis_'+controlData.in_question_master_id"
                      data-vv-as="above"
                      v-validate="{required: controlData.validationDetailsObj[1] ? true : false}"
                      class="hidden"
                      autocomplete="off"
                      :value="{value: ':@', score: (emojiScore[emojiIndex]) ? emojiScore[emojiIndex] : ''}"
                      @input="controlData.validationDetailsObj[1] ? checkInput(controlData.in_question_master_id, $event) : ''"
                      @click="uncheck(controlData.in_question_master_id, emojiValue)"
                    />
                    <i class="em em-angry"></i>
                  </label>
                </li>
              </ul>
              <div class="clearfix"></div>
              <div>
                <span
                  v-show="errors.has('chk_satis_'+controlData.in_question_master_id)"
                  class="error"
                >{{ errors.first('chk_satis_'+controlData.in_question_master_id) }}</span>
              </div>
            </div>
          </div>
          <!-- END Rating question type -->
          <!-- ********************* -->
          <!-- START Photo question type -->
          <div
            class="persnol-info-main qus_ans_sec disabled-question-none"
            v-if="!isAllowPhotoUploads && (controlData.in_question_type_id == vueQueTypeConfig.TYPE_CAMERA || controlData.in_question_type_id == vueQueTypeConfig.TYPE_QR_AND_BARCODE_READER)"
          >
            <label class="persnol-info-title">
              <span
                class="error"
              >{{controlData.validationDetailsObj[1] ? '*' : ''}}</span>{{controlData.in_question_order + '.'}}
              {{controlData.st_question_title}}
            </label>
            <div class="group img-icon">
              <!-- <i aria-hidden="true" :class="controlData.in_question_type_id == vueQueTypeConfig.TYPE_CAMERA ? 'fas fa-camera-retro' : 'fas fa-barcode'"></i> -->
              <!-- <img v-if="controlData.in_question_type_id == vueQueTypeConfig.TYPE_CAMERA" src="../../assets/images/camera.png" > -->
              <i v-if="controlData.in_question_type_id == vueQueTypeConfig.TYPE_CAMERA" aria-hidden="true" class="fas fa-camera"></i>
              <i v-else aria-hidden="true" class="fas fa-barcode"></i>
              <input
                type="text"
                placeholder="This question is not available for online form."
                readonly
              />
            </div>
            <!-- <input
              type="hidden"
              :name="'photo_'+controlData.in_question_master_id"
              v-validate="{required: controlData.validationDetailsObj[1] ? true : false}"
              data-vv-as="above"
            >-->
          </div>
          <!-- Upload or Capture Photo -->
          <div class="multichoicequs-div" v-if="arrShowAllPhotoQuestion && arrShowAllPhotoQuestion[controlData.in_question_master_id]">
                  <label class="persnol-info-title">
                    <span
                      class="error"
                    >{{controlData.validationDetailsObj[1] ? '*' : ''}}</span>{{controlData.in_question_number + '.'}}
                    {{controlData.st_question_title}}
                  </label>
                  <input
                    type="hidden"
                    :key="'photo_'+controlData.in_question_master_id"
                    :name="'photo_'+controlData.in_question_master_id"
                    v-model="previewSurveyData.chkSurveyQuestionDetails[''+controlData.in_question_master_id]"
                    v-validate="{required: controlData.validationDetailsObj[1] ? true : false}"
                    data-vv-as="above"
                  />
                  <span
                    v-show="errors.has('photo_'+controlData.in_question_master_id)"
                    class="error"
                  >{{ errors.first('photo_'+controlData.in_question_master_id) }}</span>
                  <div class="group camera_sec">
                    <label for="photoedit" class="photoquestionIcon">
                      <div class="item-inner-cam">
                        <i 
                        @click="viewPhotoModal(controlData.in_question_master_id, previewSurveyData.chkSurveyQuestionDetails[controlData.in_question_master_id], $event)"
                        aria-hidden="true" class="fas fa-camera edit-img"></i>
                      </div>
                    </label>
                    <img
                      :src="previewSurveyData.chkSurveyQuestionDetails[''+controlData.in_question_master_id]"
                      alt="..."
                      class="picture"
                    />
                    <label for="photoedit" class="photoquestionIcon">
                      <div class="item-inner-cam">
                        <i 
                        @click="(!photoQuestionStates[''+controlData.in_question_master_id]['isPhotoTaken']) ? removeOldPhoto(controlData.in_question_master_id, previewSurveyData.chkSurveyQuestionDetails[controlData.in_question_master_id], $event) : removeOldPhotoCam(controlData.in_question_master_id, previewSurveyData.chkSurveyQuestionDetails[controlData.in_question_master_id], $event)"
                        aria-hidden="true" class="fa fa-trash delete-img"></i>
                      </div>
                    </label>
                  </div>
                  <!-- view photo -->
                  <b-modal v-show="photoQuestionStates[''+controlData.in_question_master_id]['isViewPhoto']" v-if="photoQuestionStates[''+controlData.in_question_master_id]['isViewPhoto']" :id="'viewPhotoModal_'+controlData.in_question_master_id" class="view-photo-modal" :title="(controlData.validationDetailsObj[1] ? '*' : '') + controlData.in_question_number + '. ' +controlData.st_question_title" size="sm" hide-footer no-close-on-esc no-close-on-backdrop>
                      <div class="text-center">
                        <img :src="previewSurveyData.chkSurveyQuestionDetails[''+controlData.in_question_master_id]" alt="..." :width="350" class="picture img-check" />
                        <div class="camera-shoot" style="margin-top: 5px;">
                          <button  type="button" :id="'takePhoto_'+controlData.in_question_master_id" title="Retake Photo" class="btn btn-whitelable" @click="retakePhoto(controlData.in_question_master_id)" style="margin-right: 5px;">
                            <i class="fa fa-repeat" aria-hidden="true"></i>
                          </button>
                          <button  type="button" :id="'closeViewPhoto_'+controlData.in_question_master_id" title="Continue" class="btn btn-whitelable" @click="closeViewPhoto(controlData.in_question_master_id)">
                            Continue
                          </button>
                        </div>
                      </div>
                  </b-modal>
                    <!-- end view photo -->
                  <!-- retake photo -->
                  <b-modal :id="'cameraRetakeModal_'+controlData.in_question_master_id" title="Capture Photo" class="camera-modal" v-show="photoQuestionStates[''+controlData.in_question_master_id] && photoQuestionStates[''+controlData.in_question_master_id]['isRetakePhoto']"  size="xl" hide-footer no-close-on-esc no-close-on-backdrop>
                    <div class="" v-if="controlData.in_question_type_id == vueQueTypeConfig.TYPE_CAMERA || controlData.in_question_type_id == vueQueTypeConfig.TYPE_QR_AND_BARCODE_READER">
                      <div v-show="photoQuestionStates[''+controlData.in_question_master_id] && photoQuestionStates[''+controlData.in_question_master_id]['isCameraOpen'] && photoQuestionStates[''+controlData.in_question_master_id]['isLoading']" class="camera-loading">
                        <div id="loadingDiv" class="loadingDiv_analytics">
                            <div class="loadersec">
                              <div class="loader"></div>
                            </div>
                        </div>
                      </div>

                      <div v-show="photoQuestionStates[''+controlData.in_question_master_id]['isCameraOpen']" class="camera-box" :class="{ 'flash' : photoQuestionStates[''+controlData.in_question_master_id]['isShotPhoto'] }">
                        
                        <video v-show="!photoQuestionStates[''+controlData.in_question_master_id]['isPhotoTaken'] && photoQuestionStates[''+controlData.in_question_master_id]['isCameraOpen']" :id="'webcam_'+controlData.in_question_master_id" :ref="'webcam'" :width="450"  autoplay playsinline muted>
                        </video>

                        <canvas :id="'photoTaken_'+controlData.in_question_master_id" ref="canvas" :width="700" :height="525" style="display: none;"></canvas>
                      </div>
                      
                      <div v-show="photoQuestionStates[''+controlData.in_question_master_id]['isCameraOpen']" class="camera-shoot" >
                        <button  type="button" :id="'takePhoto_'+controlData.in_question_master_id" class="btn btn-whitelable" @click="takePhoto(controlData.in_question_master_id)">
                          <i class="fa fa-camera" aria-hidden="true"></i>
                        </button>
                      </div>
                    </div>
                  </b-modal>
                    <!-- end retake photo -->
          </div>
          <div
          class="persnol-info-main qus_ans_sec"
          v-else-if="isAllowPhotoUploads &&(controlData.in_question_type_id == vueQueTypeConfig.TYPE_CAMERA || controlData.in_question_type_id == vueQueTypeConfig.TYPE_QR_AND_BARCODE_READER)"
          >
            <label class="persnol-info-title">
              <span
                class="error"
              >{{controlData.validationDetailsObj[1] ? '*' : ''}}</span>{{controlData.in_question_number + '.'}}
              {{controlData.st_question_title}}
            </label>
            <div class="group img-icon">
              <i v-if="controlData.in_question_type_id == vueQueTypeConfig.TYPE_CAMERA" aria-hidden="true" class="fas fa-camera"></i>
              <i v-else aria-hidden="true" class="fas fa-barcode"></i>
              <input
                type="text"
                class="takePhoto btn text-left sub-main"
                placeholder="Take Photo"
                readonly
                @click="toggleCameraMenuModel(controlData.in_question_master_id, 'open')"
              />
              <input
                type="hidden"
                :key="'photo_'+controlData.in_question_master_id"
                :name="'photo_'+controlData.in_question_master_id"
                v-model="previewSurveyData.chkSurveyQuestionDetails[''+controlData.in_question_master_id]"
                v-validate="{required: controlData.validationDetailsObj[1] ? true : false}"
                data-vv-as="above"
              />
              <span
                v-show="errors.has('photo_'+controlData.in_question_master_id)"
                class="error"
              >{{ errors.first('photo_'+controlData.in_question_master_id) }}</span>
            </div>
            
            <b-modal :id="'photoModal_'+controlData.in_question_master_id" class="photo-modal" title="Select Photo" size="sm" hide-footer no-close-on-esc no-close-on-backdrop>
              <div class="text-center">
                <b-button class="mt-2 btn btn-success sub-main" block :id="'openCamera_'+controlData.in_question_master_id" @click="toggleCamera(controlData.in_question_master_id)">Open Camera</b-button>
                <b-button class="mt-2 btn btn-success sub-main" block @click="triggerFileInput(controlData.in_question_master_id)">Choose Photo</b-button>
                <input type="file" ref="fileInput" :id="'fileInput_'+controlData.in_question_master_id" style="display: none;" @change="uploadPhoto(controlData.in_question_master_id, $event)" />
                <b-button class="mt-2 btn btn-cancel sub-main" block @click="toggleCameraMenuModel(controlData.in_question_master_id, 'cancel')">Cancel</b-button>
              </div>
            </b-modal>
            <b-modal :id="'cameraModal_'+controlData.in_question_master_id" title="Capture Photo" class="camera-modal"  size="xl" hide-footer no-close-on-esc no-close-on-backdrop>
                    <div class="" v-if="controlData.in_question_type_id == vueQueTypeConfig.TYPE_CAMERA || controlData.in_question_type_id == vueQueTypeConfig.TYPE_QR_AND_BARCODE_READER">
                      <div v-show="photoQuestionStates[''+controlData.in_question_master_id] && photoQuestionStates[''+controlData.in_question_master_id]['isCameraOpen'] && photoQuestionStates[''+controlData.in_question_master_id]['isLoading']" class="camera-loading">
                        <div id="loadingDiv" class="loadingDiv_analytics">
                            <div class="loadersec">
                              <div class="loader"></div>
                            </div>
                        </div>
                      </div>

                      <div v-show="photoQuestionStates[''+controlData.in_question_master_id] && photoQuestionStates[''+controlData.in_question_master_id]['isCameraOpen']" class="camera-box" :class="{ 'flash' : photoQuestionStates[''+controlData.in_question_master_id] && photoQuestionStates[''+controlData.in_question_master_id]['isShotPhoto'] }">
                        
                        <video v-show="photoQuestionStates[''+controlData.in_question_master_id] && !photoQuestionStates[''+controlData.in_question_master_id]['isPhotoTaken'] && photoQuestionStates[''+controlData.in_question_master_id]['isCameraOpen']" :id="'webcam_'+controlData.in_question_master_id" :ref="'webcam'" :width="450"  autoplay playsinline muted>
                        </video>

                        <canvas :id="'photoTaken_'+controlData.in_question_master_id" ref="canvas" :width="700" :height="525" style="display: none;"></canvas>
                      </div>
                      
                      <div v-show="photoQuestionStates[''+controlData.in_question_master_id] && photoQuestionStates[''+controlData.in_question_master_id]['isCameraOpen']" class="camera-shoot" >
                        <button  type="button" :id="'takePhoto_'+controlData.in_question_master_id" class="btn btn-whitelable" @click="takePhoto(controlData.in_question_master_id)">
                          Capture
                        </button>
                      </div>
                    </div>
            </b-modal>
          </div>
          <!-- End Upload or Capture Photo -->
          <!-- END Photo question type -->
          <!-- ********************* -->
          <!-- START Audio/Video question type -->
          <div
            class="persnol-info-main qus_ans_sec disabled-question-none"
            v-if=" (controlData.in_question_type_id == vueQueTypeConfig.TYPE_AUDIO || controlData.in_question_type_id == vueQueTypeConfig.TYPE_VIDEO)"
          >
            <label class="persnol-info-title">
              <span
                class="error"
              >{{controlData.validationDetailsObj[1] ? '*' : ''}}</span>{{controlData.in_question_order + '.'}}
              {{controlData.st_question_title}}
            </label>
            <div class="group img-icon">
              <i v-if="controlData.in_question_type_id == vueQueTypeConfig.TYPE_AUDIO" aria-hidden="true" class="fas fa-microphone"></i>
              <i v-else aria-hidden="true" class="fas fa-video-camera"></i>
              <input
                type="text"
                placeholder="This question is not available for online form."
                readonly
              />
            </div>
          </div>
          <!-- END Audio/Video question type -->
          <!-- ********************* -->
          <!-- START Signature question type -->
          <div
            class="marginB0"
            v-if="controlData.in_question_type_id == vueQueTypeConfig.TYPE_SIGNATURE"
          >
            <label class="persnol-info-title">
              <span
                class="error"
              >{{controlData.validationDetailsObj[1] ? '*' : ''}}</span>{{controlData.in_question_order + '.'}}
              {{controlData.st_question_title}}
            </label>
            <!-- <div class="alert alert-info"> -->
            <input
              type="hidden"
              :key="'signature'+controlData.in_question_master_id"
              :name="'signature_'+controlData.in_question_master_id"
              v-model="previewSurveyData.chkSurveyQuestionDetails[''+controlData.in_question_master_id]"
              v-validate="{required: controlData.validationDetailsObj[1] ? true : false}"
              data-vv-as="above"
            />
            <div class="group signature_sec">
              <button
                type="button"
                class="btn sub-main edit-signature" >
                <!-- <img class="edit-img" src="../../assets/images/signature.png" /> -->
                <svg class="edit-img" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                  width="26.688px" height="26.563px" viewBox="0 -0.563 26.688 26.563" enable-background="new 0 -0.563 26.688 26.563"
                  xml:space="preserve">
                  <g>
                    <g>
                      <path d="M20.127,4.158c0-0.61-0.237-1.184-0.669-1.616l-2.154-2.154c-0.425-0.425-1.029-0.669-1.63-0.669h-0.131v4.57h4.584V4.158
                        L20.127,4.158z"/>
                    </g>
                  </g>
                  <g>
                    <g>
                      <path d="M14.258,15.438c0.146-0.443,0.4-0.855,0.732-1.189l5.158-5.136V5.813h-5.354c-0.42,0-0.736-0.341-0.736-0.762v-5.332
                        H2.633c-1.26,0-2.285,1.025-2.285,2.285v21.43c0,1.26,1.025,2.285,2.285,2.285h15.209c1.261,0,2.307-1.025,2.307-2.285v-5.686
                        l-0.838,0.817c-0.339,0.336-0.736,0.581-1.184,0.73l-2.422,0.809l-0.369,0.021c-0.61,0-1.188-0.297-1.546-0.795
                        c-0.355-0.494-0.452-1.135-0.259-1.715L14.258,15.438z M4.157,13.43h7.592c0.421,0,0.762,0.341,0.762,0.762
                        s-0.34,0.762-0.762,0.762H4.157c-0.421,0-0.762-0.341-0.762-0.762S3.736,13.43,4.157,13.43z M3.395,11.145
                        c0-0.421,0.341-0.762,0.762-0.762h7.592c0.421,0,0.762,0.341,0.762,0.762s-0.34,0.762-0.762,0.762H4.157
                        C3.736,11.906,3.395,11.565,3.395,11.145z M3.395,17.238c0-0.421,0.341-0.762,0.762-0.762h7.592c0.421,0,0.762,0.341,0.762,0.762
                        S12.17,18,11.749,18H4.157C3.736,18,3.395,17.659,3.395,17.238z M14.795,21.047c0.422,0,0.762,0.341,0.762,0.762
                        s-0.34,0.762-0.762,0.762h-4.57c-0.421,0-0.762-0.341-0.762-0.762s0.341-0.762,0.762-0.762H14.795z M4.157,8.859
                        c-0.421,0-0.762-0.341-0.762-0.762s0.341-0.762,0.762-0.762h10.639c0.422,0,0.762,0.341,0.762,0.762s-0.34,0.762-0.762,0.762
                        H4.157z"/>
                    </g>
                  </g>
                  <g>
                    <g>
                      <path d="M15.639,16.111L14.976,18.1c-0.099,0.298,0.185,0.581,0.481,0.481l1.988-0.663L15.639,16.111z"/>
                    </g>
                  </g>
                  <g>
                    <g>
                      <path d="M21.555,9.84l-5.017,5.017l2.164,2.163c1.134-1.134,3.339-3.34,5.017-5.017L21.555,9.84z"/>
                    </g>
                  </g>
                  <g>
                    <g>
                      <path d="M25.9,7.655c-0.268-0.27-0.662-0.423-1.08-0.423s-0.813,0.154-1.082,0.424l-1.107,1.107l2.164,2.163
                        c0.605-0.606,1.025-1.025,1.107-1.107C26.496,9.223,26.496,8.252,25.9,7.655z"/>
                    </g>
                  </g>
                  <g>
                    <g>
                      <g>
                        <path d="M25.902,9.819L25.902,9.819c0.002-0.002,0.002-0.003,0.004-0.004C25.904,9.816,25.904,9.817,25.902,9.819z"/>
                        <path d="M25.906,9.814c0.002-0.002,0.006-0.005,0.006-0.007C25.912,9.809,25.908,9.812,25.906,9.814z"/>
                        <path d="M25.912,9.808C25.918,9.803,25.918,9.803,25.912,9.808L25.912,9.808z"/>
                      </g>
                    </g>
                  </g>
                </svg>
              </button>
              <label class="labelpalceholder" :style="{ 'font-size': !showSignatureLabel ? '0' : '' }">Sign Here</label>
              <vue-signature
                :key="'vuesignature'+controlData.in_question_master_id"
                class="signature"
                width="100%"
                height="180px"
                :id="controlData.in_question_master_id"
                :ref="'signaturePad_'+controlData.in_question_master_id"
                :options="{ onBegin, onEnd: () => onEnd([], quesNo, controlData.validationDetailsObj[1]) }"
              ></vue-signature>
              <transition name="fade">
                <button
                  type="button"
                  class="btn sub-main delete-signature"
                  :data-id="controlData.in_question_master_id"
                  @click="clearSignature"
                  :style="{ 'visibility': previewSurveyData.chkSurveyQuestionDetails[''+controlData.in_question_master_id] ? '' : 'hidden' }"
                >
                  <!-- <img class="delete-img" src="../../assets/images/trash.png" /> -->
                  <i class="fa fa-trash delete-img" aria-hidden="true"></i>
                </button>
              </transition>
            </div>
            <div>
              <span
                v-show="errors.has('signature_'+controlData.in_question_master_id)"
                class="error"
              >{{ errors.first('signature_'+controlData.in_question_master_id) }}</span>
            </div>
            <!-- </div> -->
          </div>
          <!-- END Signature question type -->
        </div>
      </div>
      <div class="preview_btn_sec" style="justify-content: space-between;">
        <div class="left-btn">
          <div class="submit" v-if="quesNo != 0">
            <button type="button" class="btn btn-whitelable sub-main" @click="prevQues">
              previous
            </button>
          </div>
        </div>
        <div class="right-btn">
          <div class="submit" v-if="quesNo != (surveyQuestionDetailsData.length - 1)">
            <button type="button" class="btn btn-whitelable sub-main" @click="nextQues">
              Next
            </button>
          </div>
          <div class="submit" v-if="quesNo == (surveyQuestionDetailsData.length - 1)">
            <button
              type="button"
              class="btn btn-whitelable sub-main"
              :class="showDuplicateForm==1 ? 'submitBtnUseform' : ''"
              @click="validateBeforeSubmit"
              :disabled="submitted"
            >Submit</button>
          </div>
        </div>
      </div>
    </form>
  </div>
  <!--
  All in one question - all questions are on same page
  *********************************************************
  *********************************************************
  *********************************************************
  -->

  <div class="content preview_content" v-else-if="surveyMasterDetails.in_question_flow == 1">
    <v-wait for="adding response">
      <template slot="waiting">
        <!-- <div id="designLoadingdiv">
          <img class="designAjaxLoader" src="../../assets/images/loader.gif" />
        </div> -->
        <div id="loadingDiv" class="loadingDiv_analytics">
          <div class="loadersec">
            <div class="loader"></div>
          </div>
      </div>
      </template>
    </v-wait>
    <form @submit.prevent="validateBeforeSubmit" novalidate autocomplete="off">
      <div class="service-provide-info">
        <div v-for="(controlData, index) in surveyQuestionDetailsData" :key="index">

          <transition name="fade">
            <div v-if="controlData.displayFlag">
              <!-- {{ loaded.includes(index) == false ? skipLogicRuleDetails(controlData.skipLogic, index) : ''}} -->
              <!-- START text question type -->
              <div
                class="persnol-info-main qus_ans_sec"
                :class="{ 'red-border': (errors.has('map_'+controlData.queDetails.in_question_master_id) || errors.has('txt_'+controlData.queDetails.in_question_master_id)) }"
                v-if="controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_INPUT"
              >
                <label class="persnol-info-title">
                  <span
                    class="error"
                  >{{controlData.validationDetailsObj[1] ? '*' : ''}}</span>{{controlData.queDetails.in_question_number + '.'}}
                  {{controlData.queDetails.st_question_title}}
                  <a
                    @click.prevent
                    data-toggle="tooltip"
                    data-placement="top"
                    v-if="controlData.queDetails.st_question_hint != null"
                  >
                    <i
                      class="fa fa-info-circle"
                      v-tooltip.right="controlData.queDetails.st_question_hint"
                      v-if="controlData.validationDetailsObj[9]"
                    ></i>
                  </a>
                </label>
                <!-- Paragraph -->
                <div class="group" v-if="controlData.validationDetailsObj[8]">
                  <div class="text-wrap-new">
                    <div class="form-group" v-if="controlData.validationDetailsObj[49]">
                      <input
                        type="hidden"
                        :key="'map'+controlData.queDetails.in_question_master_id"
                        :name="'map_'+controlData.queDetails.in_question_master_id"
                        v-model="previewSurveyData.chkSurveyQuestionDetails[''+controlData.queDetails.in_question_master_id]"
                        v-validate="{required: controlData.validationDetailsObj[1] ? true : false}"
                        data-vv-as="above"
                      />
                      <mapbox-autocomplete
                        :id="'map_'+controlData.queDetails.in_question_master_id"
                        :ref="'map_'+controlData.queDetails.in_question_master_id"
                        placeholder="Enter a location"
                        v-on="{placechanged: (addressData, placeResultData, id) => getAddressData(controlData.validationDetailsObj[1], addressData, placeResultData, id, controlData.queDetails.in_question_master_id), error: handleError, inputChange: (inputValue, id) => (onMapInputChange(inputValue, id, controlData.queDetails.in_question_master_id), skipLogicRuleDetails(controlData.skipLogic, index))}"
                      ></mapbox-autocomplete>
                      <span
                        v-show="errors.has('map_'+controlData.queDetails.in_question_master_id)"
                        class="error"
                      >{{ errors.first('map_'+controlData.queDetails.in_question_master_id) }}</span>
                    </div>
                    <div class="form-group" v-else>
                      <textarea
                        class="form-control"
                        rows="5"
                        placeholder="Answer here"
                        :name="'txt_'+controlData.queDetails.in_question_master_id"
                        v-model="previewSurveyData.chkSurveyQuestionDetails[''+controlData.queDetails.in_question_master_id]"
                        v-validate="{required: controlData.validationDetailsObj[1] ? true : false, min: controlData.validationDetailsObj[2] ? controlData.validationDetailsObj[2] : '', custom_max: controlData.validationDetailsObj[3] ? controlData.validationDetailsObj[3] : ''}"
                        data-vv-as="above"
                        @input="controlData.validationDetailsObj[1] ? (checkInput(controlData.queDetails.in_question_master_id, $event), skipLogicRuleDetails(controlData.skipLogic, index)) : skipLogicRuleDetails(controlData.skipLogic, index)"
                      ></textarea>
                      <span
                        v-show="errors.has('txt_'+controlData.queDetails.in_question_master_id)"
                        class="error"
                      >{{ errors.first('txt_'+controlData.queDetails.in_question_master_id) }}</span>
                    </div>
                  </div>
                </div>
                <!-- Serial Number -->
                <div class="group" v-else-if="controlData.validationDetailsObj[9]">
                  <input
                    type="text"
                    placeholder="Answer here"
                    :name="'txt_'+controlData.queDetails.in_question_master_id"
                    v-model="previewSurveyData.chkSurveyQuestionDetails[''+controlData.queDetails.in_question_master_id]"
                    v-validate="{required: controlData.validationDetailsObj[1] ? true : false, min: controlData.validationDetailsObj[2] ? controlData.validationDetailsObj[2] : '', custom_max: controlData.validationDetailsObj[3] ? controlData.validationDetailsObj[3] : '', custom_regex: controlData.validationDetailsObj[10] ? ([controlData.validationDetailsObj[10]['source'],controlData.queDetails.st_question_hint]) : ''}"
                    data-vv-as="above"
                    @input="controlData.validationDetailsObj[1] ? (checkInput(controlData.queDetails.in_question_master_id, $event), skipLogicRuleDetails(controlData.skipLogic, index)) : skipLogicRuleDetails(controlData.skipLogic, index)"
                  />
                  <!-- <span class="bar"></span> -->
                  <span
                    v-show="errors.has('txt_'+controlData.queDetails.in_question_master_id)"
                    class="error"
                  >{{ errors.first('txt_'+controlData.queDetails.in_question_master_id) }}</span>
                </div>
                <!-- Single Line -->
                <div class="group" v-else-if="controlData.validationDetailsObj[6]">
                  <div v-if="controlData.validationDetailsObj[49]">
                    <input
                      type="hidden"
                      :key="'map'+controlData.queDetails.in_question_master_id"
                      :name="'map_'+controlData.queDetails.in_question_master_id"
                      v-model="previewSurveyData.chkSurveyQuestionDetails[''+controlData.queDetails.in_question_master_id]"
                      v-validate="{required: controlData.validationDetailsObj[1] ? true : false}"
                      data-vv-as="above"
                    />
                    <mapbox-autocomplete
                      :id="'map_'+controlData.queDetails.in_question_master_id"
                      :ref="'map_'+controlData.queDetails.in_question_master_id"
                      placeholder="Enter a location"
                      v-on="{placechanged: (addressData, placeResultData, id) => getAddressData(controlData.validationDetailsObj[1], addressData, placeResultData, id, controlData.queDetails.in_question_master_id), error: handleError, inputChange: (inputValue, id) => (onMapInputChange(inputValue, id, controlData.queDetails.in_question_master_id), skipLogicRuleDetails(controlData.skipLogic, index))}"
                    ></mapbox-autocomplete>
                    <span
                      v-show="errors.has('map_'+controlData.queDetails.in_question_master_id)"
                      class="error"
                    >{{ errors.first('map_'+controlData.queDetails.in_question_master_id) }}</span>
                  </div>
                  <div v-else>
                    <input
                      type="text"
                      placeholder="Answer here"
                      :name="'txt_'+controlData.queDetails.in_question_master_id"
                      v-model="previewSurveyData.chkSurveyQuestionDetails[''+controlData.queDetails.in_question_master_id]"
                      v-validate="{required: controlData.validationDetailsObj[1] ? true : false, min: controlData.validationDetailsObj[2] ? controlData.validationDetailsObj[2] : '', custom_max: controlData.validationDetailsObj[3] ? controlData.validationDetailsObj[3] : ''}"
                      data-vv-as="above"
                      @input="controlData.validationDetailsObj[1] ? (checkInput(controlData.queDetails.in_question_master_id, $event), skipLogicRuleDetails(controlData.skipLogic, index)) : skipLogicRuleDetails(controlData.skipLogic, index)"
                    />
                    <!-- <span class="highlight"></span> -->
                    <!-- <span class="bar"></span> -->
                    <!-- <label>{{controlData.queDetails.st_question_title}}</label> -->
                    <span
                      v-show="errors.has('txt_'+controlData.queDetails.in_question_master_id)"
                      class="error"
                    >{{ errors.first('txt_'+controlData.queDetails.in_question_master_id) }}</span>
                  </div>
                </div>
              </div>
              <div
                class="persnol-info-main qus_ans_sec"
                v-if="controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_DISPLAY"
              >
                <blockquote class="ludwig">
                  <div class="mb-10">
                    <label
                      class="persnol-info-title set-margin-zero"
                    >{{controlData.queDetails.st_question_title}}</label>
                    </div>
                </blockquote>
                    <!-- Display Text (Subtitle) -->
                <blockquote class="ludwig-subtitle" v-if="controlData.validationDetailsObj[11] ? previewSurveyData.chkSurveyQuestionDetails[''+controlData.queDetails.in_question_master_id] = controlData.validationDetailsObj[11] : ''">
                  <div class="mb-10">
                    <p
                    >{{controlData.validationDetailsObj[11]}}</p>
                  </div>
                </blockquote>
              </div>
              <!-- END for text question type -->
              <!-- ********************* -->
              <!-- START for List question type -->
              <div class="qus_ans_sec" v-if="controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_LIST || controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_DYNAMIC_LIST" :class="{ 'red-border': (errors.has('multiselect_'+controlData.queDetails.in_question_master_id) || errors.has('map_'+controlData.queDetails.in_question_master_id) || errors.has('chkOther_'+controlData.queDetails.in_question_master_id)) }">
                <label class="persnol-info-title">
                  <span
                    class="error"
                  >{{controlData.validationDetailsObj[1] ? '*' : ''}}</span>{{controlData.queDetails.in_question_number + '.'}}
                  {{controlData.queDetails.st_question_title}}
                </label>
                <div class="answer_sec">
                  <multi-select
                    :name="'multiselect_'+controlData.queDetails.in_question_master_id"
                    v-model="previewSurveyData.chkSurveyQuestionDetails[''+controlData.queDetails.in_question_master_id]"
                    tag-placeholder="Add this as new option"
                    placeholder="Answer here"
                    deselect-label="Can't remove this value"
                    :options="emojiSplitJoin(controlData.validationDetailsObj[6], '\n', controlData.validationDetailsObj['extra']['lat'], controlData.validationDetailsObj['extra']['lng'], controlData.validationDetailsObj['extra']['score'], controlData.queDetails.in_question_type_id)"
                    v-validate="{required: controlData.validationDetailsObj[1] ? true : false}"
                    data-vv-as="above"
                    v-on="{input : (selectedOption, id) => (checkMultipleChoice(selectedOption, id, controlData.queDetails.in_question_master_id, index, controlData.validationDetailsObj[1], skipLogicRuleDetails(controlData.skipLogic, index)))}"
                    track-by="formatted_address"
                    label="formatted_address"
                    :allow-empty="false"
                  ></multi-select>
                  <span
                    v-show="errors.has('multiselect_'+controlData.queDetails.in_question_master_id)"
                    class="error"
                  >{{ errors.first('multiselect_'+controlData.queDetails.in_question_master_id) }}</span>
                </div>
                <div class="persnol-info-main" v-if="controlData.queDetails.other">
                  <div class="group list-qus-sec" v-if="controlData.validationDetailsObj[49]">
                    <input
                      type="hidden"
                      :key="'map'+controlData.queDetails.in_question_master_id"
                      :name="'map_'+controlData.queDetails.in_question_master_id"
                      v-model="previewSurveyData['chkOtherMulChoice'][''+controlData.queDetails.in_question_master_id]"
                      v-validate="{required: controlData.validationDetailsObj[1] ? true : false}"
                      data-vv-as="above"
                    />
                    <mapbox-autocomplete
                      :id="'map_'+controlData.queDetails.in_question_master_id"
                      :ref="'map_'+controlData.queDetails.in_question_master_id"
                      placeholder="Enter a location"
                      v-on="{placechanged: (addressData, placeResultData, id) => getAddressData(controlData.validationDetailsObj[1], addressData, placeResultData, id, controlData.queDetails.in_question_master_id, controlData.queDetails.in_question_type_id), error: handleError, inputChange: (inputValue, id) => (onMapInputChange(inputValue, id, controlData.queDetails.in_question_master_id, controlData.queDetails.in_question_type_id), skipLogicRuleDetails(controlData.skipLogic, index))}"
                    ></mapbox-autocomplete>
                    <span
                      v-show="errors.has('map_'+controlData.queDetails.in_question_master_id)"
                      class="error"
                    >{{ errors.first('map_'+controlData.queDetails.in_question_master_id) }}</span>
                  </div>
                  <div class="group list-qus-sec" v-else>
                    <input
                      type="text"
                      :name="'chkOther_'+controlData.queDetails.in_question_master_id"
                      data-vv-as="above"
                      class="pac-target-input"
                      v-validate="{required: true,max:80}"
                      placeholder="Enter your other answer"
                      @input="controlData.validationDetailsObj[1] ? (checkInput(controlData.queDetails.in_question_master_id, $event), skipLogicRuleDetails(controlData.skipLogic, index),checkListOther(controlData.queDetails.in_question_master_id, $event)) : (checkListOther(controlData.queDetails.in_question_master_id, $event),skipLogicRuleDetails(controlData.skipLogic, index))"
                    />
                    <!-- <span class="bar"></span> -->
                    <div>
                      <span
                        v-show="errors.has('chkOther_'+controlData.queDetails.in_question_master_id)"
                        class="error"
                      >{{ errors.first('chkOther_'+controlData.queDetails.in_question_master_id) }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- END for List question type -->
              <!-- ********************* -->
              <!-- START for email question type -->
              <div
                class="persnol-info-main qus_ans_sec"
                :class="{ 'red-border': errors.has('txt_email_'+controlData.queDetails.in_question_master_id) }"
                v-if="controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_EMAIL"
              >
                <label class="persnol-info-title">
                  <span
                    class="error"
                  >{{controlData.validationDetailsObj[1] ? '*' : ''}}</span>{{controlData.queDetails.in_question_number + '.'}}
                  {{controlData.queDetails.st_question_title}}
                </label>
                <div class="group email_sec">
                  <i aria-hidden="true" class="fas fa-envelope"></i>
                  <input
                    type="text"
                    placeholder="Answer here"
                    :name="'txt_email_'+controlData.queDetails.in_question_master_id"
                    v-model="previewSurveyData.chkSurveyQuestionDetails[''+controlData.queDetails.in_question_master_id]"
                    v-validate="{required: controlData.validationDetailsObj[1] ? true : false, email: true}"
                    data-vv-as="above"
                    :data-email-survey="controlData.validationDetailsObj[22]"
                    @input="controlData.validationDetailsObj[1] ? (checkInput(controlData.queDetails.in_question_master_id, $event), skipLogicRuleDetails(controlData.skipLogic, index)) : skipLogicRuleDetails(controlData.skipLogic, index)"
                    @blur="validateEmail('txt_email_'+controlData.queDetails.in_question_master_id, $event)"
                  />
                  <!-- <span class="bar"></span> -->
                  <span
                    v-show="errors.has('txt_email_'+controlData.queDetails.in_question_master_id)"
                    class="error"
                  >{{ errors.first('txt_email_'+controlData.queDetails.in_question_master_id) }}</span>
                </div>
              </div>
              <!-- END email question type -->
              <!-- ********************* -->
              <!-- START for two choices question type -->
              <div
                class="selection-gender qus_ans_sec"
                :class="{ 'red-border': errors.has('rb_'+controlData.queDetails.in_question_master_id) }"
                v-if="controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_YES_NO || controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_TRUE_FALSE || controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_OTHER"
              >
                <label class="persnol-info-title">
                  <span
                    class="error"
                  >{{controlData.validationDetailsObj[1] ? '*' : ''}}</span>{{controlData.queDetails.in_question_number + '.'}}
                  {{controlData.queDetails.st_question_title}}
                </label>
                <div class="group">
                <label class="selection-main">
                  {{(controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_YES_NO) ? 'Yes' : (controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_TRUE_FALSE) ? 'True' : controlData.validationDetailsObj[40]}}
                  <input
                    type="radio"
                    :name="'rb_'+controlData.queDetails.in_question_master_id"
                    v-model="previewSurveyData.chkSurveyQuestionDetails[''+controlData.queDetails.in_question_master_id]"
                    v-validate="{required: controlData.validationDetailsObj[1] ? true : false}"
                    data-vv-as="above"
                    :value="{value: (controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_YES_NO) ? 'yes' : (controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_TRUE_FALSE) ? 'true' : controlData.validationDetailsObj[40], score: (controlData.validationDetailsObj['extra'] && controlData.validationDetailsObj['extra'][0] ? controlData.validationDetailsObj['extra'][0]['score'] : '')}"
                    @input="controlData.validationDetailsObj[1] ? (checkInput(controlData.queDetails.in_question_master_id, $event)) : '' "
                    @click="uncheck(controlData.queDetails.in_question_master_id, (controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_YES_NO) ? 'yes' : (controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_TRUE_FALSE) ? 'true' : controlData.validationDetailsObj[40]); skipLogicRuleDetails(controlData.skipLogic, index)"
                  />
                  <span class="checkmark-new checkradio-new"></span>
                </label>
                <label class="selection-main">
                  {{(controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_YES_NO) ? 'No' : (controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_TRUE_FALSE) ? 'False' : controlData.validationDetailsObj[41]}}
                  <input
                    type="radio"
                    :name="'rb_'+controlData.queDetails.in_question_master_id"
                    v-model="previewSurveyData.chkSurveyQuestionDetails[''+controlData.queDetails.in_question_master_id]"
                    :value="{value: (controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_YES_NO) ? 'no' : (controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_TRUE_FALSE) ? 'false' : controlData.validationDetailsObj[41], score: (controlData.validationDetailsObj['extra'] && controlData.validationDetailsObj['extra'][1] ? controlData.validationDetailsObj['extra'][1]['score'] : '')}"
                    @input="controlData.validationDetailsObj[1] ? (checkInput(controlData.queDetails.in_question_master_id, $event)) : '' "
                    @click="uncheck(controlData.queDetails.in_question_master_id, (controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_YES_NO) ? 'no' : (controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_TRUE_FALSE) ? 'false' : controlData.validationDetailsObj[41]); skipLogicRuleDetails(controlData.skipLogic, index)"
                  />
                  <span class="checkmark-new checkradio-new"></span>
                </label>
                <div>
                  <span
                    v-show="errors.has('rb_'+controlData.queDetails.in_question_master_id)"
                    class="error"
                  >{{ errors.first('rb_'+controlData.queDetails.in_question_master_id) }}</span>
                </div>
                </div>
              </div>
              <!-- END for two choices question type -->
              <!-- ********************* -->
              <!-- START Number question type -->
              <div
                class="persnol-info-main qus_ans_sec"
                :class="{ 'red-border': errors.has('txt_number_'+controlData.queDetails.in_question_master_id) }"
                v-if="controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_CURRENCY || controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_NUMBER"
              >
                <label class="persnol-info-title">
                  <span
                    class="error"
                  >{{controlData.validationDetailsObj[1] ? '*' : ''}}</span>{{controlData.queDetails.in_question_number + '.'}}
                  {{controlData.queDetails.st_question_title}}
                </label>
                <!-- Currency and Numbers -->
                <div class="group">
                  <span
                    class="currency"
                    v-if="controlData.validationDetailsObj[27]"
                  >{{controlData.validationDetailsObj[27]}}</span>
                  <input
                    type="text"
                    placeholder="Answer here"
                    :name="'txt_number_'+controlData.queDetails.in_question_master_id"
                    v-model="previewSurveyData.chkSurveyQuestionDetails[''+controlData.queDetails.in_question_master_id]"
                    v-validate="{required: controlData.validationDetailsObj[1] ? true : false, decimal: controlData.validationDetailsObj[28] ? 2 : false, integer: controlData.validationDetailsObj[28] ? false : true, custom_min_value: controlData.validationDetailsObj[4] ? controlData.validationDetailsObj[4] : '', custom_max_value: controlData.validationDetailsObj[5] ? controlData.validationDetailsObj[5] : ''}"
                    data-vv-as="above"
                    @input="controlData.validationDetailsObj[1] ? (checkInput(controlData.queDetails.in_question_master_id, $event), skipLogicRuleDetails(controlData.skipLogic, index)) : skipLogicRuleDetails(controlData.skipLogic, index)"
                    :style="{ 'padding-left': controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_CURRENCY ? '60px' : '20px'}"
                  />
                  <!-- <span class="bar"></span> -->
                  <span
                    v-show="errors.has('txt_number_'+controlData.queDetails.in_question_master_id)"
                    class="error"
                  >{{ errors.first('txt_number_'+controlData.queDetails.in_question_master_id) }}</span>
                </div>
              </div>
              <div
                class="persnol-info-main qus_ans_sec"
                :class="{ 'red-border': errors.has('txt_number_'+controlData.queDetails.in_question_master_id) }"
                v-if="controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_TELEPHONE"
              >
                <label class="persnol-info-title">
                  <span
                    class="error"
                  >{{controlData.validationDetailsObj[1] ? '*' : ''}}</span>{{controlData.queDetails.in_question_number + '.'}}
                  {{controlData.queDetails.st_question_title}}
                  <a
                    @click.prevent
                    data-toggle="tooltip"
                    data-placement="top"
                    v-if="controlData.queDetails.st_question_hint != null"
                  >
                    <i
                      class="fa fa-info-circle"
                      v-tooltip.right="controlData.queDetails.st_question_hint"
                    ></i>
                  </a>
                </label>
                <!-- Telephone -->
                <div class="group">
                  {{controlData.validationDetailsObj[27] ? controlData.validationDetailsObj[27] : ''}}
                  <i class="fa fa-phone"></i>
                  <input
                    type="text"
                    placeholder="Answer here"
                    :name="'txt_number_'+controlData.queDetails.in_question_master_id"
                    v-model="previewSurveyData.chkSurveyQuestionDetails[''+controlData.queDetails.in_question_master_id]"
                    v-validate="{required: controlData.validationDetailsObj[1] ? true : false, min: controlData.validationDetailsObj[2] ? controlData.validationDetailsObj[2] : '', custom_max: controlData.validationDetailsObj[3] ? controlData.validationDetailsObj[3] : '',  custom_regex: controlData.validationDetailsObj[26] ? ([controlData.validationDetailsObj[26]['source'],controlData.queDetails.st_question_hint]) : ['^[0-9]+$', 'Allowed characters: 0-9'] }"
                    data-vv-as="above"
                    @input="controlData.validationDetailsObj[1] ? (checkInput(controlData.queDetails.in_question_master_id, $event), skipLogicRuleDetails(controlData.skipLogic, index)) : skipLogicRuleDetails(controlData.skipLogic, index)"
                  />
                  <!-- <span class="bar"></span> -->
                  <span
                    v-show="errors.has('txt_number_'+controlData.queDetails.in_question_master_id)"
                    class="error"
                  >{{ errors.first('txt_number_'+controlData.queDetails.in_question_master_id) }}</span>
                </div>
              </div>
              <!-- END for Number question type -->
              <!-- ********************* -->
              <!-- START Terms & Condition question type -->
              <div
                class="persnol-info-main selection-gender qus_ans_sec term-sec"
                :class="{ 'red-border': errors.has('rb_'+controlData.queDetails.in_question_master_id) }"
                v-if="controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_TERMS_AND_CONDITIONS"
              >
                <label class="persnol-info-title">
                  <span
                    class="error"
                  >{{controlData.validationDetailsObj[1] ? '*' : ''}}</span>{{controlData.queDetails.in_question_number + '.'}}
                  {{controlData.queDetails.st_question_title}}
                </label>
                <!-- <div id="bw-step-3" class="tab-pane step-content" style="display: block; margin-bottom: 20px;" v-if="controlData.validationDetailsObj[12]">
                  <div class="card">
                    <div class="card-header d-flex align-items-center justify-content-between">
                      <b class="m-0"><span>Description</span></b>
                    </div>
                    <div class="card-body">
                      <pre class="formatText">
                        {{controlData.validationDetailsObj[12]}}
                      </pre>
                    </div>
                  </div>
                </div>-->
                <div class="group">
                  <div class="text-wrap-new" v-if="controlData.validationDetailsObj[12]">
                    <textarea rows="5" class="form-control" readonly>{{controlData.validationDetailsObj[12]}}</textarea>
                  </div>
                  <label
                    class="selection-main"
                    v-for="(val, i) in controlData.validationDetailsObj[19]"
                    :key="i"
                  >
                    {{val}}
                    <input
                      type="radio"
                      :name="'rb_'+controlData.queDetails.in_question_master_id"
                      v-model="previewSurveyData.chkSurveyQuestionDetails[''+controlData.queDetails.in_question_master_id]"
                      v-validate="{required: controlData.validationDetailsObj[1] ? true : false}"
                      data-vv-as="above"
                      :value="val"
                      @input="controlData.validationDetailsObj[1] ? (checkInput(controlData.queDetails.in_question_master_id, $event)) : '' "
                      @click="uncheck(controlData.queDetails.in_question_master_id, val); skipLogicRuleDetails(controlData.skipLogic, index)"
                    />
                    <span class="checkmark-new checkradio-new"></span>
                  </label>
                </div>
                
                <div>
                  <span
                    v-show="errors.has('rb_'+controlData.queDetails.in_question_master_id)"
                    class="error"
                  >{{ errors.first('rb_'+controlData.queDetails.in_question_master_id) }}</span>
                </div>
              </div>
              <!-- END for Terms & Condition question type -->
              <!-- ********************* -->
              <!-- START Date question type -->
              <div
                class="persnol-info-main qus_ans_sec"
                :class="{ 'red-border': errors.has('datepicker_'+controlData.queDetails.in_question_master_id) }"
                v-if="controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_DATE"
              >
                <label class="persnol-info-title">
                  <span
                    class="error"
                  >{{controlData.validationDetailsObj[1] ? '*' : ''}}</span>{{controlData.queDetails.in_question_number + '.'}}
                  {{controlData.queDetails.st_question_title}}
                </label>
                <div class="group">
                  <date-picker
                    value-type="format"
                    v-model="previewSurveyData.chkSurveyQuestionDetails[''+controlData.queDetails.in_question_master_id]"
                    v-validate="{required: controlData.validationDetailsObj[1] ? true : false}"
                    :name="'datepicker_'+controlData.queDetails.in_question_master_id"
                    :not-before="controlData.validationDetailsObj[30] ? controlData.validationDetailsObj[30] : ''"
                    :not-after="controlData.validationDetailsObj[31] ? controlData.validationDetailsObj[31] : ''"
                    :format="controlData.validationDetailsObj[42] ? controlData.validationDetailsObj[42] : 'DD-MM-YYYY' "
                    :first-day-of-week="1"
                    :lang="lang"
                    data-vv-as="above"
                    data-id="date_field"
                    v-on="{ input: controlData.validationDetailsObj[1] ? (currentValue) => (checkDateTimePicker(currentValue, controlData.queDetails.in_question_master_id)) : null }"
                    input-class
                    @change="skipLogicRuleDetails(controlData.skipLogic, index)"
                  ></date-picker>
                  <div>
                    <span
                      v-show="errors.has('datepicker_'+controlData.queDetails.in_question_master_id)"
                      class="error"
                    >{{ errors.first('datepicker_'+controlData.queDetails.in_question_master_id) }}</span>
                  </div>
                </div>
              </div>
              <!-- END for Date question type -->
              <!-- START Time question type -->
              <div
                class="persnol-info-main qus_ans_sec"
                :class="{ 'red-border': errors.has('timepicker_'+controlData.queDetails.in_question_master_id) }"
                v-if="controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_12_HOURS || controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_24_HOURS"
              >
                <label class="persnol-info-title">
                  <span
                    class="error"
                  >{{controlData.validationDetailsObj[1] ? '*' : ''}}</span>{{controlData.queDetails.in_question_number + '.'}}
                  {{controlData.queDetails.st_question_title}}
                </label>
                <div class="group timepicker-container" v-if="!previewSurveyData.chkSurveyQuestionDetails[''+controlData.queDetails.in_question_master_id] ? (previewSurveyData.chkSurveyQuestionDetails[''+controlData.queDetails.in_question_master_id] = moment().format('HH:mm:ss'), true) : true">
                  <!-- <span class="mx-input-append">
                    <svg height="512pt" viewBox="0 0 512 512" width="512pt" xmlns="http://www.w3.org/2000/svg"><path d="m256 0c-141.164062 0-256 114.835938-256 256s114.835938 256 256 256 256-114.835938 256-256-114.835938-256-256-256zm121.75 388.414062c-4.160156 4.160157-9.621094 6.253907-15.082031 6.253907-5.460938 0-10.925781-2.09375-15.082031-6.253907l-106.667969-106.664062c-4.011719-3.988281-6.25-9.410156-6.25-15.082031v-138.667969c0-11.796875 9.554687-21.332031 21.332031-21.332031s21.332031 9.535156 21.332031 21.332031v129.835938l100.417969 100.414062c8.339844 8.34375 8.339844 21.824219 0 30.164062zm0 0"/></svg>
                  </span>
                  <boot-date-picker
                    :model.sync="previewSurveyData.chkSurveyQuestionDetails[''+controlData.queDetails.in_question_master_id]"
                    :requiredValidation="controlData.validationDetailsObj[1]"
                    :minDate="controlData.validationDetailsObj[32]"
                    :maxDate="controlData.validationDetailsObj[33]"
                    :surQuesTypeId="controlData.queDetails.in_question_type_id"
                    :surQuesMasterId="controlData.queDetails.in_question_master_id"
                    :componentName="'timepicker_'+controlData.queDetails.in_question_master_id"
                    :skipLogicData="controlData.skipLogic"
                    :currentIndex="index"
                  ></boot-date-picker> -->
                  
                  <!-- <date-picker
                    type="time"
                    v-model="previewSurveyData.chkSurveyQuestionDetails[''+controlData.queDetails.in_question_master_id]"
                    v-validate="{required: controlData.validationDetailsObj[1] ? true : false}"
                    :name="'timepicker_'+controlData.queDetails.in_question_master_id"
                    :not-before="controlData.validationDetailsObj[32] ? controlData.validationDetailsObj[32] : ''"
                    :not-after="controlData.validationDetailsObj[33] ? controlData.validationDetailsObj[33] : ''"
                    :format="controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_12_HOURS ? timeFormat12 : timeFormat24"
                    :time-picker-options=" timePickerOptions"
                    placeholder="Select Time"
                    data-vv-as="above"
                    v-on="{ input: controlData.validationDetailsObj[1] ? (currentValue) => checkDateTimePicker(currentValue, controlData.queDetails.in_question_master_id) : null }"
                    input-class
                  ></date-picker>-->
                  <!-- {{previewSurveyData.chkSurveyQuestionDetails[''+controlData.queDetails.in_question_master_id]}}
                  {{controlData.validationDetailsObj[32]}}
                  {{controlData.validationDetailsObj[33]}} -->
                  <v-app>
                    <v-dialog
                      :ref="'dialog_'+controlData.queDetails.in_question_master_id"
                      v-model="timePickerObject[controlData.queDetails.in_question_master_id]"
                      :return-value.sync="previewSurveyData.chkSurveyQuestionDetails[''+controlData.queDetails.in_question_master_id]"
                      persistent
                      width="330px"
                    >
                      <!-- v-if="!previewSurveyData.chkSurveyQuestionDetails[''+controlData.queDetails.in_question_master_id] ? (previewSurveyData.chkSurveyQuestionDetails[''+controlData.queDetails.in_question_master_id] = null, true) : true" -->
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          solo
                          single-line
                          v-model="tempTimePickerValue[''+controlData.queDetails.in_question_master_id]"
                          v-validate="{required: controlData.validationDetailsObj[1] ? true : false}"
                          :name="'timepicker_'+controlData.queDetails.in_question_master_id"
                          @click:clear="clearTimepickerValue(controlData.queDetails.in_question_master_id, controlData.validationDetailsObj[1], controlData.skipLogic, index)"
                          v-bind="attrs"
                          v-on="on"
                          data-vv-as="above"
                          label="Select Time"
                          prepend-inner-icon="mdi-clock"
                          readonly
                          clearable
                          hide-details="auto"
                          rounded
                        ></v-text-field>
                      </template>
                        <!-- v-model="time" -->
                      <v-time-picker
                        v-if="timePickerObject[controlData.queDetails.in_question_master_id]"
                        v-model="previewSurveyData.chkSurveyQuestionDetails[''+controlData.queDetails.in_question_master_id]"
                        v-on="{ input: controlData.validationDetailsObj[1] ? (currentValue) => (checkDateTimePicker(currentValue, controlData.queDetails.in_question_master_id)) : null }"
                        :format="controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_12_HOURS ? 'ampm' : '24hr'"
                        :min="controlData.validationDetailsObj[32] ? controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_12_HOURS ? moment(controlData.validationDetailsObj[32], timeFormat12).format(timeFormat24) : controlData.validationDetailsObj[32]
                          : undefined"
                        :max="controlData.validationDetailsObj[33] ? controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_12_HOURS ? moment(controlData.validationDetailsObj[33], timeFormat12).format(timeFormat24) : controlData.validationDetailsObj[33]
                          : undefined"
                        use-seconds
                        full-width
                        ampm-in-title
                      >
                        <!-- :value="controlData.validationDetailsObj[33] ? controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_12_HOURS ? moment(controlData.validationDetailsObj[33], timeFormat12).format(timeFormat24) : controlData.validationDetailsObj[33] : controlData.validationDetailsObj[32] ? controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_12_HOURS ? moment(controlData.validationDetailsObj[32], timeFormat12).format(timeFormat24) : controlData.validationDetailsObj[32] : undefined" -->
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="unsetTimePickerValue(controlData.queDetails.in_question_master_id)">
                          Cancel
                        </v-btn>
                        <v-btn text color="primary" @click="setTimePickerValue(2, controlData.queDetails.in_question_type_id, controlData.queDetails.in_question_master_id, controlData.skipLogic, index)">
                          OK
                        </v-btn>
                      </v-time-picker>
                    </v-dialog>
                  </v-app>
                  <div>
                    <span
                      v-show="errors.has('timepicker_'+controlData.queDetails.in_question_master_id)"
                      class="error"
                    >{{ errors.first('timepicker_'+controlData.queDetails.in_question_master_id) }}</span>
                  </div>
                </div>
              </div>
              <!-- END for Time question type -->
              <!-- ********************* -->
              <!-- START Multiple choice question type - Text -->
              <!-- Allow more than one answer -> checkbox else radio button -->
              <div
                class="selection-gender qus_ans_sec"
                :class="{ 'red-border': (errors.has('chk_'+controlData.queDetails.in_question_master_id) || errors.has('map_'+controlData.queDetails.in_question_master_id) || errors.has('chkOther_'+controlData.queDetails.in_question_master_id)) }"
                v-if="controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_MULTIPLE_TEXT"
              >
                <label class="persnol-info-title">
                  <span
                    class="error"
                  >{{controlData.validationDetailsObj[1] ? '*' : ''}}</span>{{controlData.queDetails.in_question_number + '.'}}
                  {{controlData.queDetails.st_question_title}}
                </label>
                <!-- {{previewSurveyData.chkMapMulChoice}} -->
                <!-- {{previewSurveyData.chkSurveyQuestionDetails}} -->
                <div class="group">
                <label
                  class="check-label"
                  v-for="(val, i) in controlData.validationDetailsObj[14]"
                  :key="i"
                >
                  {{val.answer}}
                  <input
                    :type="controlData.validationDetailsObj[20] ? 'checkbox' : 'radio'"
                    :name="'chk_'+controlData.queDetails.in_question_master_id"
                    v-validate="{required: controlData.validationDetailsObj[1] ? true : false}"
                    data-vv-as="above"
                    :value="val.answer"
                    :checked="previewSurveyData['chkMapMulChoice'][controlData.queDetails.in_question_master_id] && (previewSurveyData['chkMapMulChoice'][controlData.queDetails.in_question_master_id].formatted_address == val.answer  || ( !previewSurveyData['chkMapMulChoice'][controlData.queDetails.in_question_master_id].formatted_address && (previewSurveyData['chkMapMulChoice'][controlData.queDetails.in_question_master_id]).map(y=>y['formatted_address']).includes(val.answer) ) ) ? true : false"
                    @click="checkOtherAnswer(index, controlData.queDetails.in_question_master_id, controlData.validationDetailsObj[49], $event); skipLogicRuleDetails(controlData.skipLogic, index)"
                    @change="controlData.validationDetailsObj[1] ? (checkCheckbox(controlData.queDetails.in_question_master_id, $event), setModelValueForMultipleAns(controlData.queDetails.in_question_master_id, controlData.validationDetailsObj[20], $event)) : setModelValueForMultipleAns(controlData.queDetails.in_question_master_id, controlData.validationDetailsObj[20], $event)"
                    :data-lat="val.lat"
                    :data-lng="val.lng"
                    :data-score="val.score"
                  />
                  <span class="checkmark check-mark-two"></span>
                </label>
                <!-- Allow other answer -->
                <label class="check-label" v-if="controlData.validationDetailsObj[13]">
                  Other
                  <input
                    :type="controlData.validationDetailsObj[20] ? 'checkbox' : 'radio'"
                    :name="'chk_'+controlData.queDetails.in_question_master_id"
                    v-validate="{required: controlData.validationDetailsObj[1] ? true : false}"
                    data-vv-as="above"
                    value="Other"
                    :checked="controlData.queDetails.other ? true : false"
                    @click="(checkOtherAnswer(index, controlData.queDetails.in_question_master_id, controlData.validationDetailsObj[49], $event), skipLogicRuleDetails(controlData.skipLogic, index))"
                    @change="controlData.validationDetailsObj[1] ? (checkCheckbox(controlData.queDetails.in_question_master_id, $event), skipLogicRuleDetails(controlData.skipLogic, index), setModelValueForMultipleAns(controlData.queDetails.in_question_master_id, controlData.validationDetailsObj[20], $event)) : (skipLogicRuleDetails(controlData.skipLogic, index), setModelValueForMultipleAns(controlData.queDetails.in_question_master_id, controlData.validationDetailsObj[20], $event))"
                  />
                  <span class="checkmark check-mark-two"></span>
                </label>
                <div>
                  <span
                    v-show="errors.has('chk_'+controlData.queDetails.in_question_master_id)"
                    class="error"
                  >{{ errors.first('chk_'+controlData.queDetails.in_question_master_id) }}</span>
                </div>
                <div class="persnol-info-main other-opt" v-if="controlData.queDetails.other">
                  <div class="group" v-if="controlData.validationDetailsObj[49]">
                    <input
                      type="hidden"
                      :key="'map'+controlData.queDetails.in_question_master_id"
                      :name="'map_'+controlData.queDetails.in_question_master_id"
                      v-model="previewSurveyData['chkOtherMulChoice'][''+controlData.queDetails.in_question_master_id]"
                      v-validate="{required: controlData.validationDetailsObj[1] ? true : false}"
                      data-vv-as="above"
                    />
                    <mapbox-autocomplete
                      :id="'map_'+controlData.queDetails.in_question_master_id"
                      :ref="'map_'+controlData.queDetails.in_question_master_id"
                      :data-score="controlData.validationDetailsObj[13] ? controlData.validationDetailsObj[13][0]['score'] : ''"
                      placeholder="Enter a location"
                      v-on="{placechanged: (addressData, placeResultData, id) => getAddressData(controlData.validationDetailsObj[1], addressData, placeResultData, id, controlData.queDetails.in_question_master_id, controlData.queDetails.in_question_type_id), error: handleError, inputChange: (inputValue, id) => (  (inputValue, id, controlData.queDetails.in_question_master_id, controlData.queDetails.in_question_type_id), skipLogicRuleDetails(controlData.skipLogic, index))}"
                    ></mapbox-autocomplete>
                    <span
                      v-show="errors.has('map_'+controlData.queDetails.in_question_master_id)"
                      class="error"
                    >{{ errors.first('map_'+controlData.queDetails.in_question_master_id) }}</span>
                  </div>
                  <div class="group list-qus-sec" v-else>
                    <input
                      type="text"
                      :name="'chkOther_'+controlData.queDetails.in_question_master_id"
                      :data-score="controlData.validationDetailsObj[13] ? controlData.validationDetailsObj[13][0]['score'] : ''"
                      :value="previewSurveyData['chkOtherMulChoice'][''+controlData.queDetails.in_question_master_id] ? previewSurveyData['chkOtherMulChoice'][''+controlData.queDetails.in_question_master_id].formatted_address : ''"
                      data-vv-as="above"
                      class="pac-target-input"
                      v-validate="{required: true,max:80}"
                      placeholder="Enter your other answer"
                      @input="controlData.validationDetailsObj[1] ? (checkInput(controlData.queDetails.in_question_master_id, $event), checkOtherAnswer(index, controlData.queDetails.in_question_master_id, controlData.validationDetailsObj[49], $event)) : checkOtherAnswer(index, controlData.queDetails.in_question_master_id, controlData.validationDetailsObj[49], $event)"
                    />
                    <!-- <span class="bar"></span> -->
                    <div>
                      <span
                        v-show="errors.has('chkOther_'+controlData.queDetails.in_question_master_id)"
                        class="error"
                      >{{ errors.first('chkOther_'+controlData.queDetails.in_question_master_id) }}</span>
                    </div>
                  </div>
                  </div>
                </div>
              </div>
              <!-- Multiple choice question type - Image -->
                <!-- class="image-selection multichoicequs-sec" -->
              <div
                class="image-selection multichoicequs-sec"
                :class="{ 'red-border': (errors.has('chk_image_'+controlData.queDetails.in_question_master_id) || errors.has('chkOther_image_'+controlData.queDetails.in_question_master_id)) }"
                v-if="controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_MULTIPLE_IMAGE"
              >
                <label class="persnol-info-title">
                  <span
                    class="error"
                  >{{controlData.validationDetailsObj[1] ? '*' : ''}}</span>{{controlData.queDetails.in_question_number + '.'}}
                  {{controlData.queDetails.st_question_title}}
                </label>
                <label class="selectonelabel" v-if="!controlData.validationDetailsObj[20]">Select One</label>
                <div class="row">
                  <div 
                    class="col-md-3"
                    v-for="(imageValue, imageIndex) in controlData.validationDetailsObj[15]"
                  >
                  <div :class="(controlData.validationDetailsObj[20] && previewSurveyData.chkSurveyQuestionDetails[''+controlData.queDetails.in_question_master_id] && previewSurveyData.chkSurveyQuestionDetails[''+controlData.queDetails.in_question_master_id].includes(imageValue.s3ImagePath) || previewSurveyData.chkSurveyQuestionDetails[''+controlData.queDetails.in_question_master_id] == imageValue.s3ImagePath) ? 'multichoicequs-div active' : 'multichoicequs-div'">
                    <i class="checked-circle"></i>
                    <label class="imageContainer">
                      <input
                        :type="controlData.validationDetailsObj[20] ? 'checkbox' : 'radio'"
                        :name="'chk_image_'+controlData.queDetails.in_question_master_id"
                        v-validate="{required: controlData.validationDetailsObj[1] ? true : false}"
                        data-vv-as="above"
                        :value="imageValue.s3ImagePath"
                        class="hidden"
                        autocomplete="off"
                        @click="checkOtherAnswer(index, controlData.queDetails.in_question_master_id, true, $event)"
                        @change="controlData.validationDetailsObj[1] ? (checkCheckbox(controlData.queDetails.in_question_master_id, $event), skipLogicRuleDetails(controlData.skipLogic, index), setModelValueForMultipleAns(controlData.queDetails.in_question_master_id, controlData.validationDetailsObj[20], $event)) : (skipLogicRuleDetails(controlData.skipLogic, index), setModelValueForMultipleAns(controlData.queDetails.in_question_master_id, controlData.validationDetailsObj[20], $event))"
                        :data-score="imageValue.score"
                        :checked="tempPreviouslySelected[controlData.queDetails.in_question_master_id]===imageValue.s3ImagePath"
                      />
                      <img
                        :src="imageValue.dataURL"
                        alt="..."
                        class="profileImagePreview img-check"
                      />
                    </label>
                    <div class="multichoice-text text-center" v-if="controlData.validationDetailsObj[21] && imageValue.st_answer_label">
                      <span class="iteam-select">{{imageValue.st_answer_label}}</span>
                    </div>
                  </div>
                  </div>
                  <div class="col-md-3" v-if="controlData.validationDetailsObj[13]">
                    <div :class="(controlData.validationDetailsObj[20] && previewSurveyData.chkSurveyQuestionDetails[''+controlData.queDetails.in_question_master_id] && previewSurveyData.chkSurveyQuestionDetails[''+controlData.queDetails.in_question_master_id].includes('Other') || previewSurveyData.chkSurveyQuestionDetails[''+controlData.queDetails.in_question_master_id] == 'Other') ? 'multichoicequs-div other-block active' : 'multichoicequs-div other-block'">
                      <i class="checked-circle"></i>
                      <label class="imageContainer">
                        <input
                          :type="controlData.validationDetailsObj[20] ? 'checkbox' : 'radio'"
                          :key="'chkrb'+controlData.queDetails.in_question_master_id"
                          :name="'chk_image_'+controlData.queDetails.in_question_master_id"
                          v-validate="{required: controlData.validationDetailsObj[1] ? true : false}"
                          data-vv-as="above"
                          value="Other"
                          @click="checkOtherAnswer(index, controlData.queDetails.in_question_master_id, true, $event)"
                          @change="controlData.validationDetailsObj[1] ? (checkCheckbox(controlData.queDetails.in_question_master_id, $event), skipLogicRuleDetails(controlData.skipLogic, index), setModelValueForMultipleAns(controlData.queDetails.in_question_master_id, controlData.validationDetailsObj[20], $event)) : (skipLogicRuleDetails(controlData.skipLogic, index),  setModelValueForMultipleAns(controlData.queDetails.in_question_master_id, controlData.validationDetailsObj[20], $event))"
                          :checked="tempPreviouslySelected[controlData.queDetails.in_question_master_id]==='Other'"
                        />

                        <img
                          src="../../assets/images/other_image.png"
                          alt="..."
                          class="profileImagePreview img-check"
                        />
                      </label>
                      <div class="multichoice-text text-center" v-if="controlData.validationDetailsObj[21]">
                        <span class="iteam-select">Other</span>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Allow other answer -->
                <!-- <label class="check-label" v-if="controlData.validationDetailsObj[13]">
                  Other
                  <input
                    :type="controlData.validationDetailsObj[20] ? 'checkbox' : 'radio'"
                    :name="'chk_image_'+controlData.queDetails.in_question_master_id"
                    v-model="previewSurveyData.chkSurveyQuestionDetails[''+controlData.queDetails.in_question_master_id]"
                    v-validate="{required: controlData.validationDetailsObj[1] ? true : false}"
                    data-vv-as="above"
                    value="Other"
                    @click="checkOtherAnswer(index, controlData.queDetails.in_question_master_id, true, $event)"
                    @input="controlData.validationDetailsObj[1] ? checkCheckbox(controlData.queDetails.in_question_master_id, $event) : ''"
                  >
                  <span class="checkmark check-mark-two"></span>
                </label>-->
                <div>
                  <span
                    v-show="errors.has('chk_image_'+controlData.queDetails.in_question_master_id)"
                    class="error"
                  >{{ errors.first('chk_image_'+controlData.queDetails.in_question_master_id) }}</span>
                </div>
                <div class="persnol-info-main" v-if="controlData.queDetails.other">
                  <div class="group">
                    <input
                      type="text"
                      class="form-imput-text"
                      :name="'chkOther_image_'+controlData.queDetails.in_question_master_id"
                      data-vv-as="above"
                      :data-score="controlData.validationDetailsObj[13] ? controlData.validationDetailsObj[13][0]['score'] : ''"
                      :value="previewSurveyData['chkOtherMulChoice'][''+controlData.queDetails.in_question_master_id] ? previewSurveyData['chkOtherMulChoice'][''+controlData.queDetails.in_question_master_id].formatted_address : ''"
                      v-validate="{required: true,max:80}"
                      placeholder="Enter your other answer"
                      @input="checkOtherAnswer(quesNo, controlData.queDetails.in_question_master_id, controlData.validationDetailsObj[49], $event)"
                    />
                    <!-- <span class="bar"></span> -->
                    <div>
                      <span
                        v-show="errors.has('chkOther_image_'+controlData.queDetails.in_question_master_id)"
                        class="error"
                      >{{ errors.first('chkOther_image_'+controlData.queDetails.in_question_master_id) }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- END for Multiple choice question type -->
              <!-- ********************* -->
              <!-- START Image question type -->
              <div
                class="image-selection" style="padding: 0;"
                v-if="controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_IMAGE ? previewSurveyData.chkSurveyQuestionDetails[''+controlData.queDetails.in_question_master_id] = [] : 0"
              >
                <label class="persnol-info-title" v-if="controlData.validationDetailsObj[35]">
                  <span
                    class="error"
                  >{{controlData.validationDetailsObj[1] ? '*' : ''}}</span>
                  {{controlData.queDetails.st_question_title}}
                </label>
                <!-- In one column -->
                <div class="row" v-if="controlData.validationDetailsObj[34] == 0">
                  <div
                    :class="[controlData.validationDetailsObj[15].length == 1 ? 'col-md-12' : (controlData.validationDetailsObj[15].length == 2 ? 'col-md-6' : (controlData.validationDetailsObj[15].length == 3 ? 'col-md-4' : 'col-md-3'))]"
                    v-for="(imageValue, imageIndex) in controlData.validationDetailsObj[15]"
                    :key="imageIndex"
                  >
                  <div class="multichoicequs-div">
                    <label class="imageContainer">
                      <img
                        :src="imageValue.dataURL"
                        v-if="imageValue.dataURL && imageValue.s3ImagePath ? previewSurveyData.chkSurveyQuestionDetails[''+controlData.queDetails.in_question_master_id].push(imageValue.s3ImagePath) : ''"
                        alt="..."
                        class="profileImagePreview img-check"
                      />
                    </label>
                  </div>
                  </div>
                </div>
                <!-- In one row -->
                <div
                  class="row"
                  v-else
                  v-for="(imageValue, imageIndex) in controlData.validationDetailsObj[15]"
                  :key="imageIndex"
                >
                  <div class="col-md-12">
                    <label class="imageContainer single-img">
                      <img
                        :src="imageValue.dataURL"
                        v-if="imageValue.dataURL && imageValue.s3ImagePath ? previewSurveyData.chkSurveyQuestionDetails[''+controlData.queDetails.in_question_master_id].push(imageValue.s3ImagePath) : ''"
                        alt="..."
                        class="profileImagePreview img-check"
                      />
                    </label>
                  </div>
                </div>
              </div>
              <!-- END Image question type -->
              <!-- ********************* -->
              <!-- START Rating question type - Star Rating-->
              <div
                class="star-rating-wrap"
                :class="{ 'red-border': errors.has('rb_'+controlData.queDetails.in_question_master_id) }"
                v-if="controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_STAR ? emojiStarScore = emojiSplitJoin(controlData.validationDetailsObj['extra']['score'], '\n') : 0"
              >
                <label class="persnol-info-title">
                  <span
                    class="error"
                  >{{controlData.validationDetailsObj[1] ? '*' : ''}}</span>{{controlData.queDetails.in_question_number + '.'}}
                  {{controlData.queDetails.st_question_title}}
                </label>
                <label class="selectonelabel" v-if="!controlData.validationDetailsObj[20]">Select One</label>
                <fieldset class="rating">
                  <label
                    v-for="(rating, ind) in parseInt(controlData.validationDetailsObj[38])"
                    :key="ind"
                    v-bind:style="{ 'z-index': parseInt(controlData.validationDetailsObj[38]) - ind }"
                  >
                    <input
                      type="radio"
                      :id="'star'+(ind+1)"
                      :key="'rb'+controlData.queDetails.in_question_master_id"
                      :name="'rb_'+controlData.queDetails.in_question_master_id"
                      v-model="previewSurveyData.chkSurveyQuestionDetails[''+controlData.queDetails.in_question_master_id]"
                      v-validate="{required: ind == 0 && controlData.validationDetailsObj[1] ? true : false}"
                      :value="{value: ind+1, score: (emojiStarScore[ind]) ? emojiStarScore[ind] : ''}"
                      data-vv-as="above"
                      @input="emojiStarScore = emojiSplitJoin(controlData.validationDetailsObj['extra']['score'], '\n'),(controlData.validationDetailsObj[1] ? (checkInput(controlData.queDetails.in_question_master_id, $event), skipLogicRuleDetails(controlData.skipLogic, index)) : skipLogicRuleDetails(controlData.skipLogic, index))"
                    />
                    <span class="icon" v-for="i in (ind+1)" :key="i">&#9733;</span>
                  </label>
                  <!-- <span v-for="(rating, ind) in parseInt(controlData.validationDetailsObj[38])">
                    <input
                      :key="'rb'+controlData.queDetails.in_question_master_id"
                      type="radio"
                      :id="'star'+(controlData.queDetails.in_question_master_id+ind+1)"
                      :name="'rb_'+controlData.queDetails.in_question_master_id"
                      v-validate="{required: ind == 0 && controlData.validationDetailsObj[1] ? true : false}"
                      :value="ind+1"
                      :data-score="(emojiStarScore[ind]) ? emojiStarScore[ind] : ''"
                      data-vv-as="above"
                      @click="onStarAndEmojiClick(controlData.queDetails.in_question_master_id, $event)"
                      @input="controlData.validationDetailsObj[1] ? checkInput(controlData.queDetails.in_question_master_id, $event) : ''"
                    >
                    <label
                      class="full"
                      :for="'star'+(controlData.queDetails.in_question_master_id
                    +ind+1)"
                      :title="ind+1"
                    ></label>
                  </span>-->
                </fieldset>
                <div>
                  <span
                    v-show="errors.has('rb_'+controlData.queDetails.in_question_master_id)"
                    class="error"
                  >{{ errors.first('rb_'+controlData.queDetails.in_question_master_id) }}</span>
                </div>
              </div>
              <!-- START Rating question type - Satisfaction Rating-->
              <div
                class="emoji-rates-wrap image-selection"
                :class="{ 'red-border': errors.has('chk_satis_'+controlData.queDetails.in_question_master_id) }"
                v-if="controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_SATISFACTION ? emojiScore = emojiSplitJoin(controlData.validationDetailsObj['extra']['score'], '\n') : 0"
              >
                <label class="persnol-info-title">
                  <span
                    class="error"
                  >{{controlData.validationDetailsObj[1] ? '*' : ''}}</span>{{controlData.queDetails.in_question_number + '.'}}
                  {{controlData.queDetails.st_question_title}}
                </label>
                <div id="question-1">
                  <ul class="emoji-choices">
                    <li
                      class="choice"
                      v-for="(emojiValue, emojiIndex) in emojiSplitJoin(controlData.validationDetailsObj[39], 'sep')"
                      :data-value="emojiIndex+1"
                      :key="emojiIndex"
                    >
                      <label
                        :class="previewSurveyData.chkSurveyQuestionDetails[''+controlData.queDetails.in_question_master_id] && previewSurveyData.chkSurveyQuestionDetails[''+controlData.queDetails.in_question_master_id].value == ':P' ? 'emoji emoji-selected' : 'emoji'"
                        v-if="emojiValue == ':P'"
                      >
                        <input
                          type="radio"
                          :name="'chk_satis_'+controlData.queDetails.in_question_master_id"
                          data-vv-as="above"
                          v-validate="{required: controlData.validationDetailsObj[1] ? true : false}"
                          class="hidden"
                          autocomplete="off"
                          value=":P"
                          :data-score="(emojiScore[emojiIndex]) ? emojiScore[emojiIndex] : ''"
                          @click="onStarAndEmojiClick(controlData.queDetails.in_question_master_id, $event); skipLogicRuleDetails(controlData.skipLogic, index)"
                          @input="controlData.validationDetailsObj[1] ? (checkInput(controlData.queDetails.in_question_master_id, $event)) : '' "
                        />
                        <i class="em em-heart_eyes"></i>
                      </label>
                      <label
                        :class="previewSurveyData.chkSurveyQuestionDetails[''+controlData.queDetails.in_question_master_id] && previewSurveyData.chkSurveyQuestionDetails[''+controlData.queDetails.in_question_master_id].value == ':)' ? 'emoji emoji-selected' : 'emoji'"
                        v-if="emojiValue == ':)'"
                      >
                        <input
                          type="radio"
                          :name="'chk_satis_'+controlData.queDetails.in_question_master_id"
                          data-vv-as="above"
                          v-validate="{required: controlData.validationDetailsObj[1] ? true : false}"
                          class="hidden"
                          autocomplete="off"
                          value=":)"
                          :data-score="(emojiScore[emojiIndex]) ? emojiScore[emojiIndex] : ''"
                          @click="onStarAndEmojiClick(controlData.queDetails.in_question_master_id, $event); skipLogicRuleDetails(controlData.skipLogic, index)"
                          @input="controlData.validationDetailsObj[1] ? (checkInput(controlData.queDetails.in_question_master_id, $event)) : '' "
                        />
                        <i class="em em-smile"></i>
                      </label>
                      <label
                        :class="previewSurveyData.chkSurveyQuestionDetails[''+controlData.queDetails.in_question_master_id] && previewSurveyData.chkSurveyQuestionDetails[''+controlData.queDetails.in_question_master_id].value == ':|' ? 'emoji emoji-selected' : 'emoji'"
                        v-if="emojiValue == ':|'"
                      >
                        <input
                          type="radio"
                          :name="'chk_satis_'+controlData.queDetails.in_question_master_id"
                          data-vv-as="above"
                          v-validate="{required: controlData.validationDetailsObj[1] ? true : false}"
                          class="hidden"
                          autocomplete="off"
                          value=":|"
                          :data-score="(emojiScore[emojiIndex]) ? emojiScore[emojiIndex] : ''"
                          @click="onStarAndEmojiClick(controlData.queDetails.in_question_master_id, $event); skipLogicRuleDetails(controlData.skipLogic, index)"
                          @input="controlData.validationDetailsObj[1] ? (checkInput(controlData.queDetails.in_question_master_id, $event)) : '' "
                        />
                        <i class="em em-neutral_face"></i>
                      </label>
                      <label
                        :class="previewSurveyData.chkSurveyQuestionDetails[''+controlData.queDetails.in_question_master_id] && previewSurveyData.chkSurveyQuestionDetails[''+controlData.queDetails.in_question_master_id].value == ':(' ? 'emoji emoji-selected' : 'emoji'"
                        v-if="emojiValue == ':('"
                      >
                        <input
                          type="radio"
                          :name="'chk_satis_'+controlData.queDetails.in_question_master_id"
                          data-vv-as="above"
                          v-validate="{required: controlData.validationDetailsObj[1] ? true : false}"
                          class="hidden"
                          autocomplete="off"
                          value=":("
                          :data-score="(emojiScore[emojiIndex]) ? emojiScore[emojiIndex] : ''"
                          @click="onStarAndEmojiClick(controlData.queDetails.in_question_master_id, $event); skipLogicRuleDetails(controlData.skipLogic, index)"
                          @input="controlData.validationDetailsObj[1] ? (checkInput(controlData.queDetails.in_question_master_id, $event)) : '' "
                        />
                        <i class="em em-disappointed"></i>
                      </label>
                      <label
                        :class="previewSurveyData.chkSurveyQuestionDetails[''+controlData.queDetails.in_question_master_id] && previewSurveyData.chkSurveyQuestionDetails[''+controlData.queDetails.in_question_master_id].value == ':@' ? 'emoji emoji-selected' : 'emoji'"
                        v-if="emojiValue == ':@'"
                      >
                        <input
                          type="radio"
                          :name="'chk_satis_'+controlData.queDetails.in_question_master_id"
                          data-vv-as="above"
                          v-validate="{required: controlData.validationDetailsObj[1] ? true : false}"
                          class="hidden"
                          autocomplete="off"
                          value=":@"
                          :data-score="(emojiScore[emojiIndex]) ? emojiScore[emojiIndex] : ''"
                          @click="onStarAndEmojiClick(controlData.queDetails.in_question_master_id, $event); skipLogicRuleDetails(controlData.skipLogic, index)"
                          @input="controlData.validationDetailsObj[1] ? (checkInput(controlData.queDetails.in_question_master_id, $event)) : '' "
                        />
                        <i class="em em-angry"></i>
                      </label>
                    </li>
                  </ul>
                  <div class="clearfix"></div>
                  <div>
                    <span
                      v-show="errors.has('chk_satis_'+controlData.queDetails.in_question_master_id)"
                      class="error"
                    >{{ errors.first('chk_satis_'+controlData.queDetails.in_question_master_id) }}</span>
                  </div>
                </div>
              </div>
              <!-- END Rating question type -->
              <!-- ********************* -->
              <!-- START Photo question type -->
              <div
                class="persnol-info-main qus_ans_sec disabled-question-none"
                v-if="!isAllowPhotoUploads &&(controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_CAMERA || controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_QR_AND_BARCODE_READER)"
              >
                <label class="persnol-info-title">
                  <span
                    class="error"
                  >{{controlData.validationDetailsObj[1] ? '*' : ''}}</span>{{controlData.queDetails.in_question_number + '.'}}
                  {{controlData.queDetails.st_question_title}}
                </label>
                <div class="group img-icon">
                  <!-- <img v-if="controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_CAMERA" src="../../assets/images/camera.png" > -->
                  <i v-if="controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_CAMERA" aria-hidden="true" class="fas fa-camera"></i>
                  <i v-else aria-hidden="true" class="fas fa-barcode"></i>
                  <input
                    type="text"
                    placeholder="This question is not available for online form."
                    readonly
                  />
                </div>
              </div>
              <!-- END Photo question type -->
              <!-- Upload or Capture Photo -->
              <div class="multichoicequs-div" v-if="arrShowAllPhotoQuestion && arrShowAllPhotoQuestion[controlData.queDetails.in_question_master_id]">
                      <label class="persnol-info-title">
                        <span
                          class="error"
                        >{{controlData.validationDetailsObj[1] ? '*' : ''}}</span>{{controlData.queDetails.in_question_number + '.'}}
                        {{controlData.queDetails.st_question_title}}
                      </label>
                      <div class="group camera_sec">
                        <label for="photoedit" class="photoquestionIcon">
                          <div class="item-inner-cam">
                            <i 
                            @click="viewPhotoModal(controlData.queDetails.in_question_master_id, previewSurveyData.chkSurveyQuestionDetails[controlData.queDetails.in_question_master_id], $event)"
                            aria-hidden="true" class="fas fa-camera edit-img"></i>
                          </div>
                        </label>
                        <img
                          :src="previewSurveyData.chkSurveyQuestionDetails[''+controlData.queDetails.in_question_master_id]"
                          alt="..."
                          class="picture"
                        />
                        <label for="photoedit" class="photoquestionIcon">
                          <div class="item-inner-cam">
                            <i 
                            @click="(!photoQuestionStates[''+controlData.queDetails.in_question_master_id]['isPhotoTaken']) ? removeOldPhoto(controlData.queDetails.in_question_master_id, previewSurveyData.chkSurveyQuestionDetails[controlData.queDetails.in_question_master_id], $event) : removeOldPhotoCam(controlData.queDetails.in_question_master_id, previewSurveyData.chkSurveyQuestionDetails[controlData.queDetails.in_question_master_id], $event)"
                            aria-hidden="true" class="fa fa-trash delete-img"></i>
                          </div>
                        </label>
                      </div>
                      <!-- view photo -->
                      <b-modal v-show="photoQuestionStates[''+controlData.queDetails.in_question_master_id]['isViewPhoto']" v-if="photoQuestionStates[''+controlData.queDetails.in_question_master_id]['isViewPhoto']" :id="'viewPhotoModal_'+controlData.queDetails.in_question_master_id" class="view-photo-modal" :title="(controlData.validationDetailsObj[1] ? '*' : '') + controlData.queDetails.in_question_number + '. ' +controlData.queDetails.st_question_title" size="sm" hide-footer no-close-on-esc no-close-on-backdrop>
                          <div class="text-center">
                            <img :src="previewSurveyData.chkSurveyQuestionDetails[''+controlData.queDetails.in_question_master_id]" alt="..." :width="350" class="picture img-check" />
                            <div class="camera-shoot" style="margin-top: 5px;">
                              <button  type="button" :id="'takePhoto_'+controlData.queDetails.in_question_master_id" title="Retake Photo" class="btn btn-whitelable" @click="retakePhoto(controlData.queDetails.in_question_master_id)" style="margin-right: 5px;">
                                <i class="fa fa-repeat" aria-hidden="true"></i>
                              </button>
                              <button  type="button" :id="'closeViewPhoto_'+controlData.queDetails.in_question_master_id" title="Continue" class="btn btn-whitelable" @click="closeViewPhoto(controlData.queDetails.in_question_master_id)">
                                Continue
                              </button>
                            </div>
                          </div>
                      </b-modal>
                       <!-- end view photo -->
                      <!-- retake photo -->
                      <b-modal :id="'cameraRetakeModal_'+controlData.queDetails.in_question_master_id" title="Capture Photo" class="camera-modal" v-show="photoQuestionStates[''+controlData.queDetails.in_question_master_id] && photoQuestionStates[''+controlData.queDetails.in_question_master_id]['isRetakePhoto']"  size="xl" hide-footer no-close-on-esc no-close-on-backdrop>
                        <div class="" v-if="controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_CAMERA || controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_QR_AND_BARCODE_READER">
                          <div v-show="photoQuestionStates[''+controlData.queDetails.in_question_master_id] && photoQuestionStates[''+controlData.queDetails.in_question_master_id]['isCameraOpen'] && photoQuestionStates[''+controlData.queDetails.in_question_master_id]['isLoading']" class="camera-loading">
                            <div id="loadingDiv" class="loadingDiv_analytics">
                                <div class="loadersec">
                                  <div class="loader"></div>
                                </div>
                            </div>
                          </div>
  
                          <div v-show="photoQuestionStates[''+controlData.queDetails.in_question_master_id] && photoQuestionStates[''+controlData.queDetails.in_question_master_id]['isCameraOpen']" class="camera-box" :class="{ 'flash' : photoQuestionStates[''+controlData.queDetails.in_question_master_id] && photoQuestionStates[''+controlData.queDetails.in_question_master_id]['isShotPhoto'] }">
                            
                            <!-- <div class="camera-shutter" :class="{'flash' : isShotPhoto}"></div> -->
                              
                            <!-- <video v-show="!isPhotoTaken" ref="webcam" :width="450" :height="337.5" autoplay>
                            </video> -->
                            <video v-show="photoQuestionStates[''+controlData.queDetails.in_question_master_id] && !photoQuestionStates[''+controlData.queDetails.in_question_master_id]['isPhotoTaken'] && photoQuestionStates[''+controlData.queDetails.in_question_master_id]['isCameraOpen']" :id="'webcam_'+controlData.queDetails.in_question_master_id" :ref="'webcam'" :width="450"  autoplay playsinline muted>
                            </video>
  
                            <canvas :id="'photoTaken_'+controlData.queDetails.in_question_master_id" ref="canvas" :width="700" :height="525" style="display: none;"></canvas>
                          </div>
                          
                          <div v-show="photoQuestionStates[''+controlData.queDetails.in_question_master_id] && photoQuestionStates[''+controlData.queDetails.in_question_master_id]['isCameraOpen']" class="camera-shoot" >
                            <button  type="button" :id="'takePhoto_'+controlData.queDetails.in_question_master_id" class="btn btn-whitelable" @click="takePhoto(controlData.queDetails.in_question_master_id)">
                              <i class="fa fa-camera" aria-hidden="true"></i>
                            </button>
                          </div>
                        </div>
                      </b-modal>
                       <!-- end retake photo -->
              </div>
              <div
              class="persnol-info-main qus_ans_sec"
              v-else-if="isAllowPhotoUploads &&(controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_CAMERA || controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_QR_AND_BARCODE_READER)"
              >
                <label class="persnol-info-title">
                  <span
                    class="error"
                  >{{controlData.validationDetailsObj[1] ? '*' : ''}}</span>{{controlData.queDetails.in_question_number + '.'}}
                  {{controlData.queDetails.st_question_title}}
                </label>
                <div class="group img-icon">
                  <!-- <img v-if="controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_CAMERA" src="../../assets/images/camera.png" > -->
                  <i v-if="controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_CAMERA" aria-hidden="true" class="fas fa-camera"></i>
                  <i v-else aria-hidden="true" class="fas fa-barcode"></i>
                  <input
                    type="text"
                    class="takePhoto btn text-left sub-main"
                    placeholder="Take Photo"
                    readonly
                    @click="toggleCameraMenuModel(controlData.queDetails.in_question_master_id, 'open')"
                  />
                </div>
                
                <b-modal :id="'photoModal_'+controlData.queDetails.in_question_master_id" class="photo-modal" title="Select Photo" size="sm" hide-footer no-close-on-esc no-close-on-backdrop >
                  <div class="text-center">
                    <b-button class="mt-2 btn btn-success sub-main" block :id="'openCamera_'+controlData.queDetails.in_question_master_id" @click="toggleCamera(controlData.queDetails.in_question_master_id)">Open Camera</b-button>
                    <b-button class="mt-2 btn btn-success sub-main" block @click="triggerFileInput(controlData.queDetails.in_question_master_id)">Choose Photo</b-button>
                    <input type="file" ref="fileInput" :id="'fileInput_'+controlData.queDetails.in_question_master_id" style="display: none;" @change="uploadPhoto(controlData.queDetails.in_question_master_id, $event)" />
                    <b-button class="mt-2 btn btn-cancel sub-main" block @click="toggleCameraMenuModel(controlData.queDetails.in_question_master_id, 'cancel')">Cancel</b-button>
                  </div>
                </b-modal>
                <b-modal :id="'cameraModal_'+controlData.queDetails.in_question_master_id" title="Capture Photo" class="camera-modal"  size="xl" hide-footer no-close-on-esc no-close-on-backdrop>
                        <div class="" v-if="controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_CAMERA || controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_QR_AND_BARCODE_READER">
                          <div v-show="photoQuestionStates[''+controlData.queDetails.in_question_master_id] && photoQuestionStates[''+controlData.queDetails.in_question_master_id]['isCameraOpen'] && photoQuestionStates[''+controlData.queDetails.in_question_master_id]['isLoading']" class="camera-loading">
                            <div id="loadingDiv" class="loadingDiv_analytics">
                                <div class="loadersec">
                                  <div class="loader"></div>
                                </div>
                            </div>
                          </div>
  
                          <div v-show="photoQuestionStates[''+controlData.queDetails.in_question_master_id] && photoQuestionStates[''+controlData.queDetails.in_question_master_id]['isCameraOpen']" class="camera-box" :class="{ 'flash' : photoQuestionStates[''+controlData.queDetails.in_question_master_id] && photoQuestionStates[''+controlData.queDetails.in_question_master_id]['isShotPhoto'] }">
                            
                            <!-- <div class="camera-shutter" :class="{'flash' : isShotPhoto}"></div> -->
                              
                            <!-- <video v-show="!isPhotoTaken" ref="webcam" :width="450" :height="337.5" autoplay>
                            </video> -->
                            <video v-show="photoQuestionStates[''+controlData.queDetails.in_question_master_id] && !photoQuestionStates[''+controlData.queDetails.in_question_master_id]['isPhotoTaken'] && photoQuestionStates[''+controlData.queDetails.in_question_master_id]['isCameraOpen']" :id="'webcam_'+controlData.queDetails.in_question_master_id" :ref="'webcam'" :width="450"  autoplay playsinline muted>
                            </video>
  
                            <canvas :id="'photoTaken_'+controlData.queDetails.in_question_master_id" ref="canvas" :width="700" :height="525" style="display: none;"></canvas>
                          </div>
                          
                          <div v-show="photoQuestionStates[''+controlData.queDetails.in_question_master_id] && photoQuestionStates[''+controlData.queDetails.in_question_master_id]['isCameraOpen']" class="camera-shoot" >
                            <button  type="button" :id="'takePhoto_'+controlData.queDetails.in_question_master_id" class="btn btn-whitelable" @click="takePhoto(controlData.queDetails.in_question_master_id)">
                              Capture
                              <!-- <i class="fa fa-camera" aria-hidden="true"></i> -->
                            </button>
                          </div>
                        </div>
                </b-modal>
              </div>
              <!-- end Upload or Capture Photo -->
              <!-- END Photo question type -->
              <!-- ********************* -->
              <!-- START Audio/Video question type -->
              <div
                class="persnol-info-main qus_ans_sec disabled-question-none"
                v-if="($route.path.includes('previewform')) && (controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_AUDIO || controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_VIDEO)"
              >
                <label class="persnol-info-title">
                  <span
                    class="error"
                  >{{controlData.validationDetailsObj[1] ? '*' : ''}}</span>{{controlData.queDetails.in_question_number + '.'}}
                  {{controlData.queDetails.st_question_title}}
                </label>
                <div class="group img-icon">
                  <i v-if="controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_AUDIO" aria-hidden="true" class="fas fa-microphone"></i>
                  <i v-else aria-hidden="true" class="fas fa-video-camera"></i>
                  <input
                    type="text"
                    placeholder="This question is not available for online form."
                    readonly
                  />
                </div>
              </div>
              <!-- END Audio/Video question type -->
              <!-- ********************* -->
              <!-- START Audio/Video question type -->
              <div
                class="persnol-info-main qus_ans_sec disabled-question-none"
                v-if="($route.path.includes('previewform')) && (controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_AUDIO || controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_VIDEO)"
              >
                <label class="persnol-info-title">
                  <span
                    class="error"
                  >{{controlData.validationDetailsObj[1] ? '*' : ''}}</span>{{controlData.queDetails.in_question_number + '.'}}
                  {{controlData.queDetails.st_question_title}}
                </label>
                <div class="group img-icon">
                  <i v-if="controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_AUDIO" aria-hidden="true" class="fas fa-microphone"></i>
                  <i v-else aria-hidden="true" class="fas fa-video-camera"></i>
                  <input
                    type="text"
                    placeholder="This question is not available for online form."
                    readonly
                  />
                </div>
              </div>
              <!-- END Audio/Video question type -->
              <!-- ********************* -->
              <!-- START Signature question type -->
              <div
                class="image-selection padding0"
                :class="{ 'red-border': errors.has('signature_'+controlData.queDetails.in_question_master_id) }"
                v-if="controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_SIGNATURE"
              >
                <label class="persnol-info-title">
                  <span
                    class="error"
                  >{{controlData.validationDetailsObj[1] ? '*' : ''}}</span>{{controlData.queDetails.in_question_number + '.'}}
                  {{controlData.queDetails.st_question_title}}
                </label>
                <!-- <div class="alert alert-info"> -->
                <input
                  type="hidden"
                  :name="'signature_'+controlData.queDetails.in_question_master_id"
                  v-model="previewSurveyData.chkSurveyQuestionDetails[''+controlData.queDetails.in_question_master_id]"
                  v-validate="{required: controlData.validationDetailsObj[1] ? true : false}"
                  data-vv-as="above"
                />
                <div class="group signature_sec">
                  <button type="button" class="btn sub-main edit-signature">
                    <!-- <img class="edit-img" src="../../assets/images/signature.png" /> -->
                    <svg class="edit-img" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                      width="26.688px" height="26.563px" viewBox="0 -0.563 26.688 26.563" enable-background="new 0 -0.563 26.688 26.563"
                      xml:space="preserve">
                      <g>
                        <g>
                          <path d="M20.127,4.158c0-0.61-0.237-1.184-0.669-1.616l-2.154-2.154c-0.425-0.425-1.029-0.669-1.63-0.669h-0.131v4.57h4.584V4.158
                            L20.127,4.158z"/>
                        </g>
                      </g>
                      <g>
                        <g>
                          <path d="M14.258,15.438c0.146-0.443,0.4-0.855,0.732-1.189l5.158-5.136V5.813h-5.354c-0.42,0-0.736-0.341-0.736-0.762v-5.332
                            H2.633c-1.26,0-2.285,1.025-2.285,2.285v21.43c0,1.26,1.025,2.285,2.285,2.285h15.209c1.261,0,2.307-1.025,2.307-2.285v-5.686
                            l-0.838,0.817c-0.339,0.336-0.736,0.581-1.184,0.73l-2.422,0.809l-0.369,0.021c-0.61,0-1.188-0.297-1.546-0.795
                            c-0.355-0.494-0.452-1.135-0.259-1.715L14.258,15.438z M4.157,13.43h7.592c0.421,0,0.762,0.341,0.762,0.762
                            s-0.34,0.762-0.762,0.762H4.157c-0.421,0-0.762-0.341-0.762-0.762S3.736,13.43,4.157,13.43z M3.395,11.145
                            c0-0.421,0.341-0.762,0.762-0.762h7.592c0.421,0,0.762,0.341,0.762,0.762s-0.34,0.762-0.762,0.762H4.157
                            C3.736,11.906,3.395,11.565,3.395,11.145z M3.395,17.238c0-0.421,0.341-0.762,0.762-0.762h7.592c0.421,0,0.762,0.341,0.762,0.762
                            S12.17,18,11.749,18H4.157C3.736,18,3.395,17.659,3.395,17.238z M14.795,21.047c0.422,0,0.762,0.341,0.762,0.762
                            s-0.34,0.762-0.762,0.762h-4.57c-0.421,0-0.762-0.341-0.762-0.762s0.341-0.762,0.762-0.762H14.795z M4.157,8.859
                            c-0.421,0-0.762-0.341-0.762-0.762s0.341-0.762,0.762-0.762h10.639c0.422,0,0.762,0.341,0.762,0.762s-0.34,0.762-0.762,0.762
                            H4.157z"/>
                        </g>
                      </g>
                      <g>
                        <g>
                          <path d="M15.639,16.111L14.976,18.1c-0.099,0.298,0.185,0.581,0.481,0.481l1.988-0.663L15.639,16.111z"/>
                        </g>
                      </g>
                      <g>
                        <g>
                          <path d="M21.555,9.84l-5.017,5.017l2.164,2.163c1.134-1.134,3.339-3.34,5.017-5.017L21.555,9.84z"/>
                        </g>
                      </g>
                      <g>
                        <g>
                          <path d="M25.9,7.655c-0.268-0.27-0.662-0.423-1.08-0.423s-0.813,0.154-1.082,0.424l-1.107,1.107l2.164,2.163
                            c0.605-0.606,1.025-1.025,1.107-1.107C26.496,9.223,26.496,8.252,25.9,7.655z"/>
                        </g>
                      </g>
                      <g>
                        <g>
                          <g>
                            <path d="M25.902,9.819L25.902,9.819c0.002-0.002,0.002-0.003,0.004-0.004C25.904,9.816,25.904,9.817,25.902,9.819z"/>
                            <path d="M25.906,9.814c0.002-0.002,0.006-0.005,0.006-0.007C25.912,9.809,25.908,9.812,25.906,9.814z"/>
                            <path d="M25.912,9.808C25.918,9.803,25.918,9.803,25.912,9.808L25.912,9.808z"/>
                          </g>
                        </g>
                      </g>
                    </svg>
                  </button>
                  <label class="labelpalceholder" :style="{ 'font-size': !showSignatureLabel ? '0' : '' }">Sign Here</label>
                  <vue-signature
                    class="signature"
                    width="100%"
                    height="180px"
                    :id="controlData.queDetails.in_question_master_id"
                    :ref="'signaturePad_'+controlData.queDetails.in_question_master_id"
                    :options="{ onBegin, onEnd: () => onEnd(controlData.skipLogic, index, controlData.validationDetailsObj[1]) }"
                  ></vue-signature>
                  <transition name="fade">
                    <button
                      type="button"
                      class="btn sub-main delete-signature"
                      :data-id="controlData.queDetails.in_question_master_id"
                      @click="clearSignature($event); skipLogicRuleDetails(controlData.skipLogic, index);"
                      :style="{ 'visibility': previewSurveyData.chkSurveyQuestionDetails[''+controlData.queDetails.in_question_master_id] ? '' : 'hidden' }"
                    >
                      <!-- <img class="delete-img" src="../../assets/images/trash.png" /> -->
                      <i class="fa fa-trash delete-img" aria-hidden="true"></i>

                    </button>
                  </transition>
                </div>
                <div>
                  <span
                    v-show="errors.has('signature_'+controlData.queDetails.in_question_master_id)"
                    class="error"
                  >{{ errors.first('signature_'+controlData.queDetails.in_question_master_id) }}</span>
                </div>
                <!-- </div> -->
              </div>
              <!-- END Signature question type -->
            </div>
          </transition>
        </div>
      </div>

      <div class="preview_btn_sec">
        <!-- <div class="left-btn">
          <div class="btn-prev">
            <button class="btn btn-whitelable sub-main">Previous</button>
          </div>
        </div> -->
        <div class="center-btn">
          <div class="submit">
            <button class="btn btn-whitelable sub-main" :class="showDuplicateForm==1 ? 'submitBtnUseform' : '' " :disabled="submitted">Submit</button>
          </div>
        </div>
        <!-- <div class="right-btn">
          <div class="subbtn-next">
            <button class="btn btn-whitelable sub-main">Next</button>
          </div>
        </div> -->
      </div>

    </form>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { EventBus } from "../../main";
import DatePicker from "vue2-datepicker";
import MultiSelect from "vue-multiselect";
import VueSignature from "vue-signature-pad";
import MapboxAutocomplete from "../MapboxAutocomplete.vue";
import ChildBootDatePicker from "vue-bootstrap-datetimepicker";
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";
var { queTypeConfig, frontHostName, constantCommonConfig, redirectUrl } = require("../../../config/config.js");
import QuesSkipModal  from '../../assets/js/skipLogic/QuesSkipModal';
import prepareQues from '../../assets/js/skipLogic/PrepareQuestions'

// Custom Component - For Time question type - This component is used for bootstrap datepicker
// #INFO: Don't pass config option as inline literal object to :config prop.
// This will cause date picker to freeze
const BootDatePicker = {
  inject: {
    $validator: "$validator"
  },
  props: [
    "model",
    "requiredValidation",
    "componentName",
    "minDate",
    "maxDate",
    "surQuesTypeId",
    "surQuesMasterId",
    "skipLogicData",
    "currentIndex"
  ],
  data() {
    return {};
  },
  components: {
    ChildBootDatePicker
  },
  template:
    '<child-boot-date-picker v-model="modelValue" v-validate="{required: requiredValidation ? true : false}" :name="componentName" placeholder="Select Time" :config="datepickerConfig" data-vv-as="above" v-on="{ input: requiredValidation ? (currentValue) => (this.$parent.checkDateTimePicker(currentValue, surQuesMasterId)) : null }" @dp-change="skipLogicRuleDetails"></child-boot-date-picker>',
  computed: {
    modelValue: {
      get() {
        return this.model;
      },
      set(value) {
        this.$emit("update:model", value);
      }
    },
    datepickerConfig() {
      return {
        minDate: this.minDate
          ? this.surQuesTypeId == this.$parent.vueQueTypeConfig.TYPE_12_HOURS
            ? this.moment(this.minDate, this.$parent.timeFormat12).toDate()
            : this.moment(this.minDate, this.$parent.timeFormat24).toDate()
          : false,
        maxDate: this.maxDate
          ? this.surQuesTypeId == this.$parent.vueQueTypeConfig.TYPE_12_HOURS
            ? this.moment(this.maxDate, this.$parent.timeFormat12).toDate()
            : this.moment(this.maxDate, this.$parent.timeFormat24).toDate()
          : false,
        format:
          this.surQuesTypeId == this.$parent.vueQueTypeConfig.TYPE_12_HOURS
            ? this.$parent.timeFormat12
            : this.$parent.timeFormat24,
        useCurrent: false,
        showClear: true,
        showClose: true,
        defaultDate: this.maxDate
          ? this.surQuesTypeId == this.$parent.vueQueTypeConfig.TYPE_12_HOURS
            ? this.moment(this.maxDate, this.$parent.timeFormat12).toDate()
            : this.moment(this.maxDate, this.$parent.timeFormat24).toDate()
          : this.minDate
          ? this.surQuesTypeId == this.$parent.vueQueTypeConfig.TYPE_12_HOURS
            ? this.moment(this.minDate, this.$parent.timeFormat12).toDate()
            : this.moment(this.minDate, this.$parent.timeFormat24).toDate()
          : false,
        widgetPositioning: {
          vertical: "auto",
          horizontal: "left"
        }
      };
    }
  },
  methods: {
    skipLogicRuleDetails() {
      if(typeof this.skipLogicData != 'undefined') {
        this.$parent.skipLogicRuleDetails(this.skipLogicData, this.currentIndex);
      }
    }
  }
};
export default {
  name: "Content",
  metaInfo() {
    return {
      title: this.siteTitle,
    };
  },
  props: ["siteTitle"],
  components: {
    DatePicker,
    MultiSelect,
    VueSignature,
    MapboxAutocomplete,
    BootDatePicker
  },
  computed: {
    ...mapGetters("previewSurvey", [
      "surveyOriginalQuestionDetails",
      "surveyMasterDetails",
      "surveyQuestionDetails",
      "surveyAllFlagDetails",
      "surveyDesignDetails",
      "showAllPhotoQuestion",
      "storeAllPhotoQuestion",
    ])
  },
  data() {
    return {
      surveyQuestionDetailsData: [],
      quesNo: 0,
      previewSurveyData: {
        chkSurveyQuestionDetails: {},
        chkOtherMulChoice: {},
        chkMapMulChoice: {},
        chkSurveyFlagDetals: [],
        chkSuvreyMasterDetails: []
      },
      lang: {
        days: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        months: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec"
        ],
        pickers: [
          "next 7 days",
          "next 30 days",
          "previous 7 days",
          "previous 30 days"
        ],
        placeholder: {
          date: "Select Date",
          dateRange: "Select Date/Time Range"
        }
      },
      timePickerOptions: {
        start: "00:00:00",
        step: "00:30:00",
        end: "23:30:00"
      },
      timeFormat12: "hh:mm:ss a",
      timeFormat24: "HH:mm:ss",
      signatureId: 0,
      completedQuesForPerc: [],
      address: "",
      vueQueTypeConfig: queTypeConfig,
      backwardQuesNo: [],
      loaded: [],
      questionsToSubmit: [],
      multipleRules : false,
      newQuestionList: [],
      tempPreviouslySelected: {},
      submitted: false,
      currentCallOptions: {
        durations: {
          alert: 0
        }
      },
      showSignatureLabel: true,
      timePickerObject: {},
      tempTimePickerValue: {},
      vueCommonConfig: constantCommonConfig,
      emailCollection: [],
      showDuplicateForm: 0,
      arrStoreAllPhotoQuestion: [],
      arrShowAllPhotoQuestion: {},
      imageArray: {},
      isAllowPhotoUploads: false,
      photoQuestionStates: {},
    };
  },
  mounted: async function() {
    // Custom validation for max
    this.$validator.extend("custom_max", {
      getMessage: (field, args) => {
        return (
          "The " + field + " field must not exceed " + args[0] + " characters."
        );
      },
      validate: (value, args) => {
        var length = args[0];
        if (value === undefined || value === null) {
          return false;
        }

        if (String(value).length <= length || length == "") {
          return true;
        } else {
          return false;
        }
      }
    });
    // Custom validation for regex in serial number of text
    this.$validator.extend("custom_regex", {
      getMessage: (field, args) => {
        console.log(args);
        let msg = args[1].split("Allowed characters: ")[1];
        if (msg.indexOf("1") > -1) {
          msg =
            "1," +
            msg.slice(0, msg.indexOf("1")) +
            msg.slice(msg.indexOf("1") + 2);
        }
        if (msg.indexOf("A") > -1) {
          msg =
            "A," +
            msg.slice(0, msg.indexOf("A")) +
            msg.slice(msg.indexOf("A") + 2);
        }
        msg = msg.replace(/,\s*$/, "");
        msg = msg.replace("A", "A-Z");
        msg = msg.replace("1", "0-9");
        msg = msg.replace(", ", ",space");
        return "Allowed inputs are " + msg + ".";
      },
      validate: (value, args) => {
        var res = value.match(args[0]);
        if (res) return true;
        else return false;
      }
    });
    // Custom validation for min value
    this.$validator.extend("custom_min_value", {
      getMessage: (field, args) => {
        return "The " + field + " field must be " + args[0] + " or more.";
      },
      validate: (value, args) => {
        var min = args[0];
        if (value === undefined || value === null) {
          return false;
        }

        if (Number(value) >= min || min == "") {
          return true;
        } else {
          return false;
        }
      }
    });
    // Custom validation for max value
    this.$validator.extend("custom_max_value", {
      getMessage: (field, args) => {
        return "The " + field + " field must be " + args[0] + " or less.";
      },
      validate: (value, args) => {
        var max = args[0];
        if (value === undefined || value === null) {
          return false;
        }

        if (Number(value) <= max || max == "") {
          return true;
        } else {
          return false;
        }
      }
    });
    this.surveyQuestionDetailsData = this.surveyQuestionDetails;
    this.previewSurveyData.chkSurveyFlagDetals = this.surveyAllFlagDetails;
    this.previewSurveyData.chkSuvreyMasterDetails = this.surveyMasterDetails;
    this.arrStoreAllPhotoQuestion = this.storeAllPhotoQuestion;
    this.arrShowAllPhotoQuestion = this.showAllPhotoQuestion;
    this.isAllowPhotoUploads = (this.$session.get("isAllowPhotoUploads") == 1) ? true : false;
    // if(this,surveyMasterDetails.in_question_flow == 0) {
    // this.surveyQuestionDetailsData.forEach((val,k) => {
    //   val.queDetails['validationDetailsObj'] = val.validationDetailsObj
    // })
    // console.log(this.surveyQuestionDetailsData)
    // }
    console.log('this.surveyQuestionDetails', this.surveyQuestionDetails)
    let resultCopy = this.surveyOriginalQuestionDetails
    console.log('this.surveyOriginalQuestionDetails mounetd', this.surveyOriginalQuestionDetails)
    resultCopy.map(function (v) {
        v.showQues = false,
        v.userAnswer = "",
        v.isSkipped = false,
        v.otherText = ""
    })
    console.log('resultCopy', resultCopy)
    // console.log(QuesSkipModal)
    let quesList = prepareQues.getQuesData(resultCopy)
    console.log('quesList', quesList)
    this.newQuestionList = QuesSkipModal.getData(quesList);
    console.log('this.newQuestionList before update required', this.newQuestionList)
    this.updateRequiredQues()

    if(this.surveyMasterDetails.in_question_flow == 1) {
      this.surveyQuestionDetailsData.map((skipVal, skipKey) =>  {
          this.setDisplayVariable(skipKey, this.newQuestionList[skipKey].showQues)
      })
    }
    console.log('this.newQuestionList mounted end', this.newQuestionList)
    console.log('this.surveyQuestionDetailsData mounted end', this.surveyQuestionDetailsData)
    console.log('this.surveyMasterDetails',this.surveyMasterDetails)

    this.$validator.extend("valid_email", {
      getMessage: (field, args) => {
        return "";
      },
      validate: (value, args) => {
        return true;
      }
    });
    this.$validator.extend("invalid_email", {
      getMessage: (field, args) => {
        return "This email is invalid";
      },
      validate: (value, args) => {
        return false;
      }
    });

    this.$validator.extend("valid_email2", {
      validate: (value, args) => {
        return true;
      }
    });
    this.$validator.extend("invalid_email2", {
      getMessage: (field, args) => {
        return "";
      },
      validate: (value, args) => {
        return false;
      }
    });
    
    if(this.$route.query.hasOwnProperty('q') && this.$route.query.q == 'templates')
    {
      this.showDuplicateForm = 1;
      this.submitted = true;
    }
    
    this.surveyQuestionDetailsData.forEach((question) => {
      if (question.queDetails.in_question_type_id === queTypeConfig.TYPE_CAMERA) {
        this.initPhotoQuestionState(question.queDetails.in_question_master_id);
      }
    });
  },
  methods: {
    ...mapActions("previewSurvey", ["addResponse"]),
    hispec() {
      // var parts = window.location.href.split(".");
      let whitelabel = this.$session.get("whitelabel");
      var loc =
        frontHostName +
        process.env.CAKE_BASE_PATH +
        whitelabel +
        process.env.CAKE_SURVEY_PATH;
      // var loc = "http://" + location.hostname + process.env.CAKE_SURVEY_PATH;
      window.location.href = loc;
    },
    validateBeforeSubmit() {
      this.$validator.validateAll().then(async result => {
        if (result) {
          var mainArray = this.previewSurveyData.chkSurveyQuestionDetails;
          // console.log('mainArray', mainArray, Object.keys(mainArray).length)
          if(this.showDuplicateForm == 1)
          {
            this.$awn.alert("You can't submit reponse because this is a template");
            return;
          }
          else if(Object.keys(mainArray).length == 0){
            this.$awn.alert("Please answer atleast one question.", this.currentCallOptions);
            return
          }
          this.$wait.start("adding response");
          // eslint-disable-next-line
          // this.$awn.success("Form is submitted!");
          if (this.$route.name == "ResponseForm") {
            this.submitted = true;
            //this.$wait.start("add response");
            // var finalArray = {};
            // var mainArray = this.previewSurveyData.chkSurveyQuestionDetails; // Original array with question list
            // // console.log(mainArray);
            // for (var key in mainArray) {
            //   if (mainArray[key]) {
            //     var answer = "";
            //     var mapArray = this.previewSurveyData.chkMapMulChoice; // array with map details like lat, lng
            //     var otherArray = this.previewSurveyData.chkOtherMulChoice; // array with other answer details
            //     var quesType = this.surveyQuestionDetailsData.find(
            //       x => x.queDetails.in_question_master_id == key
            //     );
            //     key = parseInt(key);

            //     // If answer found in map array and other array also
            //     if (
            //       mapArray.hasOwnProperty(key) &&
            //       otherArray.hasOwnProperty(key) &&
            //       mainArray[key].indexOf("Other") != -1
            //     ) {
            //       answer = mapArray[key].concat(otherArray[key]);
            //     } else if (mapArray.hasOwnProperty(key)) {
            //       // If answer found in only map array
            //       answer =
            //         typeof mapArray[key] === "object" &&
            //         mapArray[key].constructor === Object
            //           ? [mapArray[key]]
            //           : mapArray[key];
            //     } else if (otherArray.hasOwnProperty(key)) {
            //       // If answer found in only other array also
            //       answer =
            //         typeof otherArray[key] === "object" &&
            //         otherArray[key].constructor === Object
            //           ? [otherArray[key]]
            //           : otherArray[key];
            //     } else {
            //       // If answer found in main array called chkSurveyQuestionDetails
            //       // mainArray[key].value is for Rating question type
            //       answer = [
            //         {
            //           formatted_address:
            //             typeof mainArray[key] == "object" &&
            //             mainArray[key].value
            //               ? mainArray[key].value
            //               : mainArray[key].formatted_address
            //               ? mainArray[key].formatted_address
            //               : mainArray[key],
            //           lat: mainArray[key].lat ? mainArray[key].lat : null,
            //           lng: mainArray[key].lng ? mainArray[key].lng : null,
            //           score:
            //             typeof mainArray[key] == "object" &&
            //             mainArray[key].score
            //               ? mainArray[key].score
            //               : ""
            //         }
            //       ];
            //     }

            //     finalArray[key] = {
            //       type: quesType.queDetails.in_question_type_id,
            //       answer: answer,
            //       isAddress:
            //         this.previewSurveyData.chkSurveyFlagDetals[
            //           "in_address"
            //         ].indexOf(key) != -1
            //           ? 1
            //           : 0,
            //       isDate:
            //         this.previewSurveyData.chkSurveyFlagDetals[
            //           "in_date"
            //         ].indexOf(key) != -1
            //           ? 1
            //           : 0,
            //       isPhoto:
            //         this.previewSurveyData.chkSurveyFlagDetals[
            //           "in_photo"
            //         ].indexOf(key) != -1
            //           ? 1
            //           : 0,
            //       isAudit:
            //         this.previewSurveyData.chkSuvreyMasterDetails["in_audit"] ==
            //           1 &&
            //         this.previewSurveyData.chkSurveyFlagDetals[
            //           "in_audit"
            //         ].indexOf(key) != -1
            //           ? 1
            //           : 0,
            //       isEMailSent:
            //         this.previewSurveyData.chkSurveyFlagDetals[
            //           "in_email_sent"
            //         ].indexOf(key) != -1
            //           ? 1
            //           : 0,
            //       questionNo: quesType.queDetails.in_question_number
            //     };
            //   }
            // }
            // this.data = this.$session.getAll();
            // this.data["in_survey_Id"] = this.$route.params.id;
            // this.data["responseData"] = JSON.stringify(finalArray);
            // this.data["sentdate"] = this.moment().format("YYYY-MM-DD HH:mm:ss");
            // this.data["sentdatetimezone"] = this.moment().format("Z");
            // await this.addResponse(this.data).then(value => {
            //   this.$emit("changeToEndScreen");
            // });
            // this.$wait.end("add response");
            this.addResponseInDb();
          } else {
            // this.addResponseInDb();
            this.$awn.success("Form is submitted!");
            this.$emit("changeToEndScreen");
          }
          return;
        }
        var requiredQues = this.errors.items.some( (val, key) => {
          return val.rule == 'required'
        });
        var reqErrorMsg = '';
        if(requiredQues) {
          reqErrorMsg = "One or more mandatory questions have not been answered!";
        } else {
          var allErrorAscOrder = this.errors.items.sort(function (a, b) {
            return a.id - b.id;
          });
          var field = allErrorAscOrder[0].field.split('_');
          var quesMasterId = field[field.length - 1];
          var quesData = this.surveyOriginalQuestionDetails.find(
            x => x.in_question_master_id == quesMasterId
          );
          reqErrorMsg = "Question " + quesData.in_question_number + " has validation error";
        }
        this.$awn.closeToasts();
        this.$awn.alert(reqErrorMsg, this.currentCallOptions);
      });
    },
    async addResponseInDb() {
      var finalArray = {};
      var mainArray = this.previewSurveyData.chkSurveyQuestionDetails; // Original array with question list

      let includeQuestions = [] //final submitable questions after applying skip logic
      if(this.surveyMasterDetails.in_question_flow == 0){
        this.questionsToSubmit.push(this.quesNo)//add last question as it will not add on next button
          this.questionsToSubmit.forEach( (v) => {
            includeQuestions.push(this.surveyQuestionDetails[v].queDetails.in_question_master_id)
          })
      }else{
        this.surveyQuestionDetails.forEach( (v) => {
          if(v.displayFlag == 1){
            includeQuestions.push(v.queDetails.in_question_master_id)
          }
        })
      }
      // console.log(mainArray);
      // console.log('questionsToSubmit in addResponseInDb',this.questionsToSubmit)
      // console.log(this.quesNo)
      // console.log('includeQuestions',includeQuestions)

      for (var key in mainArray) {
        if (mainArray[key]) {
          var answer = "";
          var mapArray = this.previewSurveyData.chkMapMulChoice; // array with map details like lat, lng
          var otherArray = this.previewSurveyData.chkOtherMulChoice; // array with other answer details
          var quesType = this.surveyQuestionDetailsData.find(
            x => x.queDetails.in_question_master_id == key
          );
          key = parseInt(key);

          // This condition is for only time picker question
          // As we have added default time in v-model so we need to remove from array if someone is not changed time.
          // In short Not send unselected time picker value to server side
          if(quesType.queDetails.in_question_type_id == this.vueQueTypeConfig.TYPE_12_HOURS || quesType.queDetails.in_question_type_id == this.vueQueTypeConfig.TYPE_24_HOURS) {
            if(!this.tempTimePickerValue.hasOwnProperty(key) || this.tempTimePickerValue[key] == undefined) {
              continue;
            }
          }

          // If answer found in map array and other array also
          if (mapArray.hasOwnProperty(key) && otherArray.hasOwnProperty(key)) {
            answer = mapArray[key].concat(otherArray[key]);
          } else if (mapArray.hasOwnProperty(key)) {
            // If answer found in only map array
            answer =
              typeof mapArray[key] === "object" &&
              mapArray[key].constructor === Object
                ? [mapArray[key]]
                : mapArray[key];
          } else if (otherArray.hasOwnProperty(key)) {
            // If answer found in only other array also
            answer =
              typeof otherArray[key] === "object" &&
              otherArray[key].constructor === Object
                ? [otherArray[key]]
                : otherArray[key];
          } else {
            var formattedAddressValue = typeof mainArray[key] == "object" && mainArray[key].value
                    ? mainArray[key].value
                    : mainArray[key].formatted_address
                    ? mainArray[key].formatted_address
                    : mainArray[key];
            if(quesType.queDetails.in_question_type_id == this.vueQueTypeConfig.TYPE_12_HOURS) {
              formattedAddressValue = this.moment(formattedAddressValue, this.timeFormat24).format(this.timeFormat12);
            }
            // If answer found in main array called chkSurveyQuestionDetails
            // mainArray[key].value is for Rating question type
            answer = [
              {
                formatted_address: formattedAddressValue,
                lat: mainArray[key].lat ? mainArray[key].lat : null,
                lng: mainArray[key].lng ? mainArray[key].lng : null,
                score:
                  typeof mainArray[key] == "object" && mainArray[key].score
                    ? mainArray[key].score
                    : ""
              }
            ];
          }
          if(includeQuestions.indexOf(key) !== -1) {
            finalArray[key] = {
              type: quesType.queDetails.in_question_type_id,
              answer: answer,
              isAddress:
                this.previewSurveyData.chkSurveyFlagDetals["in_address"].indexOf(
                  key
                ) != -1
                  ? 1
                  : 0,
              isDate:
                this.previewSurveyData.chkSurveyFlagDetals["in_date"].indexOf(
                  key
                ) != -1
                  ? 1
                  : 0,
              dateFormat:
                (this.previewSurveyData.chkSurveyFlagDetals["in_date_format"].hasOwnProperty(
                  key
                ))
                  ? this.previewSurveyData.chkSurveyFlagDetals["in_date_format"][key]
                  : "",
              isPhoto:
                this.previewSurveyData.chkSurveyFlagDetals["in_photo"].indexOf(
                  key
                ) != -1
                  ? 1
                  : 0,
              isMedia:
                this.previewSurveyData.chkSurveyFlagDetals["in_media"].indexOf(
                  key
                ) != -1
                  ? 0
                  : (quesType.queDetails.in_question_type_id == 28) ? 1 : (quesType.queDetails.in_question_type_id == 27) ? 2 : 0,
              isAudit:
                this.previewSurveyData.chkSuvreyMasterDetails["in_audit"] == 1 &&
                this.previewSurveyData.chkSurveyFlagDetals["in_audit"].indexOf(
                  key
                ) != -1
                  ? 1
                  : 0,
              isEMailSent:
                this.previewSurveyData.chkSurveyFlagDetals[
                  "in_email_sent"
                ].indexOf(key) != -1
                  ? 1
                  : 0,
              questionNo: quesType.queDetails.in_question_number
            };
          }
        }
      }
      // console.log('finalArray',finalArray)
      // return
      this.data = this.$session.getAll();
      this.data["in_survey_Id"] = this.$route.params.id;
      this.data["responseData"] = JSON.stringify(finalArray);
      this.data["questionSentCount"] = Object.keys(finalArray).length ;
      this.data["sentDate"] = this.moment().format("YYYY-MM-DD HH:mm:ss");
      this.data["sentDateTimezone"] = this.moment().format("Z");
      this.data["collectedDate"] = this.moment().format("YYYY-MM-DD HH:mm:ss");
      this.data["collectedDateTimezone"] = this.moment().format("Z");
      this.data["49d22884af3ece2c46ba430268844fba"] = this.imageArray;
      await this.addResponse(this.data).then(value => {
        this.submitted = false;
        // console.log('response from server', value)
        this.$wait.end("adding response");
        if(value.status != 200){
          this.$awn.alert("Something might wrong!");
          return
        }
        if(value.data.flag != 1){
          this.$awn.alert(value.data.msg);
          return
        }
        this.$emit("changeToEndScreen");
      });
    },
    checkListOther(surveyQuesId, e) {
      this.previewSurveyData["chkOtherMulChoice"][surveyQuesId] = {
        formatted_address: e.target.value,
        lat: null,
        lng: null,
        score: this.previewSurveyData["chkSurveyQuestionDetails"][surveyQuesId]
          .score
      };
    },
    checkOtherAnswer: function(index, surveyQuesId, isAddress, e) {
      console.log('data-score',e.target.getAttribute("data-score"));
      if (e.target) {
        if (e.target.type == "radio") {
          if (e.target.value == "Other") {
            this.$set(
              this.surveyQuestionDetailsData[index]["queDetails"],
              "other",
              e.target.checked
            );
            delete this.previewSurveyData["chkMapMulChoice"][surveyQuesId];
            //this.previewSurveyData["chkMapMulChoice"][surveyQuesId] = {};
          } else {
            this.$set(
              this.surveyQuestionDetailsData[index]["queDetails"],
              "other",
              false
            );
            delete this.previewSurveyData["chkOtherMulChoice"][surveyQuesId];
            // If address field is ON
            if (isAddress) {
              //this.previewSurveyData["chkOtherMulChoice"][surveyQuesId] = {};
              // If checked then create array for map data and append lat, lng and score into that array
              this.previewSurveyData["chkMapMulChoice"][surveyQuesId] = {
                formatted_address: e.target.value,
                lat: e.target.getAttribute("data-lat"),
                lng: e.target.getAttribute("data-lng"),
                score: e.target.getAttribute("data-score")
              };
            } else {
              this.previewSurveyData["chkMapMulChoice"][surveyQuesId] = {
                formatted_address: e.target.value,
                lat: null,
                lng: null,
                score: e.target.getAttribute("data-score")
              };
            }
          }

          this.uncheck(surveyQuesId, e.target.value, true, index)
        } else if (e.target.type == "checkbox") {
          // for checkbox v-model
          if (!this.previewSurveyData.chkSurveyQuestionDetails[surveyQuesId])
            this.previewSurveyData["chkSurveyQuestionDetails"][
              surveyQuesId
            ] = [];
          // this.$set(
          //   this.previewSurveyData.chkSurveyQuestionDetails,
          //   surveyQuesId,
          //   []
          // );
          if (e.target.value == "Other") {
            this.$set(
              this.surveyQuestionDetailsData[index]["queDetails"],
              "other",
              e.target.checked
            );
          } else {
            // If address field is ON
            if (isAddress) {
              // If checked then create array for map data and append lat, lng and score into that array
              if (e.target.checked) {
                if (!this.previewSurveyData["chkMapMulChoice"][surveyQuesId])
                  this.previewSurveyData["chkMapMulChoice"][surveyQuesId] = [];
                this.previewSurveyData["chkMapMulChoice"][surveyQuesId].push({
                  formatted_address: e.target.value,
                  lat: e.target.getAttribute("data-lat"),
                  lng: e.target.getAttribute("data-lng"),
                  score: e.target.getAttribute("data-score")
                });
              } else {
                // If unchecked
                this.previewSurveyData["chkMapMulChoice"][
                  surveyQuesId
                ] = this.previewSurveyData["chkMapMulChoice"][
                  surveyQuesId
                ].filter(item => {
                  return item.formatted_address !== e.target.value;
                });
              }
            } else {
              console.log('multi choise not address')
              if (e.target.checked) {
                if (!this.previewSurveyData["chkMapMulChoice"][surveyQuesId])
                  this.previewSurveyData["chkMapMulChoice"][surveyQuesId] = [];
                this.previewSurveyData["chkMapMulChoice"][surveyQuesId].push({  
                  formatted_address: e.target.value,
                  lat: null,
                  lng: null,
                  score: e.target.getAttribute("data-score")
                });
              } else {
                // If unchecked
                this.previewSurveyData["chkMapMulChoice"][
                  surveyQuesId
                ] = this.previewSurveyData["chkMapMulChoice"][
                  surveyQuesId
                ].filter(item => {
                  return item.formatted_address !== e.target.value;
                });
              }
            }
          }
        } else {
          console.log('multi choise last else')
          //for other textbox
          this.previewSurveyData["chkOtherMulChoice"][surveyQuesId] = {
            formatted_address: e.target.value,
            lat: null,
            lng: null,
            score: e.target.getAttribute("data-score")
          };
        }
      }
    },
    emojiSplitJoin(
      emojiText,
      splitBy,
      lat = "",
      lng = "",
      score = "",
      surveyQuesTypeId = ""
    ) {
      if (surveyQuesTypeId == 3 || surveyQuesTypeId == 29) {
        const listOptions = emojiText.split(splitBy);
        const listLatOptions = lat.split(splitBy);
        const listLngOptions = lng.split(splitBy);
        const listScoreOptions = score.split(splitBy);
        var obj = [];
        listOptions.forEach((property, i) => {
          obj.push({
            formatted_address: property,
            lat: listLatOptions[i] ? listLatOptions[i] : 0,
            lng: listLngOptions[i] ? listLngOptions[i] : 0,
            score: listScoreOptions[i] ? listScoreOptions[i] : ""
          });
        });
        return obj;
      } else {
        return emojiText.split(splitBy);
      }
    },
    onImageClicked(event) {
      if (event.srcElement.classList.contains("check")) {
        event.srcElement.classList.remove("check");
      } else {
        event.srcElement.classList.add("check");
      }
    },
    onEmpjiClicked(index, emojiIndex, event) {
      console.log(index);
      console.log(emojiIndex);
      event.target.parentElement.classList.remove("emoji-selected");
      event.target.parentElement.classList.add("emoji-selected");
    },
    addOptions(searchQuery, id, surQuesId) {
      this.previewSurveyData.chkSurveyQuestionDetails["" + surQuesId].push(
        searchQuery
      );
    },
    onBegin(evt) {
      this.showSignatureLabel = false;
      this.signatureId = evt.target.parentElement.id;
    },
    onEnd(skiplogic = [], index = 0, isRequired) {
      var _id = this.signatureId; //evt.target.parentElement.id
      // console.log(this.$refs);
      // console.log(_id);
      const { isEmpty, data } = this.$refs[
        "signaturePad_" + _id
      ][0].saveSignature();
      if (!isEmpty) {
        if (skiplogic && index) this.skipLogicRuleDetails(skiplogic, index);
        this.$set(this.previewSurveyData.chkSurveyQuestionDetails, _id, data);
        // console.log(this.previewSurveyData.chkSurveyQuestionDetails["" + _id]);
        let evt = {
          target: {
            value: this.previewSurveyData.chkSurveyQuestionDetails["" + _id]
          }
        };

        if (isRequired) this.checkInput(_id, evt, true);
        if (this.errors.has("signature_" + _id)) {
          this.errors.remove("signature_" + _id);
        }
      }
    },
    clearSignature(evt) {
      this.showSignatureLabel = true;
      var _id = evt.currentTarget.getAttribute("data-id");
      console.log(this.$refs);
      console.log(_id);
      this.$refs["signaturePad_" + _id][0].clearSignature();
      this.$set(this.previewSurveyData.chkSurveyQuestionDetails, _id, "");
      let evnt = {
        target: {
          value: ""
        }
      };
      this.checkInput(_id, evnt, true);
    },
    getKeyByValue(object, value) {
      return Object.keys(object).find(key => object[key] === value);
    },
    skipLogicRuleDetails(
      skiplogic,
      currentQuesNo = 0,
      isAllQuesAtTime = true,
      isSameQuestionRule = false
    ) {
      console.log("INNNNNNNNNNNNNNNN");      
      // [
      //   {
      //     "conditions":{
      //        "rules":[
      //           {
      //              "in_question_type_id":5,
      //              "details":[
      //                 {
      //                    "st_answer_value":"1",
      //                    "st_logical_condition":"CONTAINS",
      //                    "st_rule_type":"ANY",
      //                    "in_question_master_id":6452,
      //                    "all_answer_arr":[
      //                       "1",
      //                       "2",
      //                       "3",
      //                       "4"
      //                    ]
      //                 },
      //                 {
      //                    "st_answer_value":"2",
      //                    "st_logical_condition":"CONTAINS",
      //                    "st_rule_type":"ANY",
      //                    "in_question_master_id":6452,
      //                    "all_answer_arr":[
      //                       "1",
      //                       "2",
      //                       "3",
      //                       "4"
      //                    ]
      //                 },
      //                 {
      //                    "st_answer_value":"3",
      //                    "st_logical_condition":"CONTAINS",
      //                    "st_rule_type":"ANY",
      //                    "in_question_master_id":6452,
      //                    "all_answer_arr":[
      //                       "1",
      //                       "2",
      //                       "3",
      //                       "4"
      //                    ]
      //                 },
      //                 {
      //                    "st_answer_value":"4",
      //                    "st_logical_condition":"CONTAINS",
      //                    "st_rule_type":"ANY",
      //                    "in_question_master_id":6452,
      //                    "all_answer_arr":[
      //                       "1",
      //                       "2",
      //                       "3",
      //                       "4"
      //                    ]
      //                 }
      //              ]
      //           }
      //        ],
      //        "rule_cond":[

      //        ],
      //        "is_answered":[
      //           "ANSWERED"
      //        ]
      //     },
      //     "thenQuesNo":6,
      //     "elseQuesNo":8
      //   },
      //   {
      //     "conditions":{
      //        "rules":[
      //           {
      //              "in_question_type_id":5,
      //              "details":[
      //                 {
      //                    "st_answer_value":"1",
      //                    "st_logical_condition":"EQUALS",
      //                    "st_rule_type":"ALL",
      //                    "in_question_master_id":6698,
      //                    "all_answer_arr":[
      //                       "1",
      //                       "2"
      //                    ]
      //                 },
      //                 {
      //                    "st_answer_value":"2",
      //                    "st_logical_condition":"EQUALS",
      //                    "st_rule_type":"ALL",
      //                    "in_question_master_id":6698,
      //                    "all_answer_arr":[
      //                       "1",
      //                       "2"
      //                    ]
      //                 }
      //              ]
      //           }
      //        ],
      //        "rule_cond":[

      //        ],
      //        "is_answered":[
      //           "ANSWERED"
      //        ]
      //     },
      //     "thenQuesNo":7,
      //     "elseQuesNo":8
      //   },
      //   {
      //     "conditions":{
      //        "rules":[
      //           {
      //              "in_question_type_id":5,
      //              "details":[
      //                 {
      //                    "st_answer_value":"1",
      //                    "st_logical_condition":"EQUALS",
      //                    "st_rule_type":"ALL",
      //                    "in_question_master_id":6704,
      //                    "all_answer_arr":[
      //                       "1",
      //                       "2"
      //                    ]
      //                 },
      //                 {
      //                    "st_answer_value":"2",
      //                    "st_logical_condition":"EQUALS",
      //                    "st_rule_type":"ALL",
      //                    "in_question_master_id":6704,
      //                    "all_answer_arr":[
      //                       "1",
      //                       "2"
      //                    ]
      //                 }
      //              ]
      //           }
      //        ],
      //        "rule_cond":[

      //        ],
      //        "is_answered":[
      //           "ANSWERED"
      //        ]
      //     },
      //     "thenQuesNo":7,
      //     "elseQuesNo":8
      //   }
      // ]

      // If only
      // console.log(skiplogic[0]["conditions"]["rules"].length)
      // console.log(skiplogic);

      if(this.loaded.indexOf(currentQuesNo) === -1){
        this.loaded.push(currentQuesNo) //call skip logic once on question load time to display questons properly
      }
      if (skiplogic.length > 0) {
        setTimeout(() => {
          var thenElseConditionArr = [];
          var isAnswerd = true;
          parentLoop: for (var k = 0; k < skiplogic.length; k++) {
            console.log('currentQuesNo + 1',currentQuesNo + 1);
            console.log('skiplogic[k]',skiplogic[k]);
            console.log('isSameQuestionRule',isSameQuestionRule);

            // if (
            //   skiplogic[k]["conditions"]["rules"].length > 0 &&
            //   (((skiplogic[k]["thenQuesNo"] == currentQuesNo + 1 ||
            //     skiplogic[k]["elseQuesNo"] == currentQuesNo + 1) &&
            //     isSameQuestionRule) ||
            //     (skiplogic[k]["thenQuesNo"] != currentQuesNo + 1 &&
            //       skiplogic[k]["elseQuesNo"] != currentQuesNo + 1))
            // ) {
              console.log("in checkkkkk");
              // console.log(skiplogic[k]["conditions"]);
              var skiplogicArr = skiplogic[k]["conditions"]["rules"];

              outerloop: for (let i = 0; i < skiplogicArr.length; i++) {
                var skiplogicmaster = skiplogicArr[i]["details"];
                var questionType = skiplogicArr[i]["in_question_type_id"];

                innerloop: for (let j = 0; j < skiplogicmaster.length; j++) {
                  var rules = skiplogicmaster[j];
                  //check if skip logic rule is on same question or not
                  if(rules.in_question_master_id != this.surveyQuestionDetailsData[currentQuesNo].in_question_master_id){
                    let otherQueIdx = null
                    this.surveyQuestionDetailsData.forEach((ov, ok) => {
                      if(ov.in_question_master_id == rules.in_question_master_id){
                        otherQueIdx = ok
                        return
                      }
                    })
                    console.log('otherQueIdx', otherQueIdx)
                    // do not check rule if question is not displaying
                    if(otherQueIdx >= 0){
                      if(this.surveyMasterDetails.in_question_flow == 0){
                        if(this.questionsToSubmit.indexOf(otherQueIdx) === -1){
                          continue parentLoop
                        }
                      }else{
                        if(this.surveyQuestionDetailsData[otherQueIdx].displayFlag == 0){
                          continue parentLoop
                        }
                      }
                    }

                  }

                  var modelValue = this.previewSurveyData
                    .chkSurveyQuestionDetails[rules.in_question_master_id];
                  if(questionType == this.vueQueTypeConfig.TYPE_12_HOURS || questionType == this.vueQueTypeConfig.TYPE_24_HOURS)
                  {
                    var modelValue = this.tempTimePickerValue[rules.in_question_master_id];
                  }
                  let masterIdIndex = this.surveyQuestionDetailsData.findIndex(x => x.in_question_master_id == rules.in_question_master_id);
                  console.log('masterIdIndex', masterIdIndex, modelValue)
                  let oldSkipData = JSON.parse(JSON.stringify(this.newQuestionList))

                  let requiredQues = oldSkipData[masterIdIndex];
                  requiredQues["userAnswer"] = (modelValue !== null && typeof modelValue == 'object') ? ( modelValue.value ? modelValue.value : ( modelValue.formatted_address ? modelValue.formatted_address : modelValue) ) : (modelValue ? modelValue : '')

                  oldSkipData.map(v=>{
                    v.showQues = false,
                    v.isSkipped = false
                    // return v
                  })

                  this.newQuestionList = QuesSkipModal.getData(oldSkipData)

                }

              }

            // } else {
            //   console.log("in not check");
            //   console.log('this.quesNo',this.quesNo);
            //   // this.quesNo++;
            // }
          }


          // Only for All in one question survey type
          if (isAllQuesAtTime) {

            this.surveyQuestionDetailsData.map( (skipVal, skipKey) => {
              this.setDisplayVariable(skipKey, this.newQuestionList[skipKey].showQues)
            })

          }else{
            this.setNextQuestion(currentQuesNo, false) // false => need to check only if skip logic is depend upon previous question
          }
          console.log('currentQuesNo + 1 after',currentQuesNo + 1);
          console.log('this.quesNo after',this.quesNo);
          // END

          this.updateRequiredQues()
        }, 100);
      }

      if(this.surveyQuestionDetails[currentQuesNo].skipLogicOf.length > 0 && isAllQuesAtTime){
          this.surveyQuestionDetails[currentQuesNo].skipLogicOf.forEach((val)=> {
            this.skipLogicRuleDetails(this.surveyQuestionDetails[val].skipLogic, val)
          })
      }

    },
    setNextQuestion(currentQuesNo, flag = false){
      // console.log('skipLogicOf =>' , this.surveyQuestionDetails[currentQuesNo].skipLogicOf);
      // this condition is used when then question is equal to current question
      if(flag && this.surveyQuestionDetails[currentQuesNo].skipLogicOf.length > 0){
        // alert(123);
        this.surveyQuestionDetails[currentQuesNo].skipLogicOf.forEach((val)=> {
          // console.log(123456789);
          this.skipLogicRuleDetails(this.surveyQuestionDetails[val].skipLogic, val)
        })

        setTimeout(() => {
          // console.log(456);
          for(let k = 0; k < this.newQuestionList.length; k++){
            let v = this.newQuestionList[k]
            console.log('k ',k , 'currentQuesNo ', currentQuesNo, v)
            if(k > currentQuesNo && v.showQues == true){
              console.log('in if k ',k , 'currentQuesNo ', currentQuesNo, v)
              this.quesNo = k
              break
            }
          }
        }, 400);
      } else {
        // alert(456)
        for(let k = 0; k < this.newQuestionList.length; k++){
          let v = this.newQuestionList[k]
          console.log('k ',k , 'currentQuesNo ', currentQuesNo, v)
          if(k > currentQuesNo && v.showQues == true){
            console.log('in if k ',k , 'currentQuesNo ', currentQuesNo, v)
            this.quesNo = k
            break
          }
        }
      }
    },
    setDisplayVariable(key, val){
      if(val == 1){
        // if(this.surveyQuestionDetailsData[key].skipLogic.length){
          // console.log('this.loaded', this.loaded,key)
          let qIndx = this.loaded.indexOf(key)
          this.loaded.splice(qIndx,1)
        // }

      }
      this.$set(
            this.surveyQuestionDetailsData[key],
            "displayFlag",
            val
          );
      this.$set(
        this.surveyQuestionDetailsData,
        key,
        Object.assign({}, this.surveyQuestionDetailsData[key])
      );

    },
    setVariable(name, key, val){
      this.$set(
            this.surveyQuestionDetailsData[key],
            name,
            val
          );
      this.$set(
        this.surveyQuestionDetailsData,
        key,
        Object.assign({}, this.surveyQuestionDetailsData[key])
      );

    },
    callSkipRuleCheckBfr() {
      console.log("if satisfied in new fn");
      console.log(this.quesNo);
      console.log(this.surveyQuestionDetailsData[this.quesNo].skipLogic);
      this.surveyQuestionDetailsData[this.quesNo].skipLogic.forEach(
        (value, key) => {
          console.log(value);
          console.log(
            value.conditions.rules[0].details[0]["in_question_master_id"]
          );
          if (
            this.quesNo + 1 == value.thenQuesNo ||
            this.quesNo + 1 == value.elseQuesNo
          ) {
            console.log("in iff check");

            this.skipLogicRuleDetails(
              this.surveyQuestionDetailsData[this.quesNo].skipLogic,
              this.quesNo,
              false,
              true
            );
          }
        }
      );
    },
    nextQues() {
        this.$validator.validateAll().then(result => {
          if (result) {
            let oldQues = this.quesNo
            if (this.quesNo != this.surveyQuestionDetailsData.length - 1) {
              //submitonly that questions which are passed skip logic
              if(this.questionsToSubmit.indexOf(this.quesNo) === -1){
                this.questionsToSubmit.push(this.quesNo)
              }
              this.questionsToSubmit = this.questionsToSubmit.filter( (val, key) => {
                return ! (val > this.quesNo)
              })
              console.log('this.questionsToSubmit', this.questionsToSubmit)
              // Skip logic START
              var skiplogic = this.surveyQuestionDetailsData[this.quesNo]
                .skipLogic;
              var timeoutTime = (this.surveyQuestionDetails[this.quesNo].skipLogicOf.length > 0) ? 500 : 100;

              this.backwardQuesNo.push(this.quesNo);
              // console.log(skiplogic[0]["conditions"]);
              // console.log(this.quesNo);
              if (skiplogic.length > 0) {
                console.log("in skiplogic");
                this.skipLogicRuleDetails(skiplogic, this.quesNo, false);
              } else {
                // console.log("number incremented");
                // this.quesNo++;
                this.setNextQuestion(this.quesNo, true)
                this.updateRequiredQues()
              }

              setTimeout(() => {
                // check if end survey is called in skip logic
                if(oldQues == this.quesNo){
                  this.validateBeforeSubmit()
                  return
                }
                console.log(this.quesNo);
                console.log(this.surveyQuestionDetailsData[this.quesNo]);
                if (
                  this.surveyQuestionDetailsData[this.quesNo].skipLogic.length > 0
                ) {
                  // this.callSkipRuleCheckBfr();
                }
                console.log('this.quesNo in nextques', this.quesNo)
              }, timeoutTime);
              // Skip logic END
              // For signature question type - to store sigature data in pad
              if (
                this.surveyQuestionDetailsData[this.quesNo] && this.surveyQuestionDetailsData[this.quesNo].queDetails &&
                this.surveyQuestionDetailsData[this.quesNo].queDetails
                  .in_question_type_id == this.vueQueTypeConfig.TYPE_SIGNATURE
              ) {
                const _id = this.surveyQuestionDetailsData[this.quesNo].queDetails
                  .in_question_master_id;
                const value = this.previewSurveyData.chkSurveyQuestionDetails[
                  _id
                ];
                console.log(_id);
                console.log(this.$refs["signaturePad_" + _id]);
                setTimeout(() => {
                  this.$refs["signaturePad_" + _id][0].clearSignature();
                  this.$refs["signaturePad_" + _id][0].fromDataURL(value);
                }, 100);
              } else if (
                // For text and list question type
                this.surveyQuestionDetailsData[this.quesNo] && this.surveyQuestionDetailsData[this.quesNo].queDetails &&
                (this.surveyQuestionDetailsData[this.quesNo].queDetails
                  .in_question_type_id == this.vueQueTypeConfig.TYPE_INPUT ||
                  this.surveyQuestionDetailsData[this.quesNo].queDetails
                    .in_question_type_id ==
                    this.vueQueTypeConfig.TYPE_MULTIPLE_TEXT ||
                  this.surveyQuestionDetailsData[this.quesNo].queDetails
                    .in_question_type_id == this.vueQueTypeConfig.TYPE_LIST ||
                  this.surveyQuestionDetailsData[this.quesNo].queDetails
                    .in_question_type_id == this.vueQueTypeConfig.TYPE_DYNAMIC_LIST) &&
                this.surveyQuestionDetailsData[this.quesNo].queDetails
                  .validationDetailsObj[49]
              ) {
                const _id = this.surveyQuestionDetailsData[this.quesNo].queDetails
                  .in_question_master_id;
                console.log(
                  this.surveyQuestionDetailsData[this.quesNo].queDetails
                    .in_question_type_id
                );
                console.log(this.previewSurveyData);
                const value =
                  this.surveyQuestionDetailsData[this.quesNo].queDetails
                    .in_question_type_id ==
                    this.vueQueTypeConfig.TYPE_MULTIPLE_TEXT ||
                  this.surveyQuestionDetailsData[this.quesNo].queDetails
                    .in_question_type_id == this.vueQueTypeConfig.TYPE_LIST ||
                  this.surveyQuestionDetailsData[this.quesNo].queDetails
                    .in_question_type_id == this.vueQueTypeConfig.TYPE_DYNAMIC_LIST
                    ? this.previewSurveyData["chkOtherMulChoice"][_id]
                    : this.previewSurveyData.chkSurveyQuestionDetails[_id];
                console.log(value);
                setTimeout(() => {
                  if (this.$refs["map_" + _id] && this.$refs["map_" + _id][0])
                    this.$refs["map_" + _id][0].update(
                      value ? value.formatted_address : ""
                    );
                }, 100);
              }
            }
            return;
            // this.$awn.success('Form is submitted!');
            // this.$emit("changeToEndScreen");
          }
          // this.$awn.alert("Question validation details are missing.");
        });
    },
    prevQues() {
      console.log(this.$refs);
      // this.$validator.validate('*');
      if (this.quesNo != 0) {
        this.quesNo = this.backwardQuesNo.pop(); //this.quesNo--;
      }
      if (
        this.surveyQuestionDetailsData[this.quesNo].queDetails
          .in_question_type_id == this.vueQueTypeConfig.TYPE_SIGNATURE
      ) {
        const _id = this.surveyQuestionDetailsData[this.quesNo].queDetails
          .in_question_master_id;
        const value = this.previewSurveyData.chkSurveyQuestionDetails[_id];
        console.log(_id);
        console.log(this.$refs["signaturePad_" + _id]);
        setTimeout(() => {
          this.$refs["signaturePad_" + _id][0].clearSignature();
          this.$refs["signaturePad_" + _id][0].fromDataURL(value);
        }, 100);
      } else if (
        (this.surveyQuestionDetailsData[this.quesNo].queDetails
          .in_question_type_id == this.vueQueTypeConfig.TYPE_INPUT ||
          this.surveyQuestionDetailsData[this.quesNo].queDetails
            .in_question_type_id == this.vueQueTypeConfig.TYPE_MULTIPLE_TEXT ||
          this.surveyQuestionDetailsData[this.quesNo].queDetails
            .in_question_type_id == this.vueQueTypeConfig.TYPE_LIST ||
          this.surveyQuestionDetailsData[this.quesNo].queDetails
            .in_question_type_id == this.vueQueTypeConfig.TYPE_DYNAMIC_LIST) &&
        this.surveyQuestionDetailsData[this.quesNo].queDetails
          .validationDetailsObj[49]
      ) {
        const _id = this.surveyQuestionDetailsData[this.quesNo].queDetails
          .in_question_master_id;
        const value =
          this.surveyQuestionDetailsData[this.quesNo].queDetails
            .in_question_type_id == this.vueQueTypeConfig.TYPE_MULTIPLE_TEXT ||
          this.surveyQuestionDetailsData[this.quesNo].queDetails
            .in_question_type_id == this.vueQueTypeConfig.TYPE_LIST ||
          this.surveyQuestionDetailsData[this.quesNo].queDetails
            .in_question_type_id == this.vueQueTypeConfig.TYPE_DYNAMIC_LIST
            ? this.previewSurveyData["chkOtherMulChoice"][_id]
            : this.previewSurveyData.chkSurveyQuestionDetails[_id];
        setTimeout(() => {
          if (this.$refs["map_" + _id] && this.$refs["map_" + _id][0])
            this.$refs["map_" + _id][0].update(value.formatted_address);
        }, 0);
      }
    },
    checkCheckbox(surveyQuesId, evt) {
      setTimeout(() => {
        var totalCheckbox =
          evt.target.type == "checkbox"
            ? this.previewSurveyData.chkSurveyQuestionDetails[surveyQuesId]
                .length
            : [this.previewSurveyData.chkSurveyQuestionDetails[surveyQuesId]]
                .length;
        if (totalCheckbox > 0) {
          this.checkInput(surveyQuesId, evt, true);
        } else {
          this.checkInput(surveyQuesId, evt, false);
        }
      }, 100);
    },
    checkMultipleChoice(
      selectedOption,
      id,
      surveyQuesId,
      index,
      isRequired = false
    ) {
      if (selectedOption.formatted_address == "Other") {
        this.$set(
          this.surveyQuestionDetailsData[index]["queDetails"],
          "other",
          true
        );
        delete this.previewSurveyData["chkMapMulChoice"][surveyQuesId];
      } else {
        this.$set(
          this.surveyQuestionDetailsData[index]["queDetails"],
          "other",
          false
        );
        delete this.previewSurveyData["chkOtherMulChoice"][surveyQuesId];
      }
      selectedOption = [selectedOption];
      let evt = {
        target: {
          value: selectedOption
        }
      };
      if (isRequired && selectedOption.length > 0) {
        this.checkInput(surveyQuesId, evt, true);
      } else {
        this.checkInput(surveyQuesId, evt, false);
      }
    },
    checkDateTimePicker(currentValue, surveyQuesId) {
      let evt = {
        target: {
          value: currentValue != null ? currentValue : ""
        }
      };
      this.checkInput(surveyQuesId, evt, true);
    },
    checkInput(surveyQuesId, evt, flag = true) {
      surveyQuesId = parseInt(surveyQuesId);
      if (evt.target.value != "" && flag) {
        if (this.completedQuesForPerc.indexOf(surveyQuesId) == -1) {
          this.completedQuesForPerc.push(surveyQuesId);
          console.log(this.completedQuesForPerc);
          EventBus.$emit(
            "calculatePercentage",
            this.completedQuesForPerc.length
          );
        }
      } else {
        if (this.completedQuesForPerc.indexOf(surveyQuesId) != -1) {
          this.completedQuesForPerc.splice(
            this.completedQuesForPerc.indexOf(surveyQuesId),
            1
          );
          console.log(this.completedQuesForPerc);
          EventBus.$emit(
            "calculatePercentage",
            this.completedQuesForPerc.length
          );
        }
      }
    },
    async validateEmail(fieldName, evt) {

      var emailVals = this.errors.items.filter(function(item) {
        return item.field == fieldName && item.rule != 'invalid_email';
      });

      if (evt.target.value != "" && emailVals.length <= 0) {
        const field = this.$validator.fields.find({ name: fieldName });
        field.update({ rules: 'invalid_email2' });

        var url = process.env.API_PATH + '/checkAPIEmailValidationWeb';
        await axios
          .post(
            url,
            {
              email: evt.target.value,
              source: 'Add Response',
            },
            {
              headers: { "Content-Type": "application/json" }
            }
          )
          .then(response => {
            field.update({ rules: 'valid_email2' });
            if(response.data.flag == true && response.data.emailIsvalid == false)
            {
              field.update({ rules: 'invalid_email' });
            }
            else
            {
              field.update({ rules: 'valid_email' });
            }
          })
          .catch(error => console.log(error));
      }

    },
    updateRequiredQues(){
      let visibleQues = JSON.parse(JSON.stringify(this.newQuestionList))
      visibleQues = visibleQues.filter(v => v.showQues == true)
      console.log('visibleQues', visibleQues)
      let requiredCount = 0
      let quesIds = []
      visibleQues.map(v => {
        // let idIndex = this.surveyQuestionDetails.findIndex(x => x.in_question_master_id == v.in_question_master_id)
        var idIndex;
        for (var i = 0; i < this.surveyQuestionDetails.length; ++i) {
            if (this.surveyQuestionDetails[i].in_question_master_id == v.in_question_master_id) {
                idIndex = i;
                break;
            }
        }
        if(idIndex != -1){
          quesIds.push(v.in_question_master_id)
          let surQuestDet = this.surveyQuestionDetails[idIndex]["queDetails"]["validationDetailsObj"]
              ? this.surveyQuestionDetails[idIndex]["queDetails"]["validationDetailsObj"]
              : this.surveyQuestionDetails[idIndex]["validationDetailsObj"];
          if(surQuestDet && surQuestDet[1] && surQuestDet[1] == 1){
            requiredCount++
            // if already answered then add in completed list
            if(this.previewSurveyData.chkSurveyQuestionDetails[v.in_question_master_id]){
              if(!this.completedQuesForPerc.includes(v.in_question_master_id)){
                this.completedQuesForPerc.push(v.in_question_master_id)
              }
            }
          }
        }
      })
      console.log('Total Required Ques', requiredCount)
      // update required question count
      EventBus.$emit("updateRequiredQues",requiredCount);
      let diff = []
      if (quesIds.length > 0){
        diff = this.completedQuesForPerc.filter(x => quesIds.includes(x))
      }
      this.completedQuesForPerc = diff
      setTimeout( v =>{
        EventBus.$emit("calculatePercentage",this.completedQuesForPerc.length);
      }, 100 )


    },
    setModelValueForMultipleAns(surveyQuesId, checkbox, evt){
      // console.log('in setmodelvalueformultipleans',this.previewSurveyData.chkSurveyQuestionDetails[surveyQuesId])
      if(checkbox){
        if (evt.target.checked) {
          if (!this.previewSurveyData.chkSurveyQuestionDetails[surveyQuesId])
            this.previewSurveyData.chkSurveyQuestionDetails[surveyQuesId] = [];
          this.previewSurveyData.chkSurveyQuestionDetails[surveyQuesId].push(evt.target.value);
        } else {
          // If unchecked
          this.previewSurveyData.chkSurveyQuestionDetails[surveyQuesId] = this.previewSurveyData
          .chkSurveyQuestionDetails[surveyQuesId].filter(item => {
            return item !== evt.target.value;
          });
        }
      }else{ //radio button
        this.previewSurveyData.chkSurveyQuestionDetails[surveyQuesId] = evt.target.value
      }
    },
    /**
     * When the location found
     * @param {Object} addressData Data of the found location
     * @param {Object} placeResultData PlaceResult object
     * @param {String} id Input container ID
     */
    getAddressData: function(
      isRequired,
      addressData,
      placeResultData,
      _id,
      surveyQuesId,
      surQuesTypeId = 0,
      e
    ) {
      console.log([
        isRequired,
        addressData,
        placeResultData,
        _id,
        surveyQuesId,
        surQuesTypeId
      ]);
      let evt = {};
      if (
        surQuesTypeId == this.vueQueTypeConfig.TYPE_LIST ||
        surQuesTypeId == this.vueQueTypeConfig.TYPE_DYNAMIC_LIST ||
        surQuesTypeId == this.vueQueTypeConfig.TYPE_MULTIPLE_TEXT
      ) {
        this.$set(this.previewSurveyData["chkOtherMulChoice"], surveyQuesId, {
          lat: addressData["latitude"],
          lng: addressData["longitude"],
          formatted_address: placeResultData.formatted_address,
          score: this.$refs[_id][0].$el.dataset.score
            ? this.$refs[_id][0].$el.dataset.score
            : this.previewSurveyData["chkSurveyQuestionDetails"][surveyQuesId]
                .score // 1st for multiple choice text and 2nd for list question type
        });
        evt = {
          target: {
            value: this.previewSurveyData["chkOtherMulChoice"][
              "" + surveyQuesId
            ]
          }
        };
      } else {
        this.$set(
          this.previewSurveyData.chkSurveyQuestionDetails,
          surveyQuesId,
          {
            lat: addressData["latitude"],
            lng: addressData["longitude"],
            formatted_address: placeResultData.formatted_address,
            score: ""
          }
        );
        evt = {
          target: {
            value: this.previewSurveyData.chkSurveyQuestionDetails[
              "" + surveyQuesId
            ]
          }
        };
      }
      if (isRequired) this.checkInput(surveyQuesId, evt, true);
      if (this.errors.has(_id)) {
        this.errors.remove(_id);
      }
    },
    onMapInputChange(inputValue, _id, surveyQuesId, surQuesTypeId = 0) {
      if (inputValue.newVal == "") {
        surQuesTypeId == this.vueQueTypeConfig.TYPE_MULTIPLE_TEXT
          ? this.$set(
              this.previewSurveyData["chkOtherMulChoice"],
              surveyQuesId,
              ""
            )
          : this.$set(
              this.previewSurveyData.chkSurveyQuestionDetails,
              surveyQuesId,
              ""
            );
        let evnt = {
          target: {
            value: ""
          }
        };
        this.checkInput(surveyQuesId, evnt, true);
      }
    },
    onStarAndEmojiClick(surveyQuesId, evt) {
      this.$set(this.previewSurveyData.chkSurveyQuestionDetails, surveyQuesId, {
        score: evt.currentTarget.getAttribute("data-score"),
        value: evt.target.value
      });

      this.uncheck(surveyQuesId, evt.target.value)
    },
    handleError(error) {
      this.$awn.alert(error);
    },
    uncheck(surveyQuesId, value, isMultipleChoice = false, index = 0) {
      if (value === this.tempPreviouslySelected[surveyQuesId]) {
        // For mulitiple choice type questions - Radio button only
        if(isMultipleChoice) {
          // If Other option is selected
          if (value == "Other") {
            this.$set(
              this.surveyQuestionDetailsData[index]["queDetails"],
              "other",
              false
            );
            Vue.delete(this.previewSurveyData.chkOtherMulChoice, surveyQuesId);
          }

          Vue.delete(this.previewSurveyData.chkMapMulChoice, surveyQuesId);
          Vue.delete(this.previewSurveyData.chkSurveyQuestionDetails, surveyQuesId);
        } else {
          Vue.delete(this.previewSurveyData.chkSurveyQuestionDetails, surveyQuesId);
        }

        Vue.delete(this.tempPreviouslySelected, surveyQuesId);
        let evnt = {
          target: {
            value: ""
          }
        };
        this.checkInput(surveyQuesId, evnt, true);
      } else {
        this.tempPreviouslySelected[surveyQuesId] = value;
      }
    },
    setTimePickerValue(quesFlow, surQuesTypeId, surveyQuesId, skipLogic, index) {
      // This dialog is used to fill vuetify dialog if v-model is not blank
      this.$refs["dialog_" + surveyQuesId][0].save(this.previewSurveyData.chkSurveyQuestionDetails[surveyQuesId]);

      // console.log(this.previewSurveyData.chkSurveyQuestionDetails[surveyQuesId])
      // Convert time format from 12 hour into 24 hour becuase vuetify time picker accept only 24 hour format
      var tpValue = '';
      if(surQuesTypeId == this.vueQueTypeConfig.TYPE_12_HOURS) {
        tpValue = this.moment(this.previewSurveyData.chkSurveyQuestionDetails[surveyQuesId], this.timeFormat24).format(this.timeFormat12);
      } else {
        tpValue = this.previewSurveyData.chkSurveyQuestionDetails[surveyQuesId];
      }
      // console.log(tpValue);
      this.$set(this.tempTimePickerValue, surveyQuesId, tpValue);

      // Remove validation error if it is stuck in dom
      if (this.errors.has('timepicker_' + surveyQuesId)) {
        this.errors.remove('timepicker_' + surveyQuesId);
      }

      // 1 = One at a time question and 2 = All in One
      if(quesFlow == 2)
        this.skipLogicRuleDetails(skipLogic, index);
    },
    unsetTimePickerValue(surveyQuesId) {
      this.timePickerObject[surveyQuesId] = false;
    },
    clearTimepickerValue(surveyQuesId, requiredValidation, skipLogic, index) {
      // If required then calucalte completed percentage
      if(requiredValidation) {
        this.checkDateTimePicker(null, surveyQuesId);
      }
      console.log(this.surveyMasterDetails.in_question_flow);
      // Exceute only in All question at a time
      if(this.surveyMasterDetails.in_question_flow == 1) {
        this.skipLogicRuleDetails(skipLogic, index);
      }
      // Set model value as Null
      this.$set(this.previewSurveyData.chkSurveyQuestionDetails, surveyQuesId, null);
    },
      uploadPhoto(questionMasterId,event) {    
      this.initPhotoQuestionState(questionMasterId);
      const state = this.photoQuestionStates[questionMasterId];    
      const file = event.target.files[0];
      let fileName = file.name;
      let fileExtension = fileName.split('.').pop();
    
      let newFile = new File([file], `image_${questionMasterId}.${fileExtension}`, {type: file.type, lastModified: file.lastModified});
      this.imageArray[questionMasterId] = newFile;
      this.$set(this.arrShowAllPhotoQuestion, questionMasterId, true);
      this.$forceUpdate();
      var url = URL.createObjectURL(file);
      this.previewSurveyData.chkSurveyQuestionDetails[questionMasterId] = url;
      // Mark photo as uploaded for validation
      this.checkInput(questionMasterId, {target: {value: url}}, true);
      // Clear validation error if exists
      if (this.errors.has('photo_' + questionMasterId)) {
        this.errors.remove('photo_' + questionMasterId);
      }
    },
    removeOldPhoto(questionMasterId,oldPhotoValue,event)
    {
      this.$set(this.arrShowAllPhotoQuestion, questionMasterId, false);
      this.$forceUpdate();
      var newUplodedPhoto = this.previewSurveyData.chkSurveyQuestionDetails[questionMasterId]
      if(newUplodedPhoto.includes("blob"))
      {
        this.previewSurveyData.chkSurveyQuestionDetails[questionMasterId] = this.arrStoreAllPhotoQuestion[questionMasterId]; //oldimage
      }
      else
      {
        this.previewSurveyData.chkSurveyQuestionDetails[questionMasterId] = newUplodedPhoto; //newimage
      }
      // Reset validation for mandatory photo questions
      let evt = { target: { value: this.previewSurveyData.chkSurveyQuestionDetails[questionMasterId] ? this.previewSurveyData.chkSurveyQuestionDetails[questionMasterId] : "" } };
      this.checkInput(questionMasterId, evt, this.previewSurveyData.chkSurveyQuestionDetails[questionMasterId] ? true : false);
    },
    removeOldPhotoCam(questionMasterId,oldPhotoValue,event)
    {
     
      this.initPhotoQuestionState(questionMasterId);
      const state = this.photoQuestionStates[questionMasterId];
      this.$set(this.arrShowAllPhotoQuestion, questionMasterId, false);
      this.$forceUpdate();
      var newUplodedPhoto = this.previewSurveyData.chkSurveyQuestionDetails[questionMasterId]
      this.previewSurveyData.chkSurveyQuestionDetails[questionMasterId] = newUplodedPhoto; //newimage
      state.isPhotoTaken = false;
      // Reset validation for mandatory photo questions
      let evt = { target: { value: newUplodedPhoto ? newUplodedPhoto : "" } };
      this.checkInput(questionMasterId, evt, newUplodedPhoto ? true : false);
    },
    initPhotoQuestionState(questionMasterId) {
      if (!this.photoQuestionStates[questionMasterId]) {
        this.$set(this.photoQuestionStates, questionMasterId, {
          isCameraOpen: false,
          isPhotoTaken: false,
          isShotPhoto: false,
          isLoading: false,
          isRetakePhoto: false,
          isViewPhoto: false
        });
      }
    },
    toggleCamera(id) {
      this.initPhotoQuestionState(id);
      const state = this.photoQuestionStates[id];
      state.isCameraOpen = true;
      this.createCameraElement(id);
      this.$bvModal.hide("photoModal_" + id);
    },

    retakePhoto(id) {
      this.removeOldPhotoCam(id);
      this.initPhotoQuestionState(id);
      const state = this.photoQuestionStates[id];
      state.isRetakePhoto = true;
      state.isViewPhoto = false;
      this.$bvModal.hide("photoModal_" + id);
    },
    
    closeViewPhoto(id) {
      this.initPhotoQuestionState(id);
      const state = this.photoQuestionStates[id];
      state.isViewPhoto = false;
    },
    
    createCameraElement(id) {
      this.initPhotoQuestionState(id);
      const state = this.photoQuestionStates[id];
      state.isLoading = true;
        if (navigator && navigator.mediaDevices) {
          this.$bvModal.show("cameraModal_" + id);
          navigator.mediaDevices
          .getUserMedia({ video: true })
          .then(stream => {
            state.isLoading = false;
            this.$nextTick(() => {
              document.getElementById(`webcam_${id}`).srcObject = stream;
            });
          })
          .catch(error => {
            state.isLoading = false;
            state.isCameraOpen = false;
            this.$bvModal.hide("cameraModal_" + id);
            if (error.name === "NotFoundError") {
              this.$awn.alert("Error accessing camera: Camera not found. Please check if you have a camera attached and try again.");
            } else if (error.name === "NotAllowedError") {
              this.$awn.alert("Error accessing camera: Access to the camera is blocked. Please check your browser settings and try again.");
            } else if (error.name === "NotReadableError") {
              this.$awn.alert("Error accessing camera: The camera is currently in use. Please close any other apps that may be using the camera and try again.");
            } else if (error.name === "OverconstrainedError") {
              this.$awn.alert("Error accessing camera: The selected camera is not supported. Please select a different camera and try again.");
            } else {
              this.$awn.alert("Error accessing camera: " + error.message);
            }
          });
        }else{
          state.isLoading = false;
          state.isCameraOpen = false;
          this.$bvModal.hide("cameraModal_" + id);
          this.$awn.alert("Error accessing camera");
        }
    },
    
    stopCameraStream(id) {
      let tracks = document.getElementById(`webcam_${id}`).srcObject.getTracks();
      tracks.forEach(track => {
				track.stop();
			});

      document.getElementById(`webcam_${id}`).srcObject = null;
    },    
    takePhoto(id) {
      this.initPhotoQuestionState(id);
      const state = this.photoQuestionStates[id];

      if (!state.isPhotoTaken) {
        state.isShotPhoto = true;
        setTimeout(() => { state.isShotPhoto = false; }, 50);
      }
      
      state.isPhotoTaken = true;
      const canvas = document.getElementById(`photoTaken_${id}`);
      const context = canvas.getContext("2d");
      const webcamElement = document.getElementById(`webcam_${id}`);
      
      context.drawImage(webcamElement, 0, 0, 700, 525);

      canvas.toBlob(blob => {
        const file = new File([blob], `image_${id}.jpeg`, { type: blob.type, lastModified: Date.now() });
        this.uploadPhoto(id, { target: { files: [file] } });
      }, "image/jpeg");
      this.stopCameraStream(id);
      this.$bvModal.hide("cameraModal_" + id);
      state.isCameraOpen = false;
      state.isViewPhoto = true;
    },
    editAttachedPhoto(id, event) {
      this.initPhotoQuestionState(id);
      const state = this.photoQuestionStates[id];
      if(this.removeOldPhotoCam(id)){
        state.isCameraOpen = true;
        state.isPhotoTaken = false;
        this.$bvModal.show("cameraModal_" + id);
        document.getElementById(`editCameraModal_${id}`).click();
      }
    },
    async toggleCameraMenuModel(id, evt) {
      if(evt == 'cancel')
      {
        this.$bvModal.hide("photoModal_" + id);
      }else{
        this.$bvModal.show("photoModal_" + id);
      }
    },
    triggerFileInput(id) {
      document.getElementById(`fileInput_${id}`).click();
    },
    viewPhotoModal(id) {
      this.initPhotoQuestionState(id);
      const state = this.photoQuestionStates[id];
      state.isViewPhoto = true;
      const checkIsViewPhoto = setInterval(() => {
        if (state.isViewPhoto) {
          clearInterval(checkIsViewPhoto);
          this.$bvModal.show("viewPhotoModal_" + id);
        }
      }, 100);
    }
  }
};
</script>
<style lang="scss">
@import "vue-multiselect/dist/vue-multiselect.min.css";
</style>
<!-- {
  "latitude":21.1877888,
  "longitude":72.7744512,
  "dateCollected":1550056664010,
  "dateStarted":1550053821925,
  "datePublished":1532093457000,
  "elementResponses":[
    {
      "id":1,
      "position":2,
      "subType":2,
      "value":"Doyenhub"
    },
    {
      "id":3,
      "position":3,
      "subType":2,
      "value":"Parimal"
    },
    {
      "id":4,
      "position":4,
      "subType":2,
      "value":"Web Developer"
    },
    {
      "id":5,
      "position":5,
      "subType":40,
      "value":"8460341499"
    },
    {
      "id":6,
      "position":6,
      "subType":11,
      "value":"2019-02-13"
    }
  ],
  "surveyResponseMetaData":[
  ]
} -->



// WEBPACK FOOTER //
// src/components/Preview/Content.vue